import React, { SVGProps } from "react";
import { Icon } from "@chakra-ui/react";

export const QRCodeIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    {...props}
    xmlns="http://www.w3.org/2000/svg"
    width={20}
    height={20}
    fill="none"
  >
    <path
      fill="#EE5A29"
      d="M10.887 19.61v-2.136h2.136v2.136h-2.136ZM8.75 17.474v-5.341h2.137v5.341H8.75Zm8.546-3.205V9.997h2.136v4.272h-2.136Zm-2.137-4.272V7.86h2.137v2.137h-2.137ZM2.341 12.133V9.997h2.136v2.136H2.341ZM.205 9.997V7.86H2.34v2.137H.205Zm9.613-7.478V.383h2.137v2.136H9.818ZM1.807 5.19H5.01V1.986H1.807V5.19Zm-1.602.535V1.45c0-.303.102-.556.307-.761.204-.205.458-.307.76-.307h4.274c.302 0 .556.102.76.307.205.205.308.458.308.761v4.273c0 .302-.103.556-.307.76a1.034 1.034 0 0 1-.761.308H1.273c-.303 0-.557-.102-.761-.307a1.034 1.034 0 0 1-.307-.761Zm1.602 12.284H5.01v-3.204H1.807v3.204Zm-1.602.534V14.27c0-.302.102-.556.307-.76.204-.206.458-.308.76-.308h4.274c.302 0 .556.102.76.307.205.205.308.459.308.761v4.273c0 .303-.103.556-.307.761a1.033 1.033 0 0 1-.761.307H1.273c-.303 0-.557-.102-.761-.307a1.033 1.033 0 0 1-.307-.76ZM14.625 5.19h3.205V1.985h-3.205V5.19Zm-1.602.534V1.45c0-.303.102-.556.307-.761.205-.205.459-.307.761-.307h4.273c.303 0 .556.102.761.307.205.205.307.458.307.761v4.273c0 .302-.102.556-.307.76a1.033 1.033 0 0 1-.761.308H14.09c-.302 0-.556-.102-.76-.307a1.033 1.033 0 0 1-.308-.761Zm2.136 13.886v-3.204h-2.136v-2.137h4.273v3.205h2.136v2.136H15.16Zm-4.272-7.477V9.997h4.272v2.136h-4.272Zm-4.273 0V9.997H4.477V7.86h6.41v2.137H8.75v2.136H6.614Zm1.068-5.341V2.519h2.136v2.137h2.137v2.136H7.682ZM2.608 4.389V2.786H4.21V4.39H2.608Zm0 12.818v-1.602H4.21v1.602H2.608ZM15.426 4.389V2.786h1.603V4.39h-1.603Z"
    />
  </svg>
);

export const LinkIllustration = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={64}
    height={64}
    fill="none"
    {...props}
  >
    <g clipPath="url(#a)">
      <path
        fill="#F3A286"
        d="M59.606 4.394c5.858 5.857 5.858 15.354 0 21.213l-12.36 12.361a14.936 14.936 0 0 1-5.705 3.573 15.068 15.068 0 0 1-9.804 0 14.934 14.934 0 0 1-5.705-3.573 14.95 14.95 0 0 1-3.573-5.705l.263-.263c-.263.263 4.636-4.731 4.636-4.731L32 31.999a6.567 6.567 0 0 0 9.278 0l.263-.262L53.64 19.639a6.57 6.57 0 0 0 0-9.278 6.57 6.57 0 0 0-9.278 0L32.263 22.459l-4.902 1.994-4.902-1.994a14.944 14.944 0 0 1 3.573-5.705l12.361-12.36c5.858-5.859 15.356-5.859 21.213 0Z"
      />
      <path
        fill="#EE5A29"
        d="M32.263 22.46c2.083.719 4.04 1.91 5.704 3.574a14.932 14.932 0 0 1 3.574 5.704l-.263.263a6.567 6.567 0 0 1-9.278 0 6.57 6.57 0 0 0-9.278 0l-.263.263-12.098 12.098a6.567 6.567 0 0 0 0 9.278 6.567 6.567 0 0 0 9.278 0l12.098-12.098a15.068 15.068 0 0 0 9.804 0 14.936 14.936 0 0 1-3.574 5.705l-12.36 12.361c-5.858 5.858-15.356 5.858-21.214 0-5.857-5.858-5.857-15.355 0-21.214l12.361-12.36a14.937 14.937 0 0 1 5.705-3.574 15.071 15.071 0 0 1 9.804 0Z"
      />
    </g>
    <defs>
      <clipPath id="a">
        <path fill="#fff" d="M0 0h64v64H0z" />
      </clipPath>
    </defs>
  </svg>
);

export const PlusRoundCircle = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    {...props}
  >
    <g fill={props.color || "#D1D1D1"} clipPath="url(#a)">
      <path d="M8 0C3.589 0 0 3.589 0 8c0 4.412 3.589 8 8 8 4.412 0 8-3.59 8-8s-3.588-8-8-8Zm0 14.76A6.769 6.769 0 0 1 1.24 8 6.769 6.769 0 0 1 8 1.24 6.769 6.769 0 0 1 14.76 8 6.768 6.768 0 0 1 8 14.76Z" />
      <path d="M11.098 7.325H8.62V4.846a.62.62 0 1 0-1.24 0v2.479H4.902a.62.62 0 1 0 0 1.24H7.38v2.478a.62.62 0 1 0 1.24 0V8.564h2.478a.62.62 0 1 0 0-1.24Z" />
    </g>
    <defs>
      <clipPath id="a">
        <path fill="#fff" d="M0 0h16v16H0z" />
      </clipPath>
    </defs>
  </svg>
);

export const GrayTarget = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={121}
    height={120}
    fill="none"
    {...props}
  >
    <path
      fill="#B3B3B3"
      d="M69.472 27.336a33.943 33.943 0 0 0-8.972-1.2c-18.673 0-33.865 15.19-33.865 33.864S41.827 93.865 60.5 93.865c18.673 0 33.865-15.191 33.865-33.865 0-3.046-.404-6.064-1.2-8.971a3.75 3.75 0 0 1 7.232-1.983A41.443 41.443 0 0 1 101.865 60c0 22.809-18.556 41.365-41.365 41.365S19.135 82.809 19.135 60 37.69 18.635 60.5 18.635c3.716 0 7.4.494 10.954 1.468a3.752 3.752 0 0 1 2.626 4.608 3.75 3.75 0 0 1-4.608 2.625Zm43.907 13.08a3.75 3.75 0 0 0-2.531 4.66A52.54 52.54 0 0 1 113 60c0 28.949-23.551 52.5-52.5 52.5S8 88.949 8 60C8 31.052 31.551 7.5 60.5 7.5c5.08 0 10.1.724 14.923 2.152a3.75 3.75 0 1 0 2.13-7.192A60.03 60.03 0 0 0 60.5 0C44.473 0 29.406 6.241 18.073 17.574 6.741 28.906.5 43.974.5 60c0 16.027 6.241 31.094 17.573 42.427C29.406 113.759 44.473 120 60.5 120s31.094-6.241 42.427-17.573C114.259 91.094 120.5 76.027 120.5 60c0-5.8-.828-11.538-2.46-17.053a3.751 3.751 0 0 0-4.661-2.531ZM60.5 45c.551 0 1.108.03 1.655.09a3.75 3.75 0 1 0 .818-7.455A22.7 22.7 0 0 0 60.5 37.5C48.093 37.5 38 47.593 38 60s10.093 22.5 22.5 22.5S83 72.407 83 60a3.75 3.75 0 1 0-7.5 0c0 8.271-6.729 15-15 15s-15-6.729-15-15 6.729-15 15-15Zm19.147-9.45 1.868-18.737a3.749 3.749 0 0 1 1.08-2.28L96.03 1.098a3.75 3.75 0 0 1 6.39 2.358l1.065 13.56 13.559 1.064a3.749 3.749 0 0 1 2.358 6.39l-13.435 13.435a3.749 3.749 0 0 1-2.28 1.08L84.95 40.854 63.152 62.652A3.739 3.739 0 0 1 60.5 63.75a3.75 3.75 0 0 1-2.651-6.402L79.647 35.55Zm7.785-2.481 14.178-1.414 6.735-6.735-8.64-.679a3.75 3.75 0 0 1-3.446-3.444l-.678-8.642-6.736 6.735-1.413 14.179Z"
    />
  </svg>
);
export const SendIcon = (props) => {
  const { className, ...restProps } = props;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      fill="currentColor"
      stroke="currentColor"
      strokeWidth={0}
      viewBox="0 0 512 512"
      preserveAspectRatio="xMidYMid meet"
      style={{
        display: "block",
        margin: "0",
        padding: "0",
        ...props.style
      }}
      {...restProps}
    >
      <path stroke="none" d="m48 448 416-192L48 64v149.333L346 256 48 298.667z" />
    </svg>
  );
};

export const Corporation = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={76}
    height={75}
    fill="none"
    {...props}
  >
    <circle cx={38} cy={37.5} r={37} fill="#fff" stroke="#EF6B2D" />
    <path
      fill="#000"
      d="M25.125 45.25a.688.688 0 0 0-.688.688v9.624c0 .38.308.688.688.688h4.813v.688c0 .379.308.687.687.687h13.75c.38 0 .688-.308.688-.688v-.687h4.812c.38 0 .688-.308.688-.688v-9.624a.688.688 0 0 0-.688-.688h-4.813v-8.938a.688.688 0 0 0-.687-.687H43v-2.063c0-.758-.617-1.374-1.375-1.374h-3.438v-2.063h-1.374v2.063h-3.438c-.758 0-1.375.616-1.375 1.374v2.063h-1.375a.688.688 0 0 0-.688.688v8.937h-4.812Zm24.063 1.375v8.25h-4.126v-8.25h4.126ZM38.874 56.25h-2.75v-2.063h2.75v2.063Zm-5.5-22.688h8.25v2.063h-8.25v-2.063ZM31.312 37h12.375v19.25H40.25V53.5a.688.688 0 0 0-.688-.688h-4.124a.688.688 0 0 0-.688.688v2.75h-3.438V37Zm-5.5 17.875v-8.25h4.125v8.25h-4.125Z"
    />
    <path
      fill="#000"
      d="M33.375 42.5h8.25v1.375h-8.25V42.5ZM33.375 39.063h8.25v1.374h-8.25v-1.374ZM33.375 45.938h8.25v1.374h-8.25v-1.374ZM33.375 49.375h8.25v1.375h-8.25v-1.375ZM46.438 48h1.374v1.375h-1.374V48ZM46.438 50.75h1.374v1.375h-1.374V50.75ZM27.188 48h1.375v1.375h-1.375V48ZM27.188 50.75h1.375v1.375h-1.375V50.75ZM37.5 28.75a6.195 6.195 0 0 0 6.188-6.188 6.195 6.195 0 0 0-6.188-6.187 6.195 6.195 0 0 0-6.188 6.188A6.195 6.195 0 0 0 37.5 28.75Zm-2.733-2.23a2.058 2.058 0 0 1 2.045-1.895h1.376c1.079 0 1.957.837 2.045 1.894a4.783 4.783 0 0 1-2.733.856 4.783 4.783 0 0 1-2.733-.856Zm2.733-3.27a1.376 1.376 0 0 1-1.375-1.375c0-.758.617-1.375 1.375-1.375s1.375.617 1.375 1.375-.617 1.375-1.375 1.375Zm0-5.5a4.818 4.818 0 0 1 4.813 4.813 4.78 4.78 0 0 1-.941 2.845 3.448 3.448 0 0 0-1.734-1.825c.377-.471.612-1.06.612-1.708a2.753 2.753 0 0 0-2.75-2.75 2.753 2.753 0 0 0-2.75 2.75c0 .648.235 1.237.612 1.708a3.448 3.448 0 0 0-1.734 1.825 4.78 4.78 0 0 1-.94-2.846A4.818 4.818 0 0 1 37.5 17.75ZM51.938 21.875a6.195 6.195 0 0 0-6.188 6.188 6.195 6.195 0 0 0 6.188 6.187 6.195 6.195 0 0 0 6.187-6.188 6.195 6.195 0 0 0-6.188-6.187Zm-2.733 10.144a2.058 2.058 0 0 1 2.045-1.894h1.375c1.08 0 1.958.837 2.045 1.894a4.783 4.783 0 0 1-2.733.856 4.783 4.783 0 0 1-2.732-.856Zm2.733-3.269a1.376 1.376 0 0 1-1.376-1.375 1.376 1.376 0 0 1 2.75 0c0 .758-.616 1.375-1.375 1.375Zm3.871 2.158a3.448 3.448 0 0 0-1.733-1.825c.376-.471.611-1.06.611-1.708a2.753 2.753 0 0 0-2.75-2.75 2.753 2.753 0 0 0-2.75 2.75c0 .648.236 1.237.612 1.708a3.448 3.448 0 0 0-1.733 1.825 4.78 4.78 0 0 1-.941-2.846 4.818 4.818 0 0 1 4.813-4.812 4.818 4.818 0 0 1 4.812 4.813 4.78 4.78 0 0 1-.94 2.845ZM23.063 34.25a6.195 6.195 0 0 0 6.187-6.188 6.195 6.195 0 0 0-6.188-6.187 6.195 6.195 0 0 0-6.187 6.188 6.195 6.195 0 0 0 6.188 6.187Zm-2.733-2.23a2.058 2.058 0 0 1 2.045-1.895h1.375c1.08 0 1.958.837 2.045 1.894a4.783 4.783 0 0 1-2.733.856 4.783 4.783 0 0 1-2.732-.856Zm2.733-3.27a1.376 1.376 0 0 1-1.375-1.375c0-.758.616-1.375 1.375-1.375.758 0 1.375.617 1.375 1.375s-.617 1.375-1.375 1.375Zm0-5.5a4.818 4.818 0 0 1 4.812 4.813 4.78 4.78 0 0 1-.94 2.845 3.448 3.448 0 0 0-1.734-1.825c.376-.471.611-1.06.611-1.708a2.753 2.753 0 0 0-2.75-2.75 2.753 2.753 0 0 0-2.75 2.75c0 .648.236 1.237.612 1.708a3.448 3.448 0 0 0-1.733 1.825 4.78 4.78 0 0 1-.941-2.846 4.818 4.818 0 0 1 4.813-4.812ZM18.938 55.533v2.092h1.375v-2.092c.923-.101 2.062-.566 2.062-2.72 0-1.92-.945-5.5-2.75-5.5-1.805 0-2.75 3.58-2.75 5.5 0 2.154 1.14 2.619 2.063 2.72Zm.686-6.846c.432.057 1.376 2.16 1.376 4.126 0 1.322-.397 1.374-1.375 1.374s-1.375-.052-1.375-1.374c0-1.966.944-4.07 1.374-4.126ZM55.375 47.313c-1.805 0-2.75 3.58-2.75 5.5 0 2.154 1.14 2.619 2.063 2.72v2.092h1.374v-2.092c.924-.101 2.063-.566 2.063-2.72 0-1.92-.945-5.5-2.75-5.5Zm0 6.874c-.978 0-1.375-.052-1.375-1.374 0-1.966.944-4.07 1.374-4.126.432.057 1.376 2.16 1.376 4.126 0 1.322-.397 1.374-1.375 1.374Z"
    />
  </svg>
);

export const Foundations = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={76}
    height={75}
    fill="none"
    {...props}
  >
    <circle cx={38} cy={37.5} r={37} fill="#fff" stroke="#EF6B2D" />
    <g
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      strokeWidth={1.289}
      clipPath="url(#a)"
    >
      <path d="M42.709 52.451v-5.209a5.209 5.209 0 0 0-10.418 0v5.21M48.785 48.98V34.57M20.659 37.353V34.57M20.659 48.98v-8.615M54.341 46.196v2.785M54.341 34.57v8.615M55.47 31.098v3.472h-7.813v-3.472M47.657 52.451V48.98h7.813v3.472M26.215 48.98V34.57M19.53 31.098v3.472h7.813v-3.472M27.343 52.451V48.98H19.53v3.472" />
      <path d="M17.534 55.402v-2.951h39.933v2.951M58.855 58.355h-42.71v-2.951h42.71v2.951ZM31.64 26.343a5.52 5.52 0 0 1-1.593-4.54l-9.736 4.105v2.41h13.303l-1.975-1.975ZM44.953 21.802a5.52 5.52 0 0 1-1.593 4.541l-1.974 1.975h13.302v-2.41l-9.735-4.106ZM41.396 20.45a2.777 2.777 0 0 0-3.896-.03 2.777 2.777 0 0 0-3.896 3.96l3.896 3.895 3.896-3.896a2.778 2.778 0 0 0 0-3.928Z" />
      <path d="M35.984 31.098h-18.45v-7.032l19.966-8.42 19.967 8.42v7.032h-18.45M37.5 42.034V52.45M42.709 38.477H32.29v-2.952H42.71v2.952Z" />
    </g>
    <defs>
      <clipPath id="a">
        <path fill="#fff" d="M15.5 15h44v44h-44z" />
      </clipPath>
    </defs>
  </svg>
);

export const NonProfit = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={76}
    height={75}
    fill="none"
    {...props}
  >
    <circle cx={38} cy={37.5} r={37} fill="#fff" stroke="#EF6B2D" />
    <path
      fill="#000"
      d="M19.797 39.664a.86.86 0 1 1 0 1.72.86.86 0 0 1 0-1.72Z"
    />
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      strokeWidth={1.719}
      d="M23.234 50.841a1.718 1.718 0 0 1-1.718 1.714h-5.157v-15.47h5.157c.95 0 1.718.77 1.718 1.72V50.84Z"
    />
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      strokeWidth={1.719}
      d="m44.724 47.085 10.56-3.63c1.127-.407 2.461-.023 3.03 1.03.773 1.43.096 3.005-1.216 3.53l-16.057 7.07a10.098 10.098 0 0 1-9.377-.532l-4.495-2.697c-1.037-.622-2.729-.971-3.935-1.015"
    />
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      strokeWidth={1.719}
      d="M23.234 38.805h6.804c.886 0 1.757.227 2.528.662l4.541 2.554c.258.146.548.221.843.221h5.566a2.578 2.578 0 1 1 0 5.156h-8.737M30.105 22.133c.697-2.376 2.676-4.135 5.307-4.135 4.239 0 5.577 4.834 5.577 4.834s1.34-4.834 5.579-4.834c3.301 0 5.577 2.771 5.577 6.054 0 4.345-4.096 7.253-11.053 13.282-4.19-3.632-7.59-6.17-9.518-8.697"
    />
    <path
      fill="#000"
      d="M30.023 24.71a.86.86 0 1 1 0 1.72.86.86 0 0 1 0-1.72Z"
    />
  </svg>
);

export const Grassroots = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={76}
    height={75}
    fill="none"
    {...props}
  >
    <circle cx={38} cy={37.5} r={37} fill="#fff" stroke="#EF6B2D" />
    <path
      fill="#000"
      d="M58.64 53.788h-6.468c.02-.56.126-1.45.508-2.638.68-2.111 2.37-5.525 6.573-9.795a.86.86 0 0 0-.745-1.452c-.122.02-3.008.488-6.072 2.396-2.028 1.264-4.403 3.35-5.846 6.65.09-.323.192-.659.307-1.008 1.272-3.861 4.386-10.088 12.004-17.829a.86.86 0 0 0-.745-1.452 27.979 27.979 0 0 0-14.147 6.637 27.765 27.765 0 0 0-2.19 2.147c-.443-5.477-.925-9.804-1.433-12.88-.296-1.792-.606-3.175-.92-4.11-.198-.587-.66-1.96-1.749-1.96-1.009 0-1.492 1.123-1.832 2.22-.337 1.089-.668 2.699-.985 4.786-.544 3.595-1.054 8.62-1.517 14.962-1.774-2.292-3.999-4.28-6.629-5.919-5.011-3.121-9.712-3.884-9.91-3.915a.86.86 0 0 0-.745 1.452c4.904 4.982 7.78 9.282 9.465 12.631a15.811 15.811 0 0 0-3-2.412c-3.064-1.908-5.95-2.377-6.071-2.396a.86.86 0 0 0-.746 1.452c4.123 4.189 5.82 7.549 6.52 9.63.422 1.26.538 2.212.559 2.803H18.9a.86.86 0 0 0 0 1.719h39.74a.86.86 0 0 0 0-1.72Zm-22.178-27.09c.518-3.69.971-5.323 1.255-6.04.257.65.654 2.053 1.111 5.06.503 3.304.979 7.885 1.416 13.617a26.19 26.19 0 0 0-3.685 6.684 23.288 23.288 0 0 0-1.615-3.267c.461-6.753.972-12.153 1.518-16.053Zm-11.917 27.09c-.05-1.793-.78-5.82-5.455-11.328.785.316 1.668.74 2.566 1.298 3.678 2.291 5.784 5.666 6.26 10.03h-3.371Zm5.245 0c.024-1.094-.106-3.031-.957-5.674-1.544-4.803-4.722-9.864-9.459-15.074 1.746.553 4.114 1.486 6.524 2.995 3.13 1.96 5.59 4.38 7.37 7.24a.862.862 0 0 0 .153.252c1 1.658 1.774 3.46 2.322 5.405.01.057.026.113.047.166.354 1.294.61 2.65.763 4.067.023.21.044.417.064.623H29.79Zm14.384 0h-1.597c-.083-2.97.727-6.31 2.412-9.935a.86.86 0 0 0-1.559-.724c-1.789 3.848-2.653 7.431-2.572 10.659h-2.515a54.764 54.764 0 0 0-.082-.808 27.455 27.455 0 0 0-.783-4.202c2.32-8.611 9.473-15.504 18.282-17.857-2.642 2.877-4.87 5.742-6.64 8.544-1.76 2.783-3.076 5.514-3.913 8.116-.94 2.923-1.067 5.043-1.033 6.207Zm2.91 0c.474-4.343 2.563-7.706 6.209-9.997a16.554 16.554 0 0 1 2.615-1.328c-4.673 5.506-5.403 9.532-5.453 11.325h-3.37Z"
    />
    <path
      fill="#000"
      d="M46.31 41.22a.86.86 0 0 0-1.449-.922 1.56 1.56 0 0 0-.095.167.859.859 0 0 0 1.544.756ZM16.4 53.787h-.04a.86.86 0 0 0 0 1.719h.04a.86.86 0 0 0 0-1.719Z"
    />
  </svg>
);

export const OrganizationBadge = (props) => (
  <svg fill="red" width={60} height={60}>
    <mask id="mask">
      <g>
        <path
          d="m62 30.94-2.06 1.82 1.82 2.07-2.27 1.55 1.54 2.27-2.44 1.26 1.24 2.45-2.58.93.92 2.59-2.68.6.59 2.69-2.74.26.26 2.73-2.75-.08-.09 2.75-2.72-.43-.43 2.72-2.64-.76L44.2 59l-2.52-1.09-1.1 2.52-2.36-1.39-1.41 2.36-2.17-1.69-1.69 2.17L31 59.94l-1.95 1.94-1.69-2.17-2.17 1.69-1.41-2.36-2.36 1.39-1.1-2.52-2.53 1.08-.76-2.63-2.65.76-.43-2.72-2.71.42-.09-2.74-2.75.08.25-2.74-2.73-.26.59-2.68-2.68-.6.92-2.59-2.58-.94 1.24-2.45-2.44-1.25 1.54-2.27-2.27-1.55 1.82-2.07L0 30.94l2.06-1.82-1.82-2.07 2.27-1.55-1.54-2.27 2.44-1.26-1.24-2.45 2.58-.93L3.83 16l2.68-.6-.59-2.69 2.74-.26-.26-2.73 2.75.08.09-2.75 2.72.42.43-2.71 2.64.76.77-2.64 2.52 1.09 1.1-2.52 2.36 1.39L25.19.48l2.17 1.69L29.05 0 31 1.94 32.95 0l1.69 2.17L36.81.48l1.41 2.36 2.36-1.39 1.1 2.52 2.53-1.08.76 2.63 2.65-.76.43 2.72 2.71-.42.09 2.74 2.75-.08-.25 2.74 2.73.26-.59 2.68 2.68.6-.92 2.59 2.58.94-1.24 2.45 2.44 1.25-1.54 2.27 2.27 1.55-1.82 2.07L62 30.94z"
          style={{
            fill: "#fff",
          }}
        />
      </g>
    </mask>
    <image xmlnsXlink="" mask="url(#mask)" xlinkHref={props.source}></image>
  </svg>
);

export const MobileAgronomy = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    {...props}
  >
    <g fill="#EF6B2D" clipPath="url(#a)">
      <path d="M17.045 12.294a.469.469 0 0 0-.289-.309 3.332 3.332 0 0 0-.619-.144c1.534-1.632 1.027-3.538.908-3.91a.469.469 0 0 0-.289-.308 4.034 4.034 0 0 0-2.52.026c.073-.303.116-.636.116-1.001 0-2.338-1.77-3.365-2.125-3.547a.469.469 0 0 0-.423-.014c-.087.04-2.152 1.029-2.152 3.56 0 .367.043.7.117 1.004a4.034 4.034 0 0 0-2.526-.028.469.469 0 0 0-.29.308c-.119.372-.625 2.278.908 3.91-.359.052-.59.134-.618.145a.469.469 0 0 0-.29.308c-.121.38-.647 2.358 1.006 4.011.957.957 2.018 1.185 2.814 1.185.294 0 .552-.031.754-.069v3.068a.469.469 0 0 0 .938 0V17.42c.203.038.463.07.76.07.796 0 1.858-.228 2.814-1.185 1.653-1.653 1.128-3.631 1.006-4.011Zm-5.518 3.666a3.13 3.13 0 0 1-.068.52 3.026 3.026 0 0 1-2.837-.838c-1.065-1.065-.953-2.298-.835-2.836a3.143 3.143 0 0 1 1.744.124c.36.136.735.36 1.09.714.675.676.877 1.42.906 2.003v.313Zm0-4.363a3.13 3.13 0 0 1-.068.52c-.311.07-.91.146-1.579-.062a3.774 3.774 0 0 0-.202-.072 3.095 3.095 0 0 1-1.056-.704c-1.065-1.065-.953-2.298-.835-2.835.5-.11 1.757-.239 2.833.837l.02.021c.041.046.082.09.124.133.56.633.736 1.31.763 1.85v.312Zm.476-2.351a3.186 3.186 0 0 1-.64-.547 2.99 2.99 0 0 1-.774-2.051c0-1.528.978-2.321 1.41-2.597.464.297 1.416 1.09 1.416 2.597a2.99 2.99 0 0 1-.702 1.973 4.52 4.52 0 0 0-.214.23 3.146 3.146 0 0 1-.496.395Zm.465 2.2c-.001-.55.141-1.279.724-1.963.07-.069.139-.142.207-.222a3.025 3.025 0 0 1 2.813-.818c.118.537.23 1.77-.836 2.837a3.094 3.094 0 0 1-1.054.703 3.83 3.83 0 0 0-.205.072 3.115 3.115 0 0 1-1.577.063 3.148 3.148 0 0 1-.072-.66v-.013Zm2.908 4.196a3.025 3.025 0 0 1-2.835.839c-.109-.499-.24-1.759.837-2.837a3.095 3.095 0 0 1 1.057-.704c.067-.021.134-.045.202-.071a3.116 3.116 0 0 1 1.575-.064c.118.538.23 1.771-.836 2.837Z" />
      <path d="M14.5.261A12.081 12.081 0 0 0 12 0a11.921 11.921 0 0 0-8.485 3.515A11.922 11.922 0 0 0 0 12c0 2.67.899 5.278 2.536 7.377a1.769 1.769 0 0 0-.284.964c0 .476.186.923.522 1.26a1.77 1.77 0 0 0 1.26.522 1.77 1.77 0 0 0 1.26-.522 1.77 1.77 0 0 0 .52-1.26 1.77 1.77 0 0 0-.52-1.26 1.77 1.77 0 0 0-1.26-.52c-.282 0-.554.065-.799.188A11.083 11.083 0 0 1 .937 12C.937 5.9 5.9.937 12 .937c.777 0 1.553.081 2.306.241a.469.469 0 1 0 .195-.917ZM3.438 19.745a.841.841 0 0 1 1.193 0c.16.159.247.37.247.596a.845.845 0 1 1-1.44-.597ZM21.464 4.624c.184-.285.283-.616.283-.964a1.77 1.77 0 0 0-.522-1.26 1.77 1.77 0 0 0-1.26-.521 1.77 1.77 0 0 0-1.259.522 1.77 1.77 0 0 0-.521 1.26c0 .475.185.922.521 1.259a1.77 1.77 0 0 0 1.26.521c.282 0 .554-.065.799-.188A11.084 11.084 0 0 1 23.062 12c0 6.1-4.963 11.063-11.062 11.063-.656 0-1.314-.058-1.954-.172a.469.469 0 0 0-.165.923c.695.124 1.408.186 2.119.186 3.205 0 6.218-1.248 8.485-3.514A11.921 11.921 0 0 0 24 12.002c0-2.671-.899-5.278-2.536-7.378Zm-.901-.367a.838.838 0 0 1-.597.247.845.845 0 1 1 .597-.247ZM7.881 22.27l-.177.433.176-.434a.469.469 0 0 0-.351.869l.014.006a.47.47 0 0 0 .607-.27.467.467 0 0 0-.269-.605ZM16.491.869l-.008-.003a.469.469 0 0 0-.348.87l.005.002a.467.467 0 0 0 .61-.259.469.469 0 0 0-.259-.61Z" />
    </g>
    <defs>
      <clipPath id="a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);

export const MobileDoubleMask = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    {...props}
  >
    <g
      stroke="#EF6B2D"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      strokeWidth={0.938}
      clipPath="url(#a)"
    >
      <path d="M14.592 3.723 5.665.473A2.036 2.036 0 0 0 3.056 1.69L1.075 7.134a5.768 5.768 0 0 0 .494 4.973l1.948 3.2a2.714 2.714 0 0 0 3.187 1.16l3.55-1.2a5.768 5.768 0 0 0 3.574-3.491l1.981-5.444a2.036 2.036 0 0 0-1.216-2.609Z" />
      <path d="M6.88 11.027c-1.083-.394-1.99-.99-2.622-1.66a3.053 3.053 0 0 0 5.698 2.073c-.915.108-1.993-.019-3.076-.413ZM6.765 7.375c-.118-.473-.497-.903-1.043-1.102-.547-.199-1.113-.113-1.508.174M11.866 9.23c-.118-.473-.496-.902-1.043-1.101-.547-.2-1.113-.113-1.508.173M4.36 5.053s1.304-.609 3.217.088M12.65 8.07s-.61-1.304-2.522-2M9.543 17.089l.629 1.726a5.768 5.768 0 0 0 3.574 3.492l3.55 1.199a2.714 2.714 0 0 0 3.186-1.16l1.949-3.2a5.768 5.768 0 0 0 .494-4.973L20.943 8.73a2.036 2.036 0 0 0-2.609-1.216l-1.575.573" />
      <path d="M17.352 18.703c1.083-.395 2.161-.522 3.076-.413a3.053 3.053 0 0 0-5.698 2.073c.632-.67 1.539-1.266 2.622-1.66ZM12.114 15.945c.456.174 1.025.11 1.5-.224.477-.334.73-.848.722-1.335M19.59 13.224c-.236.426-.713.743-1.293.793-.58.05-1.104-.18-1.41-.56M19.64 12.092s-1.305-.609-3.218.088" />
    </g>
    <defs>
      <clipPath id="a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);

export const MobileFightingIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    {...props}
  >
    <g
      stroke="#EF6B2D"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      strokeWidth={0.938}
      clipPath="url(#a)"
    >
      <path d="M19.362 8.906a.96.96 0 0 1-.728.332.957.957 0 0 1-.96-.954V4.775c0-.527.43-.955.96-.955s.96.428.96.955v2.647" />
      <path d="M21.51 7.496h-1.917s0 0 0 0V5.093c0-.53.428-.958.957-.958h.003c.53 0 .958.429.958.958V7.496ZM15.135 17.063v-1.18c0-.7-.265-1.325-.648-1.898a4.042 4.042 0 0 1-.647-2.193v-1.55M15.135 23.648v-4.757" />
      <path d="M18.726 13.023c0-1.595 1.3-2.887 2.902-2.887v-.732h-.972a1.602 1.602 0 0 1-1.606-1.598c0-.172.14-.311.312-.311h3.327c.53 0 .96.427.96.954v1.5a4.374 4.374 0 0 1-1.291 3.101l-.778.774a2.864 2.864 0 0 0-.845 2.03v7.794M15.758 7.565a.956.956 0 0 1-.411.787" />
      <path d="M16.718 8.973h-.003a.957.957 0 0 1-.958-.958V5.091c0-.53.429-.958.958-.958h.003c.53 0 .958.429.958.958v2.924a.957.957 0 0 1-.958.958ZM11.468 5.437a.959.959 0 0 1-.727.333.957.957 0 0 1-.96-.955V1.306c0-.527.43-.954.96-.954s.959.427.959.954v2.648" />
      <path d="M13.617 4.027h-1.918s0 0 0 0V1.625c0-.529.428-.958.957-.958h.004c.529 0 .957.429.957.958v2.402s0 0 0 0ZM5.946 8.043v-4.62" />
      <path d="M10.832 9.554c0-1.595 1.3-2.887 2.902-2.887v-.732h-.972a1.602 1.602 0 0 1-1.606-1.598c0-.172.14-.311.312-.311h3.327c.53 0 .96.427.96.954v1.5a4.374 4.374 0 0 1-1.292 3.101l-.777.774a2.864 2.864 0 0 0-.845 2.03v11.263M6.907 5.05h-.004a.957.957 0 0 1-.957-.957V2.076c0-.53.428-.958.957-.958h.004c.529 0 .957.429.957.958v2.017a.957.957 0 0 1-.957.958Z" />
      <path d="M8.825 5.504H8.82a.957.957 0 0 1-.957-.958V1.622c0-.529.428-.957.957-.957h.004c.529 0 .957.428.957.957v2.924a.957.957 0 0 1-.957.958ZM4.186 9.249c0-.244-.027-.51.013-.752.116-.696.957-1.027 1.52-.609.36.267.386.652.386 1.056V11.3M5.873 12.783a.971.971 0 0 1-1.544-.122c-.15-.242-.142-.5-.142-.77v-.526" />
      <path d="M8.022 11.375H6.104V8.971c0-.528.429-.957.957-.957h.004c.529 0 .958.429.958.957v2.402l-.001.001ZM1.646 23.648v-3.887c0-.699-.265-1.324-.647-1.897a4.042 4.042 0 0 1-.648-2.193V10.77" />
      <path d="M5.237 16.902c0-1.595 1.3-2.887 2.902-2.887v-.732h-.972a1.602 1.602 0 0 1-1.606-1.598c0-.172.14-.311.312-.311H9.2c.53 0 .96.427.96.954v1.5a4.374 4.374 0 0 1-1.291 3.101l-.778.774a2.864 2.864 0 0 0-.845 2.03v3.915M1.312 12.398h-.004a.957.957 0 0 1-.957-.957V9.423c0-.529.429-.957.958-.957h.003c.529 0 .958.428.958.957v2.018a.957.957 0 0 1-.958.957Z" />
      <path d="m4.172 9.373.016.001V8.97a.957.957 0 0 0-.958-.958h-.003a.957.957 0 0 0-.958.958v2.924c0 .529.429.958.958.958h.003a.957.957 0 0 0 .958-.958v-.646h-.016" />
    </g>
    <defs>
      <clipPath id="a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);

export const MetricStartDateIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    {...props}
  >
    <mask
      id="a"
      width={16}
      height={16}
      x={0}
      y={0}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: "alpha",
      }}
    >
      <path fill="#D9D9D9" d="M0 0h16v16H0z" />
    </mask>
    <g mask="url(#a)">
      <path
        fill="#EF6B2D"
        d="M8 9.382a.551.551 0 0 1-.417-.175.572.572 0 0 1-.166-.408c0-.167.055-.309.166-.426A.552.552 0 0 1 8 8.2c.167 0 .306.058.417.174a.595.595 0 0 1 .166.426.572.572 0 0 1-.166.408.551.551 0 0 1-.417.175Zm-2.667 0a.551.551 0 0 1-.416-.175.572.572 0 0 1-.167-.408c0-.167.056-.309.167-.426a.552.552 0 0 1 .416-.174c.167 0 .306.058.417.174a.595.595 0 0 1 .167.426.572.572 0 0 1-.167.408.551.551 0 0 1-.417.175Zm5.334 0a.551.551 0 0 1-.417-.175.572.572 0 0 1-.167-.408c0-.167.056-.309.167-.426a.552.552 0 0 1 .417-.174c.166 0 .305.058.416.174a.595.595 0 0 1 .167.426.572.572 0 0 1-.167.408.551.551 0 0 1-.416.175ZM8 11.999a.552.552 0 0 1-.417-.175.575.575 0 0 1-.166-.409c0-.166.055-.308.166-.424A.551.551 0 0 1 8 10.815c.167 0 .306.059.417.176a.592.592 0 0 1 .166.424.575.575 0 0 1-.166.409.552.552 0 0 1-.417.175Zm-2.667 0a.552.552 0 0 1-.416-.175.575.575 0 0 1-.167-.409c0-.166.056-.308.167-.424a.551.551 0 0 1 .416-.176c.167 0 .306.059.417.176a.592.592 0 0 1 .167.424.575.575 0 0 1-.167.409.552.552 0 0 1-.417.175Zm5.334 0a.552.552 0 0 1-.417-.175.575.575 0 0 1-.167-.409c0-.166.056-.308.167-.424a.55.55 0 0 1 .417-.176c.166 0 .305.059.416.176a.592.592 0 0 1 .167.424.575.575 0 0 1-.167.409.552.552 0 0 1-.416.175Zm-7.134 2.333c-.333 0-.616-.117-.85-.35a1.157 1.157 0 0 1-.35-.85V4.199c0-.334.117-.617.35-.85.234-.234.517-.35.85-.35h.934v-.9c0-.145.047-.267.141-.367.095-.1.214-.15.359-.15.155 0 .28.05.374.15.095.1.142.222.142.367v.9h5.05v-.917c0-.133.05-.25.15-.35.1-.1.217-.15.35-.15a.47.47 0 0 1 .358.15c.095.1.142.217.142.35v.917h.934c.333 0 .616.116.85.35.233.233.35.516.35.85v8.933c0 .333-.117.617-.35.85-.234.233-.517.35-.85.35H3.533Zm0-1h8.934c.055 0 .102-.02.142-.058a.194.194 0 0 0 .058-.142V6.865H3.333v6.267c0 .056.02.103.059.142a.192.192 0 0 0 .141.058Zm-.2-7.467h9.334V4.2a.192.192 0 0 0-.058-.142.193.193 0 0 0-.142-.058H3.533a.191.191 0 0 0-.141.058.191.191 0 0 0-.059.142v1.666Z"
      />
    </g>
  </svg>
);

export const MetricBarChartIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    {...props}
  >
    <mask
      id="a"
      width={16}
      height={16}
      x={0}
      y={0}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: "alpha",
      }}
    >
      <path fill="#D9D9D9" d="M0 0h16v16H0z" />
    </mask>
    <g mask="url(#a)">
      <path
        fill="#EF6B2D"
        d="M4 13.165c-.322 0-.597-.113-.825-.341a1.125 1.125 0 0 1-.342-.825V7.332c0-.322.114-.597.342-.825.228-.228.503-.342.825-.342.322 0 .597.114.825.342.228.228.342.503.342.825v4.667c0 .322-.114.597-.342.825a1.126 1.126 0 0 1-.825.341Zm4 0c-.322 0-.597-.113-.825-.341a1.126 1.126 0 0 1-.342-.825v-8c0-.323.114-.598.342-.826.228-.227.503-.341.825-.341.322 0 .597.114.825.341.228.228.342.503.342.826v8c0 .322-.114.597-.342.825a1.126 1.126 0 0 1-.825.341Zm4 0c-.322 0-.597-.113-.825-.341a1.125 1.125 0 0 1-.342-.825v-2c0-.323.114-.598.342-.826.228-.227.503-.341.825-.341.322 0 .597.114.825.341.228.228.342.503.342.826v2c0 .322-.114.597-.342.825a1.126 1.126 0 0 1-.825.341Z"
      />
    </g>
  </svg>
);

export const TargetIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    {...props}
  >
    <g clipPath="url(#a)">
      <path
        fill="#EF6B2D"
        d="M13.794 5.467A6.78 6.78 0 0 0 5.227 12 6.78 6.78 0 0 0 12 18.773a6.78 6.78 0 0 0 6.533-8.567.75.75 0 0 1 1.446-.397c.195.71.294 1.448.294 2.191 0 4.562-3.711 8.273-8.273 8.273-4.562 0-8.273-3.711-8.273-8.273 0-4.562 3.711-8.273 8.273-8.273.743 0 1.48.099 2.19.294a.75.75 0 0 1-.396 1.446Zm8.782 2.616a.75.75 0 0 0-.506.932c.285.965.43 1.97.43 2.985 0 5.79-4.71 10.5-10.5 10.5S1.5 17.79 1.5 12 6.21 1.5 12 1.5c1.016 0 2.02.145 2.985.43A.75.75 0 1 0 15.41.492 12.006 12.006 0 0 0 12 0a11.922 11.922 0 0 0-8.485 3.515A11.922 11.922 0 0 0 0 12c0 3.205 1.248 6.219 3.515 8.485A11.921 11.921 0 0 0 12 24c3.205 0 6.219-1.248 8.485-3.515A11.921 11.921 0 0 0 24 12c0-1.16-.166-2.308-.492-3.41a.75.75 0 0 0-.932-.507ZM12 9c.11 0 .222.006.331.018a.75.75 0 1 0 .164-1.49A4.505 4.505 0 0 0 7.5 12c0 2.48 2.019 4.499 4.5 4.499s4.5-2.019 4.5-4.5a.75.75 0 0 0-1.5 0c0 1.654-1.346 3-3 3s-3-1.346-3-3 1.346-3 3-3Zm3.83-1.89.373-3.747a.75.75 0 0 1 .216-.456L19.106.22a.75.75 0 0 1 1.278.471l.213 2.712 2.712.213a.75.75 0 0 1 .471 1.278l-2.687 2.687a.75.75 0 0 1-.456.216l-3.747.374-4.36 4.36a.748.748 0 0 1-1.06 0 .75.75 0 0 1 0-1.061l4.36-4.36Zm1.556-.496 2.836-.283 1.347-1.347-1.728-.136a.75.75 0 0 1-.69-.689l-.135-1.728-1.347 1.347-.283 2.836Z"
      />
    </g>
    <defs>
      <clipPath id="a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);

export const AnimalCareAndServices = ({
  width = 152,
  height = 132,
  ...restOfProps
}) => (
  <svg
    width={width}
    height={height}
    {...restOfProps}
    viewBox="0 0 152 132"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M23.9786 86.4843L15.0516 77.5573C-2.04844 60.4573 -2.04844 32.7292 15.0516 15.6292C23.3937 7.287 34.583 2.80121 46.0216 2.80121C50.4717 2.80121 54.9545 3.48106 59.3245 4.8734L76 10.1904L92.6755 4.8734C107.608 0.108559 123.895 3.70371 135.42 14.1715"
      stroke="black"
      strokeWidth="4.45312"
      stroke-miterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M142.221 21.9941C147.256 29.3923 149.773 37.9927 149.773 46.5932C149.773 57.8002 145.498 69.0073 136.948 77.5573L91.8857 122.62C87.6731 126.833 81.9582 129.199 76 129.199C73.0193 129.199 70.104 128.608 67.4025 127.489C64.7009 126.372 62.219 124.728 60.1142 122.62L31.3232 93.829"
      stroke="black"
      strokeWidth="4.45312"
      stroke-miterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M113.762 59.0392C117.946 59.0392 121.338 55.6472 121.338 51.463C121.338 47.2787 117.946 43.8867 113.762 43.8867C109.578 43.8867 106.186 47.2787 106.186 51.463C106.186 55.6472 109.578 59.0392 113.762 59.0392Z"
      stroke="black"
      strokeWidth="4.45312"
      stroke-miterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M90.6788 40.4943C94.863 40.4943 98.255 37.1023 98.255 32.918C98.255 28.7338 94.863 25.3418 90.6788 25.3418C86.4945 25.3418 83.1025 28.7338 83.1025 32.918C83.1025 37.1023 86.4945 40.4943 90.6788 40.4943Z"
      stroke="black"
      strokeWidth="4.45312"
      stroke-miterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M38.2384 59.0392C42.4226 59.0392 45.8146 55.6472 45.8146 51.463C45.8146 47.2787 42.4226 43.8867 38.2384 43.8867C34.0541 43.8867 30.6621 47.2787 30.6621 51.463C30.6621 55.6472 34.0541 59.0392 38.2384 59.0392Z"
      stroke="black"
      strokeWidth="4.45312"
      stroke-miterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M61.3214 40.4943C65.5056 40.4943 68.8976 37.1023 68.8976 32.918C68.8976 28.7338 65.5056 25.3418 61.3214 25.3418C57.1371 25.3418 53.7451 28.7338 53.7451 32.918C53.7451 37.1023 57.1371 40.4943 61.3214 40.4943Z"
      stroke="black"
      strokeWidth="4.45312"
      stroke-miterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M93.3377 64.7916L98.3935 69.8473C104.678 76.1322 104.678 86.318 98.3935 92.6028C95.3298 95.6666 91.221 97.3142 87.0173 97.3142C85.3815 97.3142 83.7338 97.0648 82.1277 96.5542L76.0002 94.6008L69.8727 96.5542C64.1371 98.383 57.8612 96.86 53.607 92.6028C50.463 89.4589 48.8926 85.3442 48.8926 81.2236C48.8926 77.1089 50.463 72.9883 53.607 69.8473L70.1637 53.2906C71.7104 51.7409 73.8123 50.8711 76.0002 50.8711C77.0927 50.8711 78.1674 51.0878 79.159 51.5005C80.1506 51.9102 81.0649 52.5158 81.8368 53.2906L85.993 57.4469"
      stroke="black"
      strokeWidth="4.45312"
      stroke-miterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const Agriculture = ({ width = 152, height = 152, ...restOfProps }) => (
  <svg
    {...restOfProps}
    width={width}
    height={height}
    viewBox="0 0 152 152"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_2898_32427)">
      <path
        d="M107.701 77.686C107.439 76.7927 106.768 76.0632 105.875 75.7368C105.695 75.6711 104.235 75.1545 101.968 74.8228C111.655 64.5146 108.457 52.4714 107.701 50.1194C107.439 49.2258 106.768 48.4963 105.875 48.1699C105.459 48.0177 98.2086 45.461 89.9475 48.3361C90.414 46.4224 90.6868 44.3186 90.6868 42.0101C90.6868 27.2402 79.5021 20.7484 77.2577 19.596C76.4411 19.1487 75.4498 19.1079 74.5885 19.5083C74.0331 19.7663 60.9852 26.0108 60.9852 42.0101C60.9852 44.3233 61.2592 46.4316 61.7275 48.3482C53.4519 45.4539 46.1815 48.0174 45.7651 48.1699C44.8727 48.4963 44.2013 49.2258 43.9397 50.1194C43.1836 52.4714 39.9851 64.5146 49.6726 74.8228C47.4051 75.1545 45.9452 75.6711 45.7651 75.7368C44.8727 76.0632 44.201 76.793 43.9395 77.6863C43.1676 80.0875 39.8486 92.5877 50.2925 103.032C56.3364 109.076 63.0443 110.518 68.0699 110.518C69.9305 110.518 71.5568 110.319 72.8372 110.084V129.465C72.8372 131.1 74.1632 132.426 75.799 132.426C77.4348 132.426 78.7608 131.1 78.7608 129.465V110.077C80.0471 110.315 81.6894 110.517 83.5702 110.517C88.5954 110.517 95.3042 109.075 101.347 103.032C111.791 92.5871 108.472 80.0872 107.701 77.686ZM72.8372 100.851C72.7714 102.196 72.5828 103.326 72.4024 104.138C69.2365 104.841 61.3155 105.677 54.4814 98.8428C47.7501 92.112 48.4556 84.3221 49.2008 80.923C51.1914 80.4903 55.0758 80.0081 59.3764 81.4037C59.6595 81.5098 59.9418 81.6099 60.2226 81.7032C62.5002 82.5668 64.8649 83.9767 67.1061 86.2176C71.3767 90.4883 72.6521 95.1829 72.8372 98.8751V100.851ZM72.8372 73.285C72.7714 74.6294 72.5828 75.7593 72.4024 76.5715C70.4408 77.0077 66.6538 77.492 62.4312 76.174C62.0032 76.009 61.5776 75.8588 61.1549 75.7229C58.946 74.8503 56.6586 73.4535 54.4811 71.2762C47.7501 64.5451 48.4556 56.7554 49.2008 53.3567C52.3637 52.669 60.307 51.8521 67.1061 58.6513C67.1493 58.6946 67.1884 58.7381 67.2308 58.7811C67.4905 59.0725 67.7512 59.3512 68.0115 59.619C71.5565 63.6207 72.666 67.8935 72.8372 71.3088V73.285ZM75.8407 58.4241C74.9125 57.8288 73.575 56.8475 72.2164 55.4291C72.0778 55.2772 71.9377 55.1252 71.7937 54.9739C69.3191 52.225 66.9085 48.0082 66.9085 42.0101C66.9085 32.3554 73.0869 27.346 75.8209 25.602C78.7489 27.4757 84.7629 32.4851 84.7629 42.0101C84.7629 47.6702 82.639 51.7315 80.3311 54.4766C79.8513 54.957 79.4023 55.4421 78.9791 55.9297C77.7949 57.0809 76.6609 57.9017 75.8407 58.4241ZM78.7791 72.325C78.775 68.8478 79.6745 64.2463 83.3572 59.9249C83.7935 59.4913 84.2321 59.0248 84.6669 58.5234C91.4634 51.8382 99.292 52.6547 102.438 53.3508C103.184 56.7466 103.894 64.5413 97.1586 71.2762C94.9852 73.45 92.7023 74.8456 90.4972 75.7187C90.0675 75.8568 89.6348 76.0093 89.1994 76.1772C84.9773 77.4932 81.1927 77.0071 79.2388 76.5723C79.0196 75.5852 78.7874 74.1353 78.7788 72.4006C78.7788 72.3754 78.7791 72.3502 78.7791 72.325ZM97.1586 98.8428C90.3234 105.679 82.402 104.841 79.2436 104.14C78.5549 100.99 77.7224 93.0293 84.5339 86.2176C86.7132 84.0383 89.0024 82.6412 91.2131 81.7686C91.6348 81.633 92.0593 81.4837 92.4861 81.319C96.6995 80.0039 100.478 80.4838 102.438 80.9171C103.184 84.3132 103.894 92.1079 97.1586 98.8428Z"
        fill="black"
      />
      <path
        d="M91.6252 1.65005C86.4624 0.555348 81.1454 0 75.8222 0C55.5694 0 36.5288 7.88684 22.2079 22.2083C7.88699 36.5295 0 55.5704 0 75.8236C0 92.6996 5.67778 109.173 16.0222 122.438C14.8585 124.238 14.2321 126.335 14.2321 128.53C14.2321 131.536 15.4029 134.362 17.5285 136.488C19.6542 138.614 22.4807 139.785 25.4869 139.785C28.4931 139.785 31.3196 138.614 33.4453 136.488C35.5713 134.362 36.7418 131.536 36.7418 128.53C36.7418 125.523 35.571 122.697 33.4453 120.571C31.3196 118.445 28.4931 117.274 25.4869 117.274C23.7051 117.274 21.9875 117.689 20.4406 118.466C11.0659 106.297 5.92361 91.2433 5.92361 75.8236C5.92361 37.2806 37.2799 5.92372 75.8222 5.92372C80.7334 5.92372 85.6367 6.43552 90.3963 7.44493C91.9975 7.78406 93.5687 6.76192 93.9081 5.16193C94.2475 3.56163 93.2254 1.98948 91.6252 1.65005ZM21.7171 124.759C22.7564 123.72 24.1215 123.2 25.4869 123.2C26.8523 123.2 28.2174 123.72 29.2567 124.759C30.2637 125.766 30.8182 127.105 30.8182 128.529C30.8182 129.953 30.2637 131.292 29.2567 132.299C27.1781 134.378 23.7957 134.378 21.7171 132.299C20.7101 131.292 20.1557 129.953 20.1557 128.529C20.1557 127.105 20.7101 125.766 21.7171 124.759Z"
        fill="black"
      />
      <path
        d="M135.619 29.2044C136.783 27.4042 137.409 25.3072 137.409 23.1125C137.409 20.1062 136.239 17.2797 134.113 15.154C131.987 13.0279 129.161 11.8574 126.154 11.8574C123.148 11.8574 120.322 13.0282 118.196 15.154C116.07 17.2797 114.9 20.1062 114.9 23.1125C114.9 26.1188 116.07 28.9453 118.196 31.071C120.322 33.197 123.148 34.3675 126.154 34.3675C127.937 34.3675 129.654 33.9532 131.201 33.1754C140.576 45.3454 145.718 60.3987 145.718 75.8184C145.718 114.361 114.361 145.718 75.8192 145.718C71.673 145.718 67.5188 145.353 63.4721 144.632C61.8626 144.345 60.3234 145.417 60.0367 147.028C59.7497 148.638 60.8224 150.176 62.4328 150.463C66.8219 151.245 71.3256 151.642 75.8192 151.642C96.0721 151.642 115.113 143.755 129.434 129.434C143.755 115.113 151.641 96.0716 151.641 75.8184C151.641 58.9424 145.964 42.4688 135.619 29.2044ZM129.925 26.8823C128.918 27.8894 127.579 28.4438 126.155 28.4438C124.731 28.4438 123.392 27.8897 122.385 26.8823C120.306 24.8037 120.306 21.4216 122.385 19.3426C123.392 18.3356 124.731 17.7811 126.155 17.7811C127.579 17.7811 128.918 18.3356 129.925 19.3426C130.932 20.3494 131.486 21.6884 131.486 23.1125C131.486 24.5365 130.932 25.8753 129.925 26.8823Z"
        fill="black"
      />
      <path
        d="M49.7997 140.724L48.6813 143.466L49.7914 140.72C48.2741 140.108 46.5485 140.84 45.9354 142.356C45.3223 143.873 46.0548 145.599 47.5712 146.213L47.6628 146.249C48.012 146.382 48.3715 146.446 48.7251 146.446C49.9182 146.446 51.0457 145.724 51.4971 144.546C52.0824 143.018 51.3274 141.309 49.7997 140.724Z"
        fill="black"
      />
      <path
        d="M104.2 5.48767L104.148 5.46664C102.629 4.85887 100.905 5.59785 100.298 7.11669C99.6899 8.63553 100.429 10.3587 101.948 10.9665L101.981 10.9801C102.345 11.1271 102.72 11.1964 103.09 11.1964C104.262 11.1964 105.371 10.4965 105.837 9.34342C106.45 7.82665 105.717 6.10048 104.2 5.48767Z"
        fill="black"
      />
    </g>
    <defs>
      <clipPath id="clip0_2898_32427">
        <rect width="151.644" height="151.647" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const ArtsAndCulture = ({
  width = 152,
  height = 152,
  ...restOfProps
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    fill="none"
    {...restOfProps}
  >
    <g
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      strokeWidth={4.443}
      clipPath="url(#a)"
    >
      <path d="M92.202 23.528 35.796 2.998C29.121.568 21.74 4.011 19.31 10.686L6.79 45.082a36.444 36.444 0 0 0 3.12 31.42l12.312 20.217a17.151 17.151 0 0 0 20.135 7.329l22.427-7.573A36.445 36.445 0 0 0 87.37 74.41l12.52-34.397c2.429-6.675-1.013-14.056-7.688-16.486Z" />
      <path d="M43.468 69.667c-6.843-2.49-12.575-6.255-16.564-10.494-2.24 9.401 2.864 19.195 12.165 22.581 9.302 3.385 19.507-.836 23.834-9.479-5.78.684-12.591-.117-19.435-2.608ZM42.74 46.584c-.748-2.988-3.137-5.705-6.591-6.962-3.455-1.257-7.031-.712-9.525 1.096M74.974 58.32c-.748-2.988-3.138-5.704-6.592-6.961-3.454-1.258-7.03-.713-9.525 1.096M27.546 31.933s8.243-3.844 20.33.555M79.921 50.988s-3.844-8.243-15.93-12.642M60.298 107.967l3.97 10.906a36.443 36.443 0 0 0 22.586 22.064l22.427 7.574a17.151 17.151 0 0 0 20.135-7.329l12.312-20.217a36.444 36.444 0 0 0 3.119-31.42l-12.519-34.397c-2.43-6.675-9.811-10.117-16.486-7.687l-9.95 3.622" />
      <path d="M109.637 118.158c6.844-2.491 13.655-3.292 19.435-2.608-4.327-8.642-14.532-12.864-23.834-9.479-9.301 3.386-14.406 13.18-12.165 22.581 3.989-4.239 9.721-8.003 16.564-10.494ZM76.54 100.73c2.878 1.098 6.473.694 9.482-1.418 3.008-2.112 4.61-5.356 4.555-8.436M123.781 83.534c-1.499 2.691-4.513 4.693-8.175 5.01-3.662.315-6.974-1.14-8.912-3.536M124.092 76.398s-8.243-3.844-20.33.555" />
    </g>
    <defs>
      <clipPath id="a">
        <path fill="#fff" d="M0 0h151.644v151.644H0z" />
      </clipPath>
    </defs>
  </svg>
);

export const AgingWell = ({ width = 150, height = 150, ...restOfProps }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={150}
    height={150}
    fill="none"
    {...restOfProps}
  >
    <g
      stroke="#000"
      strokeMiterlimit={22.926}
      strokeWidth={4.395}
      clipPath="url(#a)"
    >
      <path d="M55.225 78.003c0 3.021 2.471 5.493 5.493 5.493 3.021 0 5.493-2.472 5.493-5.493V34.058c0-3.022-2.472-5.494-5.493-5.494m-5.493 49.439V42.847m0 35.156v10.986l2.197 4.395 2.197 45.63m10.987 0 6.592-61.011V39.55c0-6.043-4.944-10.987-10.987-10.987h-5.493c-3.021 0-5.493 2.473-5.493 5.494v4.394m4.394 100.562v8.789h19.775v-4.395A4.408 4.408 0 0 0 75 139.014H59.62ZM66.212 78.004h10.986M55.225 51.635H66.21" />
      <path
        d="M79.395 15.38c0 7.282-5.902 13.184-13.183 13.184s-13.184-5.902-13.184-13.183S58.931 2.197 66.212 2.197H75a4.407 4.407 0 0 1 4.394 4.395v8.789Z"
        clipRule="evenodd"
      />
      <path d="M4.395 104.369c0 3.021 2.471 5.493 5.493 5.493 3.021 0 5.493-2.472 5.493-5.493V73.607c0-3.021-2.472-5.493-5.493-5.493m-4.41 53.321h18.692l2.197-17.067V79.1c0-6.043-4.944-10.987-10.986-10.987H9.888c-3.022 0-5.493 2.474-5.493 5.493v30.762l2.197 34.644m0 0v8.789H24.17v-4.394a4.408 4.408 0 0 0-4.395-4.395H6.592Zm8.79.001 2.196-17.578M15.38 104.369h10.987M4.395 86.791H15.38" />
      <path d="M15.38 68.115c7.282 0 13.184-5.902 13.184-13.183 0-7.282-5.902-13.184-13.183-13.184S2.197 47.651 2.197 54.932c0 7.28 5.903 13.183 13.184 13.183ZM103.488 86.793h21.973M119.968 37.353c7.281 0 13.183-5.902 13.183-13.183s-5.902-13.184-13.183-13.184-13.184 5.903-13.184 13.184 5.903 13.183 13.184 13.183ZM118.869 139.014l2.47-19.571m.551-4.36.55-4.36m.551-4.36 2.47-19.571 4.18-20.07m-8.873-29.368h-6.293c-6.043 0-10.987 4.943-10.987 10.986v45.044l2.198 4.394 2.197 41.236m0 0v8.789h19.775v-4.395a4.407 4.407 0 0 0-4.394-4.394h-15.381Z" />
      <path
        d="M145.282 80.916c2.543-1.632 3.288-5.047 1.655-7.59l-21.476-33.452c-1.632-2.543-5.047-3.287-7.59-1.655-2.542 1.633-3.287 5.048-1.655 7.59l21.476 33.452c1.632 2.543 5.048 3.288 7.59 1.655Z"
        clipRule="evenodd"
      />
      <path d="M147.152 149.999V86.176a4.407 4.407 0 0 0-4.394-4.395 4.408 4.408 0 0 0-4.395 4.395v4.395M134.503 74.294l9.1-6.161M2.197 54.932l33.399-4.22M79.394 13.184h-15.38l-7.125 11.52M133.151 24.17h-15.38l-7.125 9.322M112.276 58.775v-4.394m0 13.183V63.17" />
    </g>
    <defs>
      <clipPath id="a">
        <path fill="#fff" d="M0 0h150v150H0z" />
      </clipPath>
    </defs>
  </svg>
);

export const BehaviorAndMentalHealth = ({
  width = 152,
  height = 152,
  ...restOfProps
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    fill="none"
    {...restOfProps}
  >
    <g fill="#000" clipPath="url(#a)">
      <path d="M83.59 151.633a2.962 2.962 0 1 0 0-5.924 2.962 2.962 0 0 0 0 5.924Z" />
      <path d="M145.729 63.126c0-34.809-28.319-63.128-63.128-63.128-16.687 0-31.798 4.906-42.55 13.814-12.128 10.048-18.63 24.91-18.835 43.02 0 0-13.774 21.257-13.808 21.319-2.047 3.715-1.981 8.114.176 11.766 2.158 3.652 5.979 5.833 10.22 5.833h4.679v26.761a11.86 11.86 0 0 0 4.135 9.004 11.858 11.858 0 0 0 9.523 2.731l17.088-2.602v17.03a2.968 2.968 0 0 0 2.968 2.968H70.29a2.968 2.968 0 0 0 0-5.935H59.164v-17.516c0-1.787-1.644-3.205-3.414-2.934l-20.503 3.122a5.928 5.928 0 0 1-4.762-1.366 5.93 5.93 0 0 1-2.067-4.502V92.783a2.968 2.968 0 0 0-2.968-2.968h-7.646a5.882 5.882 0 0 1-5.11-2.916 5.88 5.88 0 0 1-.133-5.8l14.108-21.767c.311-.48.477-1.041.477-1.614 0-8.716 1.54-16.578 4.578-23.368 2.797-6.253 6.873-11.625 12.114-15.967 9.69-8.028 23.456-12.45 38.763-12.45 31.537 0 57.193 25.657 57.193 57.193 0 20.58-11.139 39.667-29.071 49.813a2.967 2.967 0 0 0-1.506 2.582l.001 30.187H96.895a2.967 2.967 0 1 0 0 5.935h15.29c.787 0 1.542-.313 2.099-.869a2.971 2.971 0 0 0 .869-2.098l-.001-31.451c18.905-11.399 30.577-31.967 30.577-54.1Z" />
      <path d="m84.199 87.5 28.638-30.718c6.821-7.316 6.821-19.22 0-26.536-3.368-3.612-7.861-5.601-12.653-5.601-4.792 0-9.285 1.989-12.653 5.6L82.03 36.15l-5.572-5.976c-3.368-3.612-7.861-5.6-12.653-5.6-4.792 0-9.285 1.988-12.653 5.6-6.82 7.316-6.82 19.22 0 26.536L79.858 87.5a2.968 2.968 0 0 0 4.341 0ZM55.492 52.66c-4.74-5.083-4.74-13.356 0-18.44 2.233-2.394 5.185-3.713 8.312-3.713s6.08 1.319 8.312 3.713l7.743 8.304a2.967 2.967 0 0 0 4.34 0l7.674-8.231c2.232-2.395 5.184-3.713 8.311-3.713 3.128 0 6.08 1.318 8.312 3.713 4.741 5.084 4.741 13.357 0 18.44L82.029 81.125 55.492 52.661Z" />
    </g>
    <defs>
      <clipPath id="a">
        <path fill="#fff" d="M0 0h151.644v151.644H0z" />
      </clipPath>
    </defs>
  </svg>
);

export const CareerDevelopmentAndTraining = ({
  width = 152,
  height = 152,
  ...restOfProps
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={width}
    fill="none"
    {...restOfProps}
  >
    <path
      fill="#000"
      d="M75.822 45.023a11.847 11.847 0 1 0-11.847-11.848 11.86 11.86 0 0 0 11.847 11.848Zm0-18.956a7.108 7.108 0 1 1-7.109 7.108 7.117 7.117 0 0 1 7.109-7.108Z"
    />
    <path
      fill="#000"
      d="M54.977 21.722a3.223 3.223 0 0 1-1.996 4.819l-3.774.905a2.37 2.37 0 0 0-1.817 2.304v6.851a2.37 2.37 0 0 0 1.817 2.304l3.774.905a3.222 3.222 0 0 1 1.996 4.82l-2.04 3.33a2.37 2.37 0 0 0 .344 2.913l4.844 4.844a2.37 2.37 0 0 0 2.914.345l3.33-2.041a3.224 3.224 0 0 1 4.82 1.997l.904 3.774a2.37 2.37 0 0 0 2.304 1.817h6.851a2.37 2.37 0 0 0 2.304-1.817l.905-3.774a3.222 3.222 0 0 1 4.82-1.997l3.33 2.041a2.37 2.37 0 0 0 2.914-.345l4.844-4.844a2.37 2.37 0 0 0 .345-2.914l-2.042-3.33a3.223 3.223 0 0 1 1.997-4.819l3.774-.905a2.366 2.366 0 0 0 1.817-2.304V29.75a2.367 2.367 0 0 0-1.817-2.304l-3.774-.905a3.223 3.223 0 0 1-1.996-4.82l2.04-3.33a2.37 2.37 0 0 0-.344-2.913l-4.844-4.844a2.37 2.37 0 0 0-2.914-.345l-3.33 2.041a3.224 3.224 0 0 1-4.82-1.997l-.904-3.774a2.37 2.37 0 0 0-2.305-1.817h-6.85a2.37 2.37 0 0 0-2.305 1.817l-.905 3.774a3.224 3.224 0 0 1-4.819 1.997l-3.33-2.041a2.37 2.37 0 0 0-2.914.345l-4.844 4.844a2.37 2.37 0 0 0-.345 2.914l2.041 3.33Zm4.041-2.476-1.065-1.738 2.203-2.202 1.738 1.064a7.963 7.963 0 0 0 11.903-4.932l.469-1.957h3.114l.47 1.957a7.963 7.963 0 0 0 11.903 4.933l1.737-1.065 2.203 2.202-1.065 1.738A7.961 7.961 0 0 0 97.56 31.15l1.957.47v3.114l-1.957.469a7.962 7.962 0 0 0-4.932 11.903l1.065 1.738-2.203 2.202-1.738-1.064a7.963 7.963 0 0 0-11.903 4.932l-.47 1.957h-3.113l-.47-1.957a7.962 7.962 0 0 0-11.903-4.933l-1.737 1.066-2.203-2.203 1.065-1.738a7.961 7.961 0 0 0-4.932-11.903l-1.957-.47V31.62l1.957-.47a7.962 7.962 0 0 0 4.932-11.903ZM97.677 124.189a11.913 11.913 0 0 0-7.639-10.02l-9.919-3.72-.014-.011 2.42-2.42a9.42 9.42 0 0 0 2.776-6.702V87.674a2.37 2.37 0 0 0-2.37-2.37h-7.108a9.489 9.489 0 0 0-9.478 9.478v6.534a9.42 9.42 0 0 0 2.776 6.702l2.42 2.42-.014.011-9.92 3.72a11.911 11.911 0 0 0-7.638 10.02l-1.83 20.137a2.369 2.369 0 0 0 4.719.429l1.83-20.137a7.145 7.145 0 0 1 4.584-6.012l5.459-2.047a7.094 7.094 0 0 0 2.292 4.786l-2.296 22.96a2.369 2.369 0 1 0 4.715.471l2.156-21.566c.075.002.15.006.225.006.075 0 .15-.004.225-.006l2.156 21.566a2.37 2.37 0 1 0 4.716-.471l-2.296-22.96a7.093 7.093 0 0 0 2.291-4.786l5.46 2.047a7.143 7.143 0 0 1 4.583 6.012l1.83 20.137a2.371 2.371 0 0 0 3.461 1.884 2.375 2.375 0 0 0 1.161-1.394c.093-.297.126-.609.098-.919l-1.831-20.137ZM71.084 94.783a4.745 4.745 0 0 1 4.739-4.74h4.739v11.273a4.706 4.706 0 0 1-1.388 3.351l-3.351 3.351-3.35-3.351a4.712 4.712 0 0 1-1.389-3.351v-6.534Zm7.108 21.324a2.37 2.37 0 0 1-4.66.607 2.372 2.372 0 0 1 .486-2.138l1.805-.677 1.805.677c.364.427.565.97.564 1.531Z"
    />
    <path
      fill="#000"
      d="M139.798 52.13h-33.172a7.118 7.118 0 0 0-7.108 7.11v9.477h-2.37a7.116 7.116 0 0 0-7.108 7.108v30.803a2.367 2.367 0 0 0 1.463 2.189 2.376 2.376 0 0 0 2.582-.513l6.414-6.415h29.822a7.12 7.12 0 0 0 7.108-7.108v-8.497l5.433 5.433a2.366 2.366 0 0 0 2.582.514 2.366 2.366 0 0 0 1.463-2.19V59.24a7.115 7.115 0 0 0-7.109-7.108Zm-9.477 45.02H99.518a2.37 2.37 0 0 0-1.676.694l-3.063 3.064V75.825a2.372 2.372 0 0 1 2.37-2.37h2.369v4.74a7.12 7.12 0 0 0 7.108 7.108h26.064v9.478a2.374 2.374 0 0 1-2.369 2.37Zm11.847-12.828-3.064-3.064a2.369 2.369 0 0 0-1.675-.694h-30.803a2.375 2.375 0 0 1-2.369-2.37V59.24a2.37 2.37 0 0 1 2.369-2.37h33.172a2.372 2.372 0 0 1 2.37 2.37v25.083Z"
    />
    <path
      fill="#000"
      d="M118.473 66.348h-7.108a2.37 2.37 0 1 0 0 4.739h7.108a2.368 2.368 0 1 0 0-4.74ZM135.06 66.348h-7.109a2.369 2.369 0 0 0 0 4.739h7.109a2.368 2.368 0 1 0 0-4.74ZM30.803 111.366a2.369 2.369 0 0 0 4.739 0 7.115 7.115 0 0 1 7.108-7.109h16.586a2.367 2.367 0 0 0 2.37-2.369V63.977a2.37 2.37 0 0 0-2.37-2.37H47.39a14.217 14.217 0 1 0-28.433 0H7.109a2.37 2.37 0 0 0-2.37 2.37v37.911a2.369 2.369 0 0 0 2.37 2.369h16.586a7.115 7.115 0 0 1 7.108 7.109Zm3.693-30.803h-2.647a2.366 2.366 0 0 1-2.247-1.62l-1.04-3.12h9.221l-1.04 3.12a2.366 2.366 0 0 1-2.247 1.62Zm22.371-14.217v33.172H42.65a11.787 11.787 0 0 0-7.108 2.376V85.222a7.097 7.097 0 0 0 5.697-4.78l1.07-3.209c.131-.394.276-.79.43-1.176l3.633-9.082c.084-.208.162-.418.235-.629h10.26Zm-33.172-4.739a9.477 9.477 0 1 1 18.955 0v.088a9.436 9.436 0 0 1-.678 3.52l-2.348 5.87H26.721l-2.348-5.87a9.432 9.432 0 0 1-.678-3.52v-.088Zm-14.217 4.74h10.26c.073.21.152.42.235.628l3.633 9.082c.154.387.3.782.43 1.177l1.07 3.207a7.097 7.097 0 0 0 5.697 4.781v16.671a11.786 11.786 0 0 0-7.108-2.375H9.478V66.346Z"
    />
    <path
      fill="#000"
      d="M45.02 82.934a2.37 2.37 0 0 0 2.37 2.37h2.37a2.37 2.37 0 1 0 0-4.74h-2.37a2.37 2.37 0 0 0-2.37 2.37ZM49.759 90.043h-7.108a2.37 2.37 0 1 0 0 4.739h7.108a2.37 2.37 0 0 0 0-4.739ZM16.587 85.303h2.37a2.37 2.37 0 1 0 0-4.739h-2.37a2.37 2.37 0 1 0 0 4.74ZM28.434 92.412a2.37 2.37 0 0 0-2.369-2.369h-9.478a2.37 2.37 0 1 0 0 4.739h9.478a2.37 2.37 0 0 0 2.37-2.37ZM9.747 56.751a2.367 2.367 0 0 0 2.987-1.517A66.559 66.559 0 0 1 48.37 15.407a2.37 2.37 0 0 0-1.963-4.313A71.307 71.307 0 0 0 8.23 53.764a2.37 2.37 0 0 0 1.518 2.987ZM46.083 135.15a66.43 66.43 0 0 1-27.455-25.68 2.37 2.37 0 0 0-4.083 2.406 71.15 71.15 0 0 0 29.411 27.509 2.37 2.37 0 0 0 2.127-4.235ZM138.328 104.512a2.37 2.37 0 0 0-3.181 1.053 66.93 66.93 0 0 1-29.904 29.744 2.364 2.364 0 0 0-1.315 2.283 2.379 2.379 0 0 0 .806 1.626 2.363 2.363 0 0 0 2.613.337 71.7 71.7 0 0 0 32.034-31.862 2.376 2.376 0 0 0-.324-2.613 2.356 2.356 0 0 0-.729-.568ZM103.271 15.412a66.681 66.681 0 0 1 32.031 30.998 2.372 2.372 0 0 0 3.175 1.071 2.366 2.366 0 0 0 1.071-3.175A71.434 71.434 0 0 0 105.235 11.1a2.371 2.371 0 0 0-3.136 1.175 2.37 2.37 0 0 0 1.172 3.137Z"
    />
  </svg>
);

export const CivicEngagement = ({
  width = 152,
  height = 152,
  ...restOfProps
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    fill="none"
    {...restOfProps}
  >
    <g fill="#000" clipPath="url(#a)">
      <path d="M59.83 70.877a2.221 2.221 0 0 0-2.222 2.221v4.077a2.221 2.221 0 0 0 4.443 0v-4.077a2.221 2.221 0 0 0-2.221-2.221ZM70.492 70.877a2.221 2.221 0 0 0-2.222 2.221v4.077a2.221 2.221 0 0 0 4.443 0v-4.077a2.221 2.221 0 0 0-2.221-2.221ZM91.816 70.877a2.221 2.221 0 0 0-2.221 2.221v4.077a2.221 2.221 0 0 0 4.442 0v-4.077a2.221 2.221 0 0 0-2.22-2.221ZM81.153 70.877a2.221 2.221 0 0 0-2.221 2.221v4.077a2.221 2.221 0 0 0 4.442 0v-4.077a2.221 2.221 0 0 0-2.221-2.221ZM135.176 117.309h-5.573a2.22 2.22 0 1 0 0 4.442h5.573a2.22 2.22 0 1 0 0-4.442ZM135.176 127.973h-5.573a2.22 2.22 0 1 0 0 4.442h5.573a2.22 2.22 0 1 0 0-4.442ZM22.358 117.309h-5.573a2.221 2.221 0 1 0 0 4.442h5.573a2.221 2.221 0 1 0 0-4.442ZM22.358 127.973h-5.573a2.221 2.221 0 1 0 0 4.442h5.573a2.221 2.221 0 1 0 0-4.442ZM65.16 99.64a2.221 2.221 0 0 0-2.22 2.222v30.903a2.22 2.22 0 1 0 4.442 0v-30.903a2.22 2.22 0 0 0-2.221-2.221ZM54.497 99.64a2.221 2.221 0 0 0-2.222 2.222v30.903a2.221 2.221 0 1 0 4.443 0v-30.903a2.221 2.221 0 0 0-2.221-2.221ZM43.835 99.64a2.221 2.221 0 0 0-2.222 2.222v30.903a2.221 2.221 0 1 0 4.443 0v-30.903a2.221 2.221 0 0 0-2.221-2.221ZM107.811 99.64a2.22 2.22 0 0 0-2.221 2.222v30.903a2.22 2.22 0 1 0 4.443 0v-30.903a2.222 2.222 0 0 0-2.222-2.221ZM97.147 99.64a2.221 2.221 0 0 0-2.221 2.222v30.903a2.221 2.221 0 1 0 4.442 0v-30.903a2.221 2.221 0 0 0-2.22-2.221ZM86.484 99.64a2.221 2.221 0 0 0-2.221 2.222v30.903a2.221 2.221 0 1 0 4.442 0v-30.903a2.221 2.221 0 0 0-2.221-2.221ZM75.822 99.64a2.221 2.221 0 0 0-2.221 2.222v30.903a2.221 2.221 0 1 0 4.442 0v-30.903a2.221 2.221 0 0 0-2.221-2.221Z" />
      <path d="M145.447 138.455v-27.197a6.609 6.609 0 0 0 6.197-6.588 6.61 6.61 0 0 0-6.602-6.603h-21.898v-2.919c3.247-.412 5.767-3.19 5.767-6.547a6.61 6.61 0 0 0-6.602-6.602h-15.675V68.098c3.126-.52 5.518-3.241 5.518-6.512 0-3.297-2.431-6.038-5.594-6.525a30.612 30.612 0 0 0-5.189-15.087 2.222 2.222 0 0 0-3.681 2.488 26.19 26.19 0 0 1 4.411 12.522H49.546c1.694-20.217 24.762-30.94 41.303-19.448a2.222 2.222 0 0 0 2.535-3.648 30.59 30.59 0 0 0-15.34-5.413V22.8h13.65a5.782 5.782 0 0 0 5.775-5.776V9.308a5.782 5.782 0 0 0-5.776-5.776h-13.65V2.223a2.221 2.221 0 1 0-4.443 0v24.25C58.352 27.565 46.14 39.801 45.087 55.06c-3.163.487-5.593 3.228-5.593 6.525 0 3.271 2.391 5.993 5.517 6.512v13.9H29.336a6.61 6.61 0 0 0-6.602 6.603c0 3.357 2.52 6.136 5.767 6.547v2.92h-6.332a2.221 2.221 0 1 0 0 4.442H28.5v4.319H6.602c-1.19 0-2.159-.969-2.159-2.159 0-1.191.969-2.159 2.16-2.159h5.199a2.222 2.222 0 0 0 0-4.443h-5.2A6.61 6.61 0 0 0 0 104.669c0 3.505 2.745 6.379 6.198 6.589v27.197c-3.453.21-6.198 3.084-6.198 6.589a6.61 6.61 0 0 0 6.602 6.602h109.136a2.221 2.221 0 1 0 0-4.442H6.602c-1.19 0-2.159-.969-2.159-2.16 0-1.191.969-2.159 2.16-2.159h138.439c1.191 0 2.159.969 2.159 2.159 0 1.191-.969 2.16-2.159 2.16h-18.937a2.22 2.22 0 1 0 0 4.442h18.937a6.61 6.61 0 0 0 6.602-6.602c0-3.505-2.745-6.379-6.197-6.589ZM78.043 7.975h13.65c.723 0 1.333.61 1.333 1.333v7.716a1.35 1.35 0 0 1-1.332 1.333h-13.65V7.975ZM28.5 138.441H10.64v-27.169H28.5v27.169Zm15.436-76.856c0-1.19.968-2.159 2.16-2.159H105.547c1.191 0 2.16.97 2.16 2.16 0 1.19-.969 2.159-2.16 2.159H46.095c-1.19 0-2.159-.968-2.159-2.16Zm58.255 6.603v13.81H49.453v-13.81h52.738Zm16.509 70.253H32.943V95.203h85.758l-.001 43.238ZM29.336 90.76c-1.19 0-2.16-.969-2.16-2.16 0-1.19.969-2.159 2.16-2.159h92.973c1.191 0 2.159.97 2.159 2.16 0 1.19-.969 2.159-2.159 2.159H29.336Zm111.668 47.681h-17.861v-27.169h17.861v27.169Zm-17.861-31.612v-4.319h21.899c1.191 0 2.159.969 2.159 2.159 0 1.191-.969 2.16-2.159 2.16h-21.899Z" />
    </g>
    <defs>
      <clipPath id="a">
        <path fill="#fff" d="M0 0h151.644v151.644H0z" />
      </clipPath>
    </defs>
  </svg>
);

export const ClimateAction = ({
  width = 143,
  height = 143,
  ...restOfProps
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    fill="none"
    {...restOfProps}
  >
    <path
      fill="#000"
      d="M140.728 17.235c-2.054-6.46-4.838-11.084-4.956-11.279a2.124 2.124 0 0 0-2.247-.948c-.221.05-5.477 1.277-11.541 4.306-8.186 4.087-13.904 9.543-16.539 15.776-2.192 5.19-2.507 11.536-.951 18.546a59.066 59.066 0 0 0-11.106-9.664c-1.24-2.45-4.521-8.486-9.65-14.793-1.69-2.077-4.94.529-3.233 2.626 3.457 4.251 6.058 8.432 7.685 11.304l-18.97-3.698L51.194 4.826c1.75.024 3.506.193 5.254.536 5.54 1.085 11.013 3.907 16.269 8.386 2.059 1.755 4.733-1.44 2.701-3.171-5.806-4.948-11.919-8.078-18.17-9.303-9.542-1.867-20.672.584-32.188 7.092-8.583 4.85-14.323 10.178-14.563 10.402-.768.718-.89 2.021-.247 2.86.842 1.726 4.031 7.956 9.34 14.662 3.13 3.954 6.431 7.338 9.846 10.12a49.3 49.3 0 0 0-2.828 2.557c-4.88 4.774-8.616 10.404-11.07 16.56a48.09 48.09 0 0 0-3.4 17.32c-.107 9.862 2.75 19.373 8.266 27.507 5.388 7.945 12.92 14.045 21.78 17.64 2.48 1.004 4.048-2.853 1.567-3.86a43.966 43.966 0 0 1-9.009-4.955c.356-1.974 1.181-9.075-3.536-16.426-.66-1.028 1.314-5.067 2.492-7.48 1.217-2.485 2.472-5.055 3.059-7.475.623-2.571-.078-4.73-2.026-6.243-1.43-1.112-3.302-1.687-4.951-2.195-1.072-.33-2.287-.703-2.72-1.065-.894-.749-2.354-3.516-3.527-5.738-1.302-2.465-2.54-4.811-3.806-6.256 2.847-6.761 7.42-12.744 13.147-17.322 5.231 3.564 11.202 6.023 17.549 6.521-7.36 5.703-9.741 12.986-6.338 19.981 3.974 8.169 12.154 6.864 19.37 5.714 1.25-.2 2.541-.405 3.779-.56.464-.058.604.07.697.152 1.58 1.405 1.534 8.119 1.5 13.021-.046 6.782-.09 13.187 2.436 16.476 1.289 1.676 3.103 2.533 5.23 2.533 1.275 0 2.66-.307 4.112-.93 6.282-2.69 12.811-10.785 11.815-17.19-.87-5.601-1.447-9.301-.089-12.284 1.256-2.76 4.291-5.315 10.269-8.576a43.974 43.974 0 0 1 1.04 10.018c-.128 11.743-4.822 22.735-13.218 30.948-9.382 9.178-22.569 13.711-35.613 12.274-2.658-.288-3.117 3.847-.456 4.14 14.279 1.573 28.715-3.391 38.981-13.436 9.192-8.992 14.331-21.024 14.471-33.882.185-17.048-8.562-32.151-21.878-40.852a81.24 81.24 0 0 0 5.938-4.643 55.424 55.424 0 0 1 12.744 12.773c8.601 12.003 12.012 26.635 9.606 41.204-4.967 30.074-33.474 50.503-63.554 45.533-14.57-2.406-27.33-10.34-35.93-22.343-8.602-12.003-12.013-26.637-9.607-41.205.432-2.621-3.675-3.31-4.108-.678-2.589 15.666 1.08 31.402 10.328 44.31 9.249 12.905 22.972 21.438 38.639 24.027 3.276.54 6.556.808 9.813.808 12.313 0 24.291-3.824 34.498-11.138 12.909-9.249 21.443-22.969 24.03-38.635 1.896-11.48.429-22.998-4.129-33.412a59.938 59.938 0 0 0 9.603-3.782c8.185-4.087 13.904-9.543 16.537-15.776 2.636-6.235 2.563-14.138-.212-22.855ZM19.85 74.501c1.55 2.938 3.015 5.715 4.538 6.988 1.078.902 2.58 1.364 4.168 1.852 4.07 1.251 4.544 1.866 4.153 3.475-.479 1.98-1.635 4.343-2.751 6.628-2.151 4.401-4.183 8.556-2.257 11.558a19.807 19.807 0 0 1 3.151 11.05c-12.405-11.185-17.456-28.853-12.835-44.911.613 1.05 1.256 2.27 1.833 3.36Zm100.763-40.928-5.919-14.343c2.88-2.694 6.222-4.72 9.068-6.148a55.564 55.564 0 0 1 6.581-2.77l-9.73 23.261Zm13.569-21.647a55.833 55.833 0 0 1 2.605 6.66c.898 2.842 1.723 6.365 1.887 10.04l-13.871 5.722 9.379-22.422Zm-24.9 14.785a19.827 19.827 0 0 1 2.325-4.042l6.738 16.326-6.046 14.458a55.27 55.27 0 0 1-2.699-6.859c-1.703-5.384-3.14-13.206-.318-19.883Zm13.342 25.386a55.274 55.274 0 0 1-6.373 2.698l6.275-15 15.971-6.59c-.232 1.789-.674 3.562-1.393 5.263-2.821 6.677-9.431 11.098-14.48 13.63Zm-75.098-1.185a28.103 28.103 0 0 1-2.178-.52l23.05-16.897 18.98 3.7c-6.914 5.447-23.74 16.874-39.852 13.717Zm-21.065-13.03c-4.93-5.314-8.543-10.994-10.618-14.632l24.153 4.71-13.535 9.922Zm4.265-27.787 10.106 13.783-24.31-4.738c3.061-2.417 8.113-6.045 14.204-9.045Zm16.131 14.958L34.606 8.342c3.668-1.507 7.605-2.694 11.64-3.221l16.949 23.116-16.338-3.184Zm-1.296 3.99 17.273 3.367-22.169 16.25c-4.18-1.93-7.943-4.706-11.235-7.792l16.13-11.824Zm56.512 40.67c-7.508 4-11.184 7.143-12.928 10.976-1.874 4.115-1.188 8.533-.237 14.647.561 3.605-3.724 10.318-9.338 12.723-2.077.889-3.557.784-4.4-.313-1.654-2.154-1.609-8.672-1.573-13.909.05-7.245.093-13.502-2.897-16.162-1.075-.956-2.45-1.36-3.978-1.173-1.31.163-2.638.375-3.921.58-7.656 1.22-12.474 1.708-14.97-3.423-4.043-8.31 4.142-14.466 7.85-16.726a13.196 13.196 0 0 0 2.105-1.606c8.96-1.07 17.425-4.915 24.969-9.73 9.045 5.404 15.988 13.956 19.318 24.117Z"
    />
  </svg>
);

export const CommunityPowerAndAdvocacy = ({
  width = 152,
  height = 152,
  ...restOfProps
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    fill="none"
    {...restOfProps}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      strokeWidth={4.443}
      d="M122.338 56.279a6.058 6.058 0 0 1-4.596 2.1c-3.348 0-6.061-2.7-6.061-6.032V30.179c0-3.332 2.713-6.033 6.061-6.033 3.347 0 6.061 2.7 6.061 6.033v16.726"
    />
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      strokeWidth={4.443}
      d="M135.911 47.355h-12.114c-.003 0-.004-.001-.004-.003V32.175a6.05 6.05 0 0 1 6.05-6.05h.023a6.05 6.05 0 0 1 6.049 6.05v15.177c0 .002-.001.004-.004.004ZM95.626 107.814v-7.456c0-4.418-1.675-8.367-4.091-11.987a25.537 25.537 0 0 1-4.092-13.86v-9.79M95.623 149.412V119.35"
    />
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      strokeWidth={4.443}
      d="M118.321 82.274c0-10.075 8.209-18.243 18.335-18.243v-4.623h-6.14c-5.606 0-10.15-4.522-10.15-10.1 0-1.083.883-1.961 1.972-1.961h21.023c3.348 0 6.061 2.7 6.061 6.03v9.48a27.636 27.636 0 0 1-8.155 19.591l-4.915 4.89a18.098 18.098 0 0 0-5.34 12.829v49.245M99.568 47.789a6.043 6.043 0 0 1-2.601 4.97"
    />
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      strokeWidth={4.443}
      d="M105.636 56.713h-.023a6.05 6.05 0 0 1-6.05-6.05V32.185a6.05 6.05 0 0 1 6.05-6.05h.023a6.05 6.05 0 0 1 6.05 6.05v18.478a6.05 6.05 0 0 1-6.05 6.05ZM72.46 34.351a6.06 6.06 0 0 1-4.597 2.1c-3.348 0-6.061-2.7-6.061-6.032V8.251c0-3.331 2.713-6.032 6.06-6.032 3.349 0 6.062 2.7 6.062 6.032v16.726"
    />
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      strokeWidth={4.443}
      d="M86.04 25.438H73.926c-.003 0-.004-.002-.004-.004V10.257a6.05 6.05 0 0 1 6.05-6.05h.023a6.05 6.05 0 0 1 6.05 6.05v15.177a.004.004 0 0 1-.005.003ZM37.571 50.809V21.618M68.442 60.369c0-10.076 8.21-18.243 18.335-18.243v-4.624h-6.14c-5.606 0-10.15-4.521-10.15-10.099 0-1.084.883-1.962 1.972-1.962h21.023c3.348 0 6.061 2.7 6.061 6.03v9.48a27.636 27.636 0 0 1-8.155 19.592l-4.915 4.89a18.096 18.096 0 0 0-5.34 12.828v71.165M43.644 31.924h-.023a6.05 6.05 0 0 1-6.05-6.05V13.125a6.05 6.05 0 0 1 6.05-6.05h.023a6.05 6.05 0 0 1 6.05 6.05v12.749a6.05 6.05 0 0 1-6.05 6.05Z"
    />
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      strokeWidth={4.443}
      d="M55.757 34.785h-.023a6.05 6.05 0 0 1-6.05-6.05V10.257a6.05 6.05 0 0 1 6.05-6.05h.023a6.05 6.05 0 0 1 6.05 6.05v18.478a6.05 6.05 0 0 1-6.05 6.05ZM26.45 58.441c0-1.542-.173-3.22.082-4.752.73-4.391 6.044-6.486 9.602-3.843 2.27 1.685 2.438 4.12 2.438 6.67v14.892M37.107 80.79c-2.64 3.05-7.64 2.654-9.76-.773-.945-1.527-.897-3.157-.897-4.86v-3.325"
    />
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      strokeWidth={4.443}
      d="M50.688 71.871H38.573a.004.004 0 0 1-.004-.004V56.691a6.05 6.05 0 0 1 6.05-6.05h.023a6.05 6.05 0 0 1 6.05 6.05v15.176a.004.004 0 0 1-.004.004ZM10.4 149.426v-24.561c0-4.417-1.676-8.367-4.092-11.987a25.535 25.535 0 0 1-4.091-13.86V68.05"
    />
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      strokeWidth={4.443}
      d="M33.093 106.784c0-10.076 8.209-18.243 18.335-18.243v-4.624h-6.14c-5.606 0-10.15-4.521-10.15-10.099 0-1.084.882-1.962 1.971-1.962h21.023c3.348 0 6.062 2.7 6.062 6.03v9.48a27.637 27.637 0 0 1-8.156 19.592l-4.914 4.89a18.094 18.094 0 0 0-5.34 12.828v24.736M8.29 78.352h-.024a6.05 6.05 0 0 1-6.05-6.05v-12.75a6.05 6.05 0 0 1 6.05-6.05h.023a6.05 6.05 0 0 1 6.05 6.05v12.75a6.05 6.05 0 0 1-6.05 6.05Z"
    />
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      strokeWidth={4.443}
      d="M26.356 59.233c.034 0 .067.004.1.005v-2.555a6.05 6.05 0 0 0-6.05-6.05h-.022a6.05 6.05 0 0 0-6.05 6.05v18.478a6.05 6.05 0 0 0 6.05 6.05h.023a6.05 6.05 0 0 0 6.05-6.05v-4.084c-.034 0-.067.003-.1.003"
    />
  </svg>
);

const DisasterRelief = ({ width = 150, height = 150, ...restOfProps }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    fill="none"
    {...restOfProps}
  >
    <g fill="#000" clipPath="url(#a)">
      <path d="M80.431 1.043a14.654 14.654 0 0 0-10.86 0L0 19.922v110.15l69.569 18.876a14.482 14.482 0 0 0 5.431 1.05c1.873 0 3.7-.353 5.431-1.05L150 130.072V19.922L80.431 1.043Zm64.73 22.578v48.956H77.419V5.18c.443.113.886.22 1.312.394l66.43 18.046ZM70.979 5.677l.293-.102c.423-.174.866-.28 1.309-.394v67.396h-9.678V48.383h8.26L44.55 21.77c-3.119-3.121-8.562-3.121-11.68 0L6.255 48.383h8.26v24.194H4.839V23.62l66.14-17.944ZM17.937 43.544 36.29 25.191c1.273-1.273 3.566-1.273 4.839 0l18.353 18.353H17.937Zm7.515 4.839 7.599 9.498-4.493 4.493-3.278-1.64-2.165 4.328 6.399 3.198 8.018-8.017 7.7-1.926 6.29 6.29 3.422-3.42-8.226-8.226-9.5 2.373-5.563-6.953h26.41v24.193h-38.71V48.381h6.097v.002Zm-20.613 77.99V77.415H72.58v67.396c-.44-.113-.886-.22-1.31-.394L4.84 126.373Zm74.182 17.945-.295.099c-.424.177-.866.283-1.31.394V77.415h67.743v48.956l-66.138 17.947Z" />
      <path d="M38.71 82.254c-10.783 0-29.032 2.04-29.032 9.677 0 2.804 2.47 4.849 6.116 6.32-.973 1.217-1.278 2.402-1.278 3.358 0 2.823 2.277 4.988 5.77 6.551-.709 1.154-.93 2.25-.93 3.126 0 2.985 2.167 5.294 5.445 6.912-.387.89-.607 1.815-.607 2.765 0 5.427 6.377 9.678 14.516 9.678 8.138 0 14.516-4.251 14.516-9.678 0-.95-.22-1.877-.608-2.765 3.279-1.616 5.447-3.924 5.447-6.912 0-.876-.223-1.974-.932-3.126 3.494-1.563 5.77-3.728 5.77-6.551 0-.956-.305-2.141-1.277-3.358 3.646-1.471 6.116-3.516 6.116-6.32 0-7.638-18.249-9.677-29.032-9.677Zm9.677 38.71c0 2.284-4.137 4.838-9.677 4.838s-9.677-2.555-9.677-4.838c0-.4.142-.777.338-1.121 2.882.738 6.112 1.121 9.34 1.121 3.226 0 6.456-.383 9.338-1.121.196.344.338.721.338 1.121Zm4.84-9.678c0 1.706-5.512 4.839-14.517 4.839-9.005 0-14.516-3.133-14.516-4.839 0-.411.387-.948 1.043-1.485 4.071.997 8.838 1.485 13.473 1.485 4.635 0 9.402-.488 13.473-1.485.656.537 1.043 1.074 1.043 1.485Zm4.838-9.677c0 1.243-6.653 4.838-19.355 4.838-12.702 0-19.355-3.595-19.355-4.838 0-.114.377-.818 2.03-1.701 5.666 1.246 12.3 1.701 17.325 1.701 5.025 0 11.659-.455 17.325-1.701 1.652.883 2.03 1.587 2.03 1.701Zm-19.355-4.84c-14.623 0-23.533-3.214-24.208-4.736.675-1.725 9.585-4.94 24.208-4.94 14.34 0 23.185 3.092 24.16 4.838-.975 1.747-9.82 4.839-24.16 4.839ZM123.387 89.512v-2.42h-2.419c-2.158 0-5.306.67-7.851 2.635-1.65-5.796-6.358-7.473-9.085-7.473h-2.419v2.42c0 4.68-1.548 6.582-3.687 9.215-2.669 3.278-5.99 7.359-5.99 17.397 0 6.576 8.632 14.516 19.355 14.516 10.722 0 19.355-7.94 19.355-14.516 0-6.854-2.185-9.767-4.113-12.338-1.687-2.25-3.146-4.193-3.146-9.436Zm-14.516 29.032c0-1.998 1.381-5.893 2.419-7.052 1.038 1.159 2.42 5.054 2.42 7.052a2.423 2.423 0 0 1-2.42 2.42 2.422 2.422 0 0 1-2.419-2.42Zm9.593.847c.034-.281.084-.556.084-.847 0-2.816-2.262-12.096-7.258-12.096s-7.258 9.28-7.258 12.096c0 .291.054.566.085.847-4.524-2.085-7.343-5.77-7.343-8.105 0-8.317 2.38-11.245 4.904-14.346 1.924-2.367 3.903-4.793 4.551-9.121 1.28.841 2.642 2.646 2.642 6.532v7.258h4.839v-2.42c0-4.642 2.799-6.321 4.969-6.924.501 4.943 2.335 7.391 3.982 9.586 1.687 2.252 3.145 4.192 3.145 9.435 0 2.335-2.818 6.02-7.342 8.105ZM91.931 67.738c3.421 0 5.226-1.81 6.547-3.128 1.185-1.186 1.766-1.71 3.123-1.71 1.357 0 1.938.524 3.124 1.71 1.318 1.318 3.125 3.128 6.549 3.128 3.423 0 5.228-1.81 6.549-3.128 1.185-1.186 1.766-1.71 3.126-1.71 1.362 0 1.947.524 3.135 1.712 1.321 1.319 3.131 3.126 6.554 3.126 3.424 0 5.233-1.807 6.554-3.126 1.188-1.188 1.771-1.713 3.136-1.713v-4.838c-3.424 0-5.233 1.807-6.554 3.125-1.188 1.188-1.771 1.713-3.136 1.713-1.364 0-1.947-.525-3.135-1.713-.506-.503-1.084-1.079-1.793-1.596l8.557-7.326a17.312 17.312 0 0 0 6.056-13.164c0-9.556-7.773-17.33-17.33-17.33h-7.156c-.162 0-.317.02-.477.025-3.189-3.095-7.454-4.863-11.906-4.863h-7.086c-7.78 0-14.11 6.38-14.11 14.223 0 4.164 3.366 7.55 7.503 7.55a7.437 7.437 0 0 0 5.313-2.218l1.333-1.348c1.793 3.119 2.787 6.61 2.787 10.232 0 3.179-.752 6.363-2.173 9.208l-4.088 8.175c-.296.09-.613.145-1.002.145-1.36 0-1.94-.525-3.126-1.71-1.32-1.32-3.126-3.129-6.55-3.129V62.9c1.36 0 1.941.525 3.127 1.71 1.32 1.322 3.128 3.129 6.55 3.129Zm8.727-9.614.689-1.382a25.545 25.545 0 0 0 2.683-11.37c0-1.43-.13-2.843-.365-4.235 1.379 1.474 3.324 2.408 5.497 2.408a7.503 7.503 0 0 0 5.339-2.212l1.629-1.625 1.71 1.71a7.174 7.174 0 0 0 2.826 1.72c-1.554 5.95-9.257 14.923-19.065 14.923-.334 0-.639.031-.943.063ZM135.484 39.1c0 3.654-1.592 7.11-4.369 9.489l-11.141 9.537c-2.797.305-4.391 1.877-5.579 3.063-1.185 1.185-1.766 1.71-3.126 1.71-1.144 0-1.756-.401-2.625-1.229 9.003-3.138 15.77-11.702 16.955-18.508 2.918-.94 5.047-3.65 5.047-6.875h-4.839a2.423 2.423 0 0 1-2.419 2.419h-.414a2.41 2.41 0 0 1-1.713-.709l-5.131-5.131-5.047 5.046a2.7 2.7 0 0 1-1.918.794 2.716 2.716 0 0 1-2.712-2.712c0-5.175 4.209-9.385 9.384-9.385h7.157c6.887 0 12.49 5.603 12.49 12.491Zm-43.848-6.019a2.622 2.622 0 0 1-1.875.786c-1.469 0-2.664-1.217-2.664-2.712 0-5.175 4.16-9.384 9.269-9.384h7.086c2.098 0 4.14.554 5.944 1.558-3.827 1.955-6.66 5.581-7.512 9.921-.036-.034-.084-.046-.121-.082l-5.107-5.158-5.02 5.071Z" />
    </g>
    <defs>
      <clipPath id="a">
        <path fill="#fff" d="M0 0h150v150H0z" />
      </clipPath>
    </defs>
  </svg>
);

const DigitalInclusion = ({ width = 152, height = 152, ...restOfProps }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    fill="none"
    {...restOfProps}
  >
    <g fill="#000" clipPath="url(#a)">
      <path d="M25.272 91.68h20.84a2.66 2.66 0 1 0 0-5.322h-20.84c-11.001 0-19.953-8.95-19.953-19.953a19.896 19.896 0 0 1 17.848-19.84 2.66 2.66 0 0 0 2.183-3.66 18.49 18.49 0 0 1-1.407-7.093c0-10.27 8.355-18.624 18.623-18.624 5.2 0 10.21 2.22 13.74 6.089.568.622 1.389.956 2.235.85a2.651 2.651 0 0 0 2.015-1.286C66.631 12.64 77.308 6.547 89.123 6.547c18.337 0 33.256 14.917 33.256 33.254 0 1.177-.076 2.41-.23 3.77-.09.787.279 1.563.827 2.134.548.57 1.415.85 2.213.805.391-.027.781-.058 1.18-.058 11.003 0 19.953 8.95 19.953 19.953 0 11.004-8.95 19.953-19.953 19.953H95.775a2.66 2.66 0 1 0 0 5.322h30.594c13.937 0 25.275-11.338 25.275-25.275 0-13.5-10.64-24.56-23.972-25.24.018-.462.027-.916.027-1.364 0-21.27-17.305-38.576-38.576-38.576-12.404 0-24.127 6.11-31.331 16.138-4.267-3.524-9.66-5.496-15.226-5.496-13.203 0-23.945 10.741-23.945 23.945 0 2.04.258 4.053.768 6.01C8.133 44.481-.001 54.534-.001 66.404c0 13.937 11.338 25.275 25.273 25.275Z" />
      <path d="M69.17 128.923a2.661 2.661 0 0 0 2.66-2.66v-69.17h21.662c1.19 4.576 5.32 7.98 10.263 7.98 5.868 0 10.642-4.774 10.642-10.641s-4.774-10.643-10.642-10.643c-4.943 0-9.073 3.405-10.263 7.981H69.17a2.66 2.66 0 0 0-2.66 2.661v69.171H13.301v-8.359c4.576-1.189 7.981-5.32 7.981-10.263 0-5.869-4.773-10.643-10.64-10.643-5.869 0-10.643 4.774-10.643 10.643 0 4.943 3.405 9.074 7.981 10.263v11.02a2.66 2.66 0 0 0 2.662 2.66H69.17Zm34.585-79.812a5.326 5.326 0 0 1 5.322 5.32 5.326 5.326 0 0 1-5.322 5.321 5.326 5.326 0 0 1-5.32-5.32 5.326 5.326 0 0 1 5.32-5.32ZM5.319 104.98a5.326 5.326 0 0 1 5.323-5.32 5.326 5.326 0 0 1 5.32 5.32 5.327 5.327 0 0 1-5.32 5.32 5.327 5.327 0 0 1-5.323-5.32Z" />
      <path d="M39.907 104.98a2.66 2.66 0 1 0 0 5.32H58.53a2.66 2.66 0 0 0 2.659-2.661V75.715c0-.623-.218-1.225-.617-1.704L48.92 60.026c1.017-1.63 1.63-3.536 1.63-5.596 0-5.867-4.774-10.64-10.642-10.64-5.867 0-10.641 4.773-10.641 10.64 0 5.868 4.774 10.643 10.64 10.643 1.875 0 3.61-.529 5.141-1.383L55.87 76.677v28.303H39.907Zm-5.32-50.549a5.326 5.326 0 0 1 5.32-5.32 5.326 5.326 0 0 1 5.322 5.32c0 1.03-.308 1.981-.815 2.797a2.64 2.64 0 0 0-.889.481c-.393.326-.621.754-.773 1.203a5.275 5.275 0 0 1-2.845.84 5.326 5.326 0 0 1-5.32-5.32ZM143.663 104.979H87.794V83.318c4.576-1.19 7.982-5.32 7.982-10.265 0-5.867-4.776-10.64-10.643-10.64-5.867 0-10.64 4.773-10.64 10.64 0 4.945 3.403 9.075 7.98 10.265v24.32a2.66 2.66 0 0 0 2.66 2.661h58.53a2.659 2.659 0 0 0 2.659-2.661 2.658 2.658 0 0 0-2.659-2.659Zm-63.85-31.926a5.326 5.326 0 0 1 5.32-5.32 5.326 5.326 0 0 1 5.32 5.32 5.326 5.326 0 0 1-5.32 5.322 5.326 5.326 0 0 1-5.32-5.322ZM141 136.902h-19.739l-9.876-17.282a2.658 2.658 0 0 0-2.309-1.341H85.132a2.661 2.661 0 0 0 0 5.321h22.4l9.876 17.283a2.66 2.66 0 0 0 2.309 1.341H141a2.662 2.662 0 0 0 0-5.322ZM106.418 136.903h-8.359c-1.19-4.576-5.32-7.981-10.263-7.981-4.945 0-9.075 3.405-10.265 7.981H13.303a2.66 2.66 0 0 0 0 5.322h64.228c1.19 4.576 5.32 7.98 10.265 7.98 4.943 0 9.073-3.404 10.263-7.98h8.359a2.662 2.662 0 0 0 0-5.322Zm-18.622 7.982a5.327 5.327 0 0 1-5.322-5.321 5.326 5.326 0 0 1 5.322-5.32 5.325 5.325 0 0 1 5.32 5.32 5.326 5.326 0 0 1-5.32 5.321Z" />
    </g>
    <defs>
      <clipPath id="a">
        <path fill="#fff" d="M0 0h151.644v151.644H0z" />
      </clipPath>
    </defs>
  </svg>
);

export const DisabilityJustice = ({
  width = 152,
  height = 152,
  ...restOfProps
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    fill="none"
    {...restOfProps}
  >
    <g
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      strokeWidth={4.443}
      clipPath="url(#a)"
    >
      <path d="m130.426 143.484-4.033-21.224a7.124 7.124 0 0 1 .756-4.762l19.625-35.683a21.359 21.359 0 0 0 2.646-10.297V41.883a2.865 2.865 0 0 0-2.865-2.864 7.123 7.123 0 0 0-7.105 6.615l-1.812 25.372a4.745 4.745 0 0 1-.786 2.296L132.8 79.38M118.555 100.749l5.73-24.83c.713-3.087-1.633-6.035-4.802-6.035a5.008 5.008 0 0 0-4.603 3.035l-8.698 20.295a40.368 40.368 0 0 0-2.987 20.615l3.489 29.655M21.21 143.484l4.034-21.224a7.123 7.123 0 0 0-.757-4.762L4.862 81.815a21.366 21.366 0 0 1-2.645-10.297V41.883A2.865 2.865 0 0 1 5.08 39.02a7.123 7.123 0 0 1 7.105 6.615L14 71.006c.058.82.329 1.612.785 2.296l4.052 6.078M33.084 100.749l-5.73-24.83c-.713-3.087 1.633-6.035 4.802-6.035a5.008 5.008 0 0 1 4.602 3.035l8.698 20.295a40.363 40.363 0 0 1 2.987 20.615l-3.488 29.655M125.113 61.082c3.28-6.626 5.311-13.748 5.311-21.223 0-17.511-14.196-31.707-31.707-31.707-9.012 0-17.127 3.777-22.9 9.814-5.773-6.037-13.888-9.814-22.9-9.814-17.511 0-31.707 14.196-31.707 31.707 0 7.475 2.031 14.597 5.311 21.223M96.305 94.105c-11.038 8.703-20.487 13.766-20.487 13.766s-9.45-5.063-20.488-13.766" />
    </g>
    <defs>
      <clipPath id="a">
        <path fill="#fff" d="M0 0h151.644v151.644H0z" />
      </clipPath>
    </defs>
  </svg>
);

const Education = ({ width = 152, height = 152, ...restOfProps }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    fill="none"
    {...restOfProps}
  >
    <g fill="#000" clipPath="url(#a)">
      <path d="M145.871 42.003 84.337 15.63a21.719 21.719 0 0 0-17.035.005L5.78 42C2.216 43.528.002 46.886.002 50.763c0 3.875 2.213 7.231 5.775 8.758l7.272 3.117a2.266 2.266 0 0 0-.011.228V97.28c-2.811.95-4.842 3.61-4.842 6.737 0 1.813.683 3.469 1.805 4.727a7.552 7.552 0 0 0-2.234 4.73l-1.742 19.167a4.701 4.701 0 0 0 1.208 3.587 4.698 4.698 0 0 0 3.463 1.527h9.222a4.698 4.698 0 0 0 3.463-1.527 4.7 4.7 0 0 0 1.208-3.587l-1.742-19.167a7.553 7.553 0 0 0-2.234-4.73 7.082 7.082 0 0 0 1.804-4.727c0-3.127-2.03-5.787-4.841-6.737V64.578L29.994 69.9a2.261 2.261 0 0 0-.012.227v17.327c0 7.232 4.952 13.922 13.943 18.838 8.558 4.679 19.886 7.256 31.898 7.256 12.013 0 23.342-2.577 31.899-7.256 8.991-4.916 13.943-11.606 13.943-18.838V70.127c0-.076-.004-.152-.011-.227l24.214-10.378c3.564-1.527 5.778-4.885 5.778-8.762 0-3.875-2.212-7.23-5.775-8.757ZM20.03 133.167c-.045.049-.094.049-.112.049h-9.222c-.019 0-.067 0-.112-.049s-.04-.097-.04-.115l1.743-19.167a3.017 3.017 0 0 1 3.02-2.757 3.017 3.017 0 0 1 3.02 2.757l1.742 19.166a.14.14 0 0 1-.04.116Zm-4.723-26.578a2.575 2.575 0 0 1-2.572-2.572 2.575 2.575 0 0 1 2.572-2.572 2.575 2.575 0 0 1 2.572 2.572 2.575 2.575 0 0 1-2.572 2.572Zm101.82-28.817c0 5.868-4.83 11.598-13.252 15.72a2.27 2.27 0 0 0 1.996 4.075c4.671-2.285 8.413-5.07 11.082-8.167-.851 4.785-4.825 9.31-11.408 12.91-7.901 4.321-18.456 6.7-29.72 6.7-11.266 0-21.82-2.379-29.722-6.7-6.559-3.586-10.529-8.092-11.399-12.858 2.294 2.644 5.39 5.062 9.221 7.157 8.558 4.68 19.887 7.257 31.899 7.257 3.36 0 6.712-.205 9.962-.608a2.269 2.269 0 1 0-.559-4.504c-3.065.38-6.229.573-9.403.573-11.265 0-21.82-2.38-29.721-6.7-7.469-4.083-11.582-9.359-11.582-14.855V71.84l32.79 14.053a21.614 21.614 0 0 0 8.51 1.738c2.907 0 5.816-.58 8.525-1.742l32.781-14.048v5.93ZM144.08 55.35 82.558 81.717a17.16 17.16 0 0 1-13.459.005L22.082 61.57l43.082-7.492c1.937 2.293 5.886 3.795 10.66 3.795 6.815 0 11.953-3.057 11.953-7.111s-5.138-7.11-11.952-7.11c-6.189 0-10.994 2.521-11.824 6.02L14.918 58.21a2.26 2.26 0 0 0-.413.114l-6.94-2.975c-1.894-.81-3.024-2.525-3.024-4.585 0-2.062 1.132-3.778 3.027-4.59L69.09 19.806a17.12 17.12 0 0 1 6.737-1.377c2.294 0 4.587.458 6.722 1.373l61.535 26.372c1.893.812 3.024 2.526 3.024 4.586 0 2.062-1.132 3.778-3.028 4.59Zm-75.67-4.589c0-.66 2.55-2.572 7.414-2.572s7.413 1.911 7.413 2.572-2.549 2.572-7.413 2.572c-4.864 0-7.413-1.91-7.413-2.572Z" />
      <path d="M92.766 101.995c.17 0 .34-.019.513-.058 1.712-.396 3.4-.855 5.014-1.366a2.27 2.27 0 0 0-1.368-4.328 61.28 61.28 0 0 1-4.668 1.271 2.27 2.27 0 0 0 .509 4.481Z" />
    </g>
    <defs>
      <clipPath id="a">
        <path fill="#fff" d="M0 0h151.644v151.644H0z" />
      </clipPath>
    </defs>
  </svg>
);

export const FaithAndSpirituality = ({
  width = 130,
  height = 152,
  ...restOfProps
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    fill="none"
    {...restOfProps}
  >
    <path
      fill="#000"
      d="M128.127 41.379a17.702 17.702 0 0 0 .282-13.632 2.545 2.545 0 0 0-3.296-1.446 17.7 17.7 0 0 0-9.839 9.44 18.102 18.102 0 0 0-.871 2.453 67.392 67.392 0 0 0-11.276-13.761 17.674 17.674 0 0 0 3.276-11.612A17.694 17.694 0 0 0 100.311.623a2.544 2.544 0 0 0-3.59.254c-3.865 4.452-5.12 10.294-3.904 15.645a66.69 66.69 0 0 0-8.73-4.582 2.546 2.546 0 0 0-2.025 4.67 61.674 61.674 0 0 1 17.25 11.224 18.263 18.263 0 0 0-1.628-.195 17.694 17.694 0 0 0-12.941 4.291 2.545 2.545 0 0 0-.261 3.59C88 39.59 92.97 41.675 97.969 41.675c3.647 0 7.309-1.113 10.43-3.375a62.283 62.283 0 0 1 9.247 20.664c-2.206.034-6.212-.49-9.795-4.072a2.708 2.708 0 0 0-.17-.156c-.245-.203-6.079-4.972-13.66-3.246-5.793 1.318-10.818 5.971-14.964 13.847-4.374-3.2-13.723-9.042-23.654-9.042-3.857 0-8.416.876-13.243 1.803-11.417 2.194-25.627 4.924-37.912-2.652a2.544 2.544 0 0 0-3.853 1.79c-.133.893-3.108 22.048 9.87 39.159 7.603 10.025 19.032 16.472 34.015 19.201-3.946 4.073-11.55 10.65-21.004 12.579a2.548 2.548 0 0 0-1.934 3.205c.063.217 1.596 5.369 6.156 10.422 4.089 4.531 11.455 9.843 23.518 9.843.354 0 .713-.005 1.075-.014a2.545 2.545 0 0 0 2.47-2.319c.01-.124 1.218-12.28 12.708-20.702h1.798a43.01 43.01 0 0 0 32.45-14.775 43.006 43.006 0 0 0 10.16-34.177 15.088 15.088 0 0 1 7.077-14.948c.606 4.205.786 8.513.499 12.865a2.545 2.545 0 1 0 5.079.335 66.85 66.85 0 0 0-4.149-27.966 17.677 17.677 0 0 0 7.944-8.565ZM97.481 13.452a12.643 12.643 0 0 1 1.448-6.861 12.638 12.638 0 0 1 2.397 6.59 12.637 12.637 0 0 1-1.447 6.86 12.639 12.639 0 0 1-2.398-6.589ZM90.456 34.15a12.653 12.653 0 0 1 6.86-1.433 12.64 12.64 0 0 1 6.582 2.408 12.765 12.765 0 0 1-13.442-.975Zm16.182 46.21a37.92 37.92 0 0 1-8.96 30.134 37.92 37.92 0 0 1-28.61 13.027h-2.559c-.411-.019-4.084-.226-7.57-1.449a2.544 2.544 0 1 0-1.684 4.803c1.055.37 2.117.661 3.124.891-7.22 6.939-9.695 14.908-10.51 18.772-14.317-.463-20.466-9.59-22.64-14.108 11.922-3.537 20.503-12.817 23.189-16.02a44.51 44.51 0 0 0 1.942.041c5.053 0 14.786-.781 22.05-6.14a2.546 2.546 0 0 0-3.02-4.096c-8.257 6.091-21.153 5.102-21.846 5.043-.238-.03-.472-.063-.707-.095.312-.265.611-.536.888-.812a2.545 2.545 0 1 0-3.6-3.599c-1.154 1.154-3.186 2.397-4.453 3.102a61.13 61.13 0 0 1-8-2.441 17.906 17.906 0 0 0 3.109-1.879 2.544 2.544 0 1 0-3.08-4.052c-2.377 1.807-5.354 2.536-6.72 2.79a42.803 42.803 0 0 1-7.188-5.08c2.278-.372 4.92-1.08 7.434-2.414a2.545 2.545 0 0 0-2.385-4.496c-3.575 1.897-7.656 2.191-9.592 2.213a40.077 40.077 0 0 1-.899-1.133 40.821 40.821 0 0 1-3.875-6.197c1.198.115 2.553.196 3.987.196 2.72 0 5.72-.293 8.462-1.207a2.545 2.545 0 0 0-1.61-4.829c-4.638 1.546-10.561.836-13.168.4a51.174 51.174 0 0 1-2.027-7.585c3.19 1.015 8.064 2.06 14.625 2.06a2.545 2.545 0 0 0 0-5.09c-8.135 0-13.28-1.764-15.4-2.678a58.271 58.271 0 0 1-.187-6.701c12.962 6.17 26.721 3.527 37.963 1.367 4.582-.88 8.91-1.711 12.282-1.711 11.457 0 22.773 9.713 22.885 9.81l.029.022.035.032 8.288 6.753c.473.385 1.041.572 1.606.572a2.545 2.545 0 0 0 1.609-4.518L83.12 68.57c3.47-6.907 7.587-11.08 11.975-12.104 4.762-1.112 8.726 1.724 9.264 2.133 2.637 2.598 5.455 3.998 7.983 4.725a20.18 20.18 0 0 0-5.705 17.036Zm12.355-35.625c-.346-2.338-.03-4.73.943-6.949a12.644 12.644 0 0 1 4.473-5.4c.346 2.338.03 4.731-.943 6.949a12.646 12.646 0 0 1-4.473 5.4Z"
    />
  </svg>
);

export const FraternityAndSororityLife = (props) => (
  <Icon {...props}>
    <svg
      width="150"
      height="150"
      viewBox="0 0 150 150"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16.2207 8.7397L22.4814 3.28768C24.3265 1.67683 27.1294 1.87013 28.7373 3.71822L32.0089 7.47298"
        stroke="black"
        strokeWidth="4.39324"
        stroke-miterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.28729 29.2696L3.31746 25.8575C1.70953 24.0094 1.90283 21.2094 3.75092 19.5986L8.89688 15.1172"
        stroke="black"
        strokeWidth="4.39324"
        stroke-miterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M45.0767 22.4797L37.0225 13.2305"
        stroke="black"
        strokeWidth="4.39324"
        stroke-miterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M21.3468 46.5583L11.9014 35.7129"
        stroke="black"
        strokeWidth="4.39324"
        stroke-miterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M44.1275 87.3533C43.1258 86.9637 42.2032 86.334 41.4564 85.4759L27.2955 69.2179C17.7059 58.2096 18.883 41.5095 29.8934 31.9222L35.8799 26.7089C41.7551 21.5928 48.9381 21.3037 56.1445 24.0144C62.1925 26.2901 68.5686 27.5319 75.0003 27.5817"
        stroke="black"
        strokeWidth="4.39324"
        stroke-miterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M29.9549 8.47327L7.01689 28.4508C5.17993 30.0505 4.9878 32.8364 6.58753 34.6734C8.18725 36.5104 10.9732 36.7025 12.8101 35.1028L35.7481 15.1252C37.5851 13.5255 37.7772 10.7396 36.1775 8.90264C34.5775 7.06567 31.7916 6.87354 29.9549 8.47327Z"
        stroke="black"
        strokeWidth="4.39324"
        stroke-miterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M112.979 13.2305L104.925 22.4797"
        stroke="black"
        strokeWidth="4.39324"
        stroke-miterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M138.1 35.7129L128.654 46.5583"
        stroke="black"
        strokeWidth="4.39324"
        stroke-miterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M141.28 15.2715L146.25 19.5988C148.098 21.2097 148.291 24.0096 146.683 25.8577L143.713 29.2698"
        stroke="black"
        strokeWidth="4.39324"
        stroke-miterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M117.993 7.47298L121.265 3.71822C122.873 1.87013 125.675 1.67683 127.521 3.28768L133.971 8.90518"
        stroke="black"
        strokeWidth="4.39324"
        stroke-miterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M74.3089 44.2349C74.3119 44.2349 74.3119 44.2349 74.3119 44.232L74.675 43.8132C68.1168 43.2617 68.0506 43.3085 67.0279 43.0136C63.4371 41.9797 60.9535 38.5296 61.2727 34.6664C61.6388 30.2703 65.499 27.0046 69.8981 27.3737C71.545 27.5043 72.9757 27.6004 75.0001 27.5816C81.4318 27.5318 87.8079 26.29 93.8559 24.0143C101.061 21.3043 108.244 21.5922 114.12 26.7088L120.107 31.9221C131.119 41.5111 132.291 58.2134 122.705 69.2178L113.813 79.4248"
        stroke="black"
        strokeWidth="4.39324"
        stroke-miterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M120.046 8.47327L142.984 28.4508C144.821 30.0505 145.014 32.8364 143.414 34.6734C141.814 36.5104 139.028 36.7025 137.191 35.1028L114.253 15.1252C112.416 13.5255 112.224 10.7396 113.824 8.90264C115.424 7.06567 118.209 6.87354 120.046 8.47327Z"
        stroke="black"
        strokeWidth="4.39324"
        stroke-miterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M66.1793 147.802H57.486C54.9789 147.802 52.9492 145.244 52.9492 142.089V136.699"
        stroke="black"
        strokeWidth="4.39324"
        stroke-miterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M88.2334 136.699V142.089C88.2334 145.244 86.2008 147.802 83.6937 147.802H75.001"
        stroke="black"
        strokeWidth="4.39324"
        stroke-miterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M88.2334 127.877V116.209"
        stroke="black"
        strokeWidth="4.39324"
        stroke-miterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M52.9492 127.876V112.33"
        stroke="black"
        strokeWidth="4.39324"
        stroke-miterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M113.144 78.3459C110.53 74.7903 105.525 74.0241 101.965 76.6343L97.0323 80.2508V54.0934C97.0323 50.4948 94.2071 47.4529 90.6052 47.3545C86.8683 47.252 83.8065 50.2467 83.8063 53.9558V50.3199C83.8063 46.7213 80.9811 43.6794 77.3792 43.5807C73.642 43.4782 70.5802 46.4732 70.5802 50.1826V57.7304C70.5802 54.0214 67.5187 51.0263 63.7815 51.1286C60.1794 51.2273 57.3542 54.2692 57.3542 57.8678V70.9392C57.3542 67.2301 54.2924 64.2351 50.5552 64.3373C46.9534 64.436 44.1279 67.4779 44.1279 71.0765V92.6392C44.1279 107.229 55.9709 119.056 70.5802 119.056H78.5206C87.4254 119.056 92.6446 113.209 95.5711 107.779C99.51 100.472 104.736 94.4199 111.43 89.5109C114.99 86.9001 115.757 81.9015 113.144 78.3459Z"
        stroke="black"
        strokeWidth="4.39324"
        stroke-miterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M57.3584 71.2109V83.7041"
        stroke="black"
        strokeWidth="4.39324"
        stroke-miterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M70.5898 57.418V79.9316"
        stroke="black"
        strokeWidth="4.39324"
        stroke-miterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M83.8213 54.832V79.3624"
        stroke="black"
        strokeWidth="4.39324"
        stroke-miterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M88.2325 136.698H52.9486C50.5127 136.698 48.5381 134.723 48.5381 132.287C48.5381 129.852 50.5127 127.877 52.9486 127.877H88.2325C90.6684 127.877 92.643 129.852 92.643 132.287C92.6427 134.723 90.6681 136.698 88.2325 136.698Z"
        stroke="black"
        strokeWidth="4.39324"
        stroke-miterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M57.3584 127.877V136.698"
        stroke="black"
        strokeWidth="4.39324"
        stroke-miterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M66.1797 127.877V136.698"
        stroke="black"
        strokeWidth="4.39324"
        stroke-miterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M75.001 127.877V136.698"
        stroke="black"
        strokeWidth="4.39324"
        stroke-miterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M83.8213 127.877V136.698"
        stroke="black"
        strokeWidth="4.39324"
        stroke-miterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  </Icon>
);

const HealthAndWellness = ({ width = 152, height = 127, ...restOfProps }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    fill="none"
    {...restOfProps}
  >
    <path
      fill="#000"
      d="M159.335 60.984h-14.631c6.082-13.809 5.425-24.987 3.123-32.55-3.945-13.48-17.261-28.11-36.987-28.11-5.261 0-10.521.987-15.946 2.96-9.37 3.451-15.617 7.232-18.412 9.205-2.795-1.973-8.877-5.754-18.412-9.206C52.645 1.311 47.22.324 42.125.324c-19.727 0-33.043 14.63-36.988 28.11-2.302 8.056-3.124 20.22 4.603 35.509H-8.014c-1.48 0-2.63 1.15-2.63 2.63s1.15 2.63 2.63 2.63h20.877a34.71 34.71 0 0 0 2.96 4.439C32.918 98.301 70.07 125.096 76.81 126.74v.164s.164 0 .329-.164h.493v-.164c5.753-2.795 41.426-25.81 60.166-53.098 1.809-2.466 3.288-4.932 4.603-7.398h17.261c1.48 0 2.631-1.15 2.631-2.63s-1.48-2.466-2.959-2.466Zm-26.303 9.699c-17.425 25.48-49.481 46.029-56.386 50.468-7.068-4.439-38.96-25.152-56.55-50.468l-.986-1.48h24.165c.987 0 1.973-.493 2.466-1.479l11.014-21.7 17.261 44.221c.329.987 1.48 1.644 2.466 1.644h.165c1.15 0 2.136-.822 2.465-1.972l15.124-51.783 8.055 26.138c.329.986 1.151 1.644 2.137 1.808.987.165 1.973-.329 2.631-1.15l6.411-9.37 5.425 9.205c.493.822 1.315 1.315 2.301 1.315h14.795c-.986 1.644-1.973 3.124-2.959 4.603Zm5.918-9.699h-16.11l-6.74-11.507c-.493-.822-1.315-1.315-2.301-1.315-.987 0-1.809.328-2.302 1.15l-5.589 8.22-9.042-29.426c-.328-1.15-1.48-1.808-2.63-1.973-1.15 0-2.301.822-2.63 1.973l-15.288 52.77-16.604-42.413c-.328-.987-1.315-1.644-2.301-1.644-1.15 0-1.973.493-2.466 1.48L41.96 63.778H15.822c-6.575-12-8.384-23.508-5.425-33.865C13.85 18.243 25.192 5.75 42.29 5.75c4.603 0 9.37.986 14.137 2.63 12.001 4.439 18.412 9.535 18.577 9.535.986.822 2.301.822 3.287 0 0 0 6.412-5.096 18.576-9.535 4.768-1.808 9.535-2.63 14.138-2.63 16.932 0 28.439 12.494 31.892 24.165 2.794 9.535 1.315 20.056-3.946 31.07Z"
    />
  </svg>
);

export const FaternityAndSororityLife = ({
  width = 150,
  height = 150,
  ...restOfProps
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    fill="none"
    {...restOfProps}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      strokeWidth={4.393}
      d="m16.22 8.74 6.261-5.452a4.43 4.43 0 0 1 6.256.43l3.272 3.755M6.287 29.27l-2.97-3.412a4.437 4.437 0 0 1 .434-6.26l5.146-4.48M45.077 22.48l-8.054-9.25M21.347 46.558 11.9 35.713M44.127 87.353a6.804 6.804 0 0 1-2.67-1.877L27.294 69.218c-9.59-11.008-8.412-27.709 2.598-37.296l5.987-5.213c5.875-5.116 13.058-5.405 20.264-2.695C62.194 26.29 68.57 27.532 75 27.582"
    />
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      strokeWidth={4.393}
      d="M29.955 8.473 7.017 28.451a4.41 4.41 0 1 0 5.793 6.652l22.938-19.978a4.41 4.41 0 1 0-5.793-6.652ZM112.979 13.23l-8.054 9.25M138.1 35.713l-9.446 10.845M141.28 15.271l4.97 4.328a4.437 4.437 0 0 1 .433 6.259l-2.97 3.412M117.993 7.473l3.272-3.755a4.43 4.43 0 0 1 6.256-.43l6.45 5.617M74.309 44.235c.003 0 .003 0 .003-.003l.363-.419c-6.558-.551-6.624-.505-7.647-.8-3.59-1.033-6.075-4.483-5.755-8.347a7.983 7.983 0 0 1 8.625-7.292c1.647.13 3.078.226 5.102.208 6.432-.05 12.808-1.292 18.856-3.568 7.205-2.71 14.388-2.422 20.264 2.695l5.987 5.213c11.012 9.59 12.184 26.291 2.598 37.296l-8.892 10.207"
    />
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      strokeWidth={4.393}
      d="m120.046 8.473 22.938 19.978a4.41 4.41 0 1 1-5.793 6.652l-22.938-19.978a4.41 4.41 0 1 1 5.793-6.652ZM66.18 147.802h-8.694c-2.507 0-4.537-2.558-4.537-5.713v-5.39M88.233 136.699v5.39c0 3.155-2.032 5.713-4.54 5.713h-8.692M88.233 127.877v-11.668M52.95 127.876V112.33M113.144 78.346a8.004 8.004 0 0 0-11.179-1.712l-4.933 3.617V54.093c0-3.598-2.825-6.64-6.427-6.739a6.609 6.609 0 0 0-6.799 6.602V50.32c0-3.599-2.825-6.64-6.427-6.74a6.609 6.609 0 0 0-6.799 6.603v7.547a6.609 6.609 0 0 0-6.798-6.601c-3.603.098-6.428 3.14-6.428 6.739v13.071a6.61 6.61 0 0 0-6.799-6.602c-3.602.099-6.427 3.14-6.427 6.74v21.562c0 14.59 11.843 26.417 26.452 26.417h7.94c8.905 0 14.125-5.847 17.051-11.277 3.939-7.307 9.165-13.36 15.859-18.268a7.982 7.982 0 0 0 1.714-11.165ZM57.358 71.21v12.494M70.59 57.418v22.514M83.821 54.832v24.53M88.233 136.698H52.949a4.41 4.41 0 0 1 0-8.821h35.284a4.41 4.41 0 0 1 0 8.821ZM57.358 127.877v8.821M66.18 127.877v8.821M75.001 127.877v8.821M83.821 127.877v8.821"
    />
  </svg>
);

export const Economic1 = ({ width = 150, height = 150, ...restOfProps }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={150}
    height={150}
    fill="none"
    {...restOfProps}
  >
    <path
      fill="#000"
      d="M61.089 55.095H41.346a2.344 2.344 0 0 0-2.343 2.344v63.015a2.344 2.344 0 0 0 2.343 2.344H61.09a2.344 2.344 0 0 0 2.344-2.344V57.439a2.343 2.343 0 0 0-2.344-2.344Zm-2.344 63.015H43.69V59.782h15.055v58.328ZM24.43 79.538H4.688a2.344 2.344 0 0 0-2.344 2.344v38.572a2.343 2.343 0 0 0 2.344 2.343H24.43a2.343 2.343 0 0 0 2.344-2.343V81.882a2.344 2.344 0 0 0-2.344-2.344Zm-2.344 38.572H7.031V84.226h15.055v33.884ZM12.71 62.868a2.344 2.344 0 0 1 .41-3.29l36.659-28.544a2.345 2.345 0 0 1 2.162-.38L87.228 42.09l30.088-30.345-4.321.931a2.345 2.345 0 0 1-.987-4.582l12.034-2.592a2.344 2.344 0 0 1 2.801 2.698l-1.934 10.968a2.344 2.344 0 1 1-4.616-.814l.634-3.593-31.386 31.653a2.345 2.345 0 0 1-2.387.58L51.677 35.496l-35.679 27.78a2.333 2.333 0 0 1-1.438.495c-.698 0-1.389-.31-1.85-.903ZM136.75 87.073V31.541a2.343 2.343 0 0 0-2.343-2.344h-19.743a2.344 2.344 0 0 0-2.344 2.344v47.11a32.737 32.737 0 0 0-12.228 3.315v-16.3a2.344 2.344 0 0 0-2.344-2.343H78.006a2.344 2.344 0 0 0-2.344 2.344v54.787a2.344 2.344 0 0 0 2.344 2.344h5.638c4.606 12.675 16.772 21.754 31.02 21.754 18.192 0 32.992-14.8 32.992-32.992 0-9.706-4.213-18.445-10.906-24.487Zm-4.687-53.188V83.54a32.768 32.768 0 0 0-15.055-4.889V33.885h15.055ZM80.349 118.11v-50.1h15.055v16.78c-8.311 5.996-13.732 15.761-13.732 26.77 0 2.242.226 4.433.654 6.55h-1.977Zm34.315 21.755c-15.608 0-28.305-12.698-28.305-28.305s12.698-28.305 28.305-28.305 28.305 12.698 28.305 28.305-12.698 28.305-28.305 28.305Zm9.794-23.109c.248 2.046-.305 3.918-1.598 5.413-1.331 1.538-3.438 2.616-5.852 3.039v1.161a2.344 2.344 0 0 1-4.688 0v-1.2c-3.717-.754-6.569-3.259-7.438-6.747a2.344 2.344 0 1 1 4.548-1.134c.652 2.612 3.359 3.476 5.484 3.428 1.835-.044 3.604-.692 4.401-1.614.422-.488.577-1.054.489-1.781-.152-1.25-.914-2.78-5.498-3.533-6.949-1.141-8.572-4.773-8.71-7.62-.191-3.92 2.509-7.201 6.724-8.178v-1.24a2.344 2.344 0 0 1 4.688 0v1.219c2.737.602 5.346 2.332 6.707 5.574a2.343 2.343 0 1 1-4.322 1.814c-1.103-2.627-3.802-3.304-5.985-2.808-.544.123-3.253.867-3.13 3.392.032.672.118 2.455 4.787 3.222 5.735.941 8.895 3.496 9.393 7.593Zm-9.794-30.943c-14.197 0-25.747 11.55-25.747 25.747s11.55 25.747 25.747 25.747 25.747-11.55 25.747-25.747-11.55-25.747-25.747-25.747Zm0 46.806c-11.612 0-21.06-9.447-21.06-21.059 0-11.612 9.448-21.06 21.06-21.06 11.612 0 21.059 9.448 21.059 21.06.001 11.612-9.447 21.059-21.059 21.059Z"
    />
  </svg>
);

export const HumanServices = ({
  width = 152,
  height = 152,
  ...restOfProps
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 152 152"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...restOfProps}
  >
    <g clipPath="url(#clip0_2898_32478)">
      <path
        d="M132.144 0C129.555 0.000490988 126.994 0.531103 124.619 1.55913C122.243 2.58716 120.103 4.09082 118.331 5.97743L116.143 8.2673L113.956 5.99259C112.22 4.15151 110.134 2.6756 107.821 1.65144C105.507 0.627272 103.012 0.0754647 100.482 0.0283819C97.9517 -0.0187008 95.4378 0.439889 93.0874 1.37725C90.7371 2.31462 88.5975 3.71188 86.7943 5.4871C82.9782 9.44787 80.8505 14.7366 80.8604 20.2367C80.8703 25.7368 83.017 31.0178 86.8474 34.9648L112.501 61.6269C112.971 62.1168 113.535 62.5067 114.16 62.773C114.785 63.0393 115.457 63.1766 116.136 63.1766C116.815 63.1766 117.488 63.0393 118.112 62.773C118.737 62.5067 119.302 62.1168 119.772 61.6269L145.961 34.4138C149.608 30.5798 151.642 25.4908 151.642 20.1994C151.642 14.908 149.608 9.81895 145.961 5.98501C144.188 4.09759 142.047 2.59296 139.671 1.56368C137.295 0.534407 134.733 0.00226539 132.144 0V0ZM142.319 30.9082L116.143 58.1314L90.4818 31.4693C87.6066 28.4701 85.9867 24.4852 85.9538 20.3306C85.9209 16.1759 87.4775 12.1659 90.3049 9.12158C92.9202 6.54165 96.4427 5.08982 100.116 5.07765C102.023 5.07234 103.911 5.46011 105.661 6.21677C107.411 6.97342 108.987 8.08272 110.289 9.47542L112.49 11.7653C113.457 12.7255 114.764 13.2643 116.126 13.2643C117.488 13.2643 118.795 12.7255 119.762 11.7653L121.973 9.46784C123.274 8.07256 124.848 6.95991 126.597 6.19915C128.346 5.43839 130.234 5.0458 132.141 5.0458C134.049 5.0458 135.936 5.43839 137.685 6.19915C139.434 6.95991 141.008 8.07256 142.309 9.46784C145.051 12.3603 146.58 16.1944 146.58 20.1804C146.58 24.1664 145.051 28.0006 142.309 30.8931L142.319 30.9082Z"
        fill="black"
      />
      <path
        d="M129.87 96.0458C128.027 96.0478 126.194 96.3282 124.434 96.8773C125.383 92.4751 127.549 88.4276 130.684 85.1954C131.145 84.7187 131.399 84.0803 131.394 83.4176C131.388 82.7549 131.122 82.121 130.654 81.6524C130.185 81.1838 129.551 80.918 128.888 80.9122C128.226 80.9064 127.587 81.1612 127.111 81.6216C124.655 84.0934 122.688 87.0074 121.315 90.2099C119.934 88.1209 118.057 86.4065 115.852 85.2197C113.647 84.0329 111.182 83.4106 108.678 83.4085H101.096C100.426 83.4085 99.7828 83.6748 99.3088 84.1488C98.8348 84.6228 98.5685 85.2656 98.5685 85.936V88.4634C98.5671 92.0704 99.8634 95.5575 102.221 98.2876C95.1161 101.72 90.9863 108.936 90.9863 118.793C90.9863 133.988 100.499 151.65 112.76 151.65C115.754 151.642 118.697 150.876 121.315 149.423C123.933 150.876 126.876 151.642 129.87 151.65C142.131 151.65 151.644 133.988 151.644 118.793C151.644 104.76 143.304 96.0458 129.87 96.0458ZM103.623 88.4634H108.678C111.083 88.4719 113.406 89.3374 115.23 90.9045C117.054 92.4716 118.26 94.6377 118.631 97.0138C116.74 96.3712 114.757 96.0441 112.76 96.0458C111.051 96.043 109.345 96.2004 107.665 96.5159C106.41 95.582 105.39 94.3674 104.689 92.9692C103.987 91.5709 103.622 90.0279 103.623 88.4634ZM129.87 146.595C127.32 146.579 124.831 145.804 122.723 144.368C122.307 144.089 121.817 143.94 121.315 143.94C120.814 143.94 120.324 144.089 119.907 144.368C117.799 145.804 115.311 146.579 112.76 146.595C103.757 146.595 96.0411 131.306 96.0411 118.793C96.0411 107.551 102.135 101.101 112.76 101.101C115.3 101.064 117.791 101.796 119.907 103.201C120.002 103.252 120.1 103.298 120.201 103.337C120.274 103.377 120.349 103.412 120.426 103.444C120.996 103.658 121.625 103.658 122.195 103.444C122.367 103.359 122.54 103.275 122.713 103.191C124.833 101.787 127.328 101.059 129.87 101.101C140.496 101.101 146.589 107.551 146.589 118.793C146.589 131.306 138.873 146.595 129.87 146.595Z"
        fill="black"
      />
      <path
        d="M12.6346 63.1863H58.1279C60.1388 63.1863 62.0674 62.3875 63.4893 60.9655C64.9113 59.5435 65.7101 57.6149 65.7101 55.604V25.2745C66.5718 25.2743 67.4191 25.0538 68.1715 24.634C68.924 24.2142 69.5566 23.609 70.0094 22.8759C70.4622 22.1428 70.72 21.3061 70.7585 20.4453C70.7969 19.5845 70.6147 18.7281 70.2291 17.9576L62.6469 2.79286C62.2296 1.95177 61.5851 1.24435 60.7865 0.750746C59.9878 0.257142 59.0668 -0.00291911 58.1279 2.4718e-05H12.6346C11.6958 -0.00262533 10.7749 0.257557 9.97631 0.751128C9.17768 1.2447 8.53314 1.95195 8.11562 2.79286L0.533399 17.9576C0.147814 18.7281 -0.0343989 19.5845 0.00406253 20.4453C0.0425239 21.3061 0.300383 22.1428 0.753154 22.8759C1.20592 23.609 1.83857 24.2142 2.59103 24.634C3.34348 25.0538 4.19076 25.2743 5.0524 25.2745V55.604C5.0524 57.6149 5.85124 59.5435 7.27318 60.9655C8.69512 62.3875 10.6237 63.1863 12.6346 63.1863ZM20.2168 58.1314V35.3844H27.799V58.1314H20.2168ZM58.1279 58.1314H32.8539V35.3844C32.8539 34.0437 32.3213 32.758 31.3733 31.81C30.4254 30.862 29.1397 30.3295 27.799 30.3295H20.2168C18.8762 30.3295 17.5905 30.862 16.6425 31.81C15.6946 32.758 15.162 34.0437 15.162 35.3844V58.1314H12.6346C11.9643 58.1314 11.3215 57.8651 10.8475 57.3912C10.3735 56.9172 10.1072 56.2743 10.1072 55.604V25.2745H60.6553V55.604C60.6553 56.2743 60.389 56.9172 59.9151 57.3912C59.4411 57.8651 58.7982 58.1314 58.1279 58.1314ZM12.6346 5.05493H58.1279L65.7101 20.2196H5.0524L12.6346 5.05493Z"
        fill="black"
      />
      <path
        d="M50.5472 30.3203H42.965C41.6243 30.3203 40.3386 30.8529 39.3907 31.8009C38.4427 32.7488 37.9102 34.0346 37.9102 35.3752V45.485C37.9102 46.8257 38.4427 48.1114 39.3907 49.0594C40.3386 50.0074 41.6243 50.5399 42.965 50.5399H50.5472C51.8878 50.5399 53.1735 50.0074 54.1215 49.0594C55.0694 48.1114 55.602 46.8257 55.602 45.485V35.3752C55.602 34.0346 55.0694 32.7488 54.1215 31.8009C53.1735 30.8529 51.8878 30.3203 50.5472 30.3203ZM42.965 45.485V35.3752H50.5472V45.485H42.965Z"
        fill="black"
      />
      <path
        d="M0.0920298 116.547C0.215169 117.208 0.469956 117.836 0.841208 118.396C1.21246 118.956 1.69258 119.435 2.25296 119.805L15.163 128.505V146.596C15.163 147.937 15.6955 149.223 16.6435 150.171C17.5914 151.119 18.8771 151.651 20.2178 151.651H50.5466C51.8873 151.651 53.173 151.119 54.1209 150.171C55.0689 149.223 55.6014 147.937 55.6014 146.596V128.505L68.5038 119.805C69.0665 119.433 69.5488 118.952 69.9225 118.39C70.2962 117.828 70.5536 117.197 70.6796 116.534C70.8057 115.871 70.7977 115.19 70.6562 114.53C70.5148 113.871 70.2427 113.246 69.856 112.693L55.1516 91.6646C54.4457 90.6787 53.5158 89.8745 52.4384 89.3183C51.361 88.762 50.1669 88.4695 48.9544 88.4648H45.1633C44.0305 88.4758 42.9335 88.8628 42.0446 89.565C41.1557 90.2673 40.5253 91.245 40.2525 92.3445C39.9591 93.4121 39.3233 94.3539 38.4427 95.0251C37.5622 95.6963 36.4856 96.0599 35.3784 96.0599C34.2712 96.0599 33.1946 95.6963 32.3141 95.0251C31.4335 94.3539 30.7977 93.4121 30.5043 92.3445C30.2321 91.2456 29.6026 90.2683 28.7147 89.566C27.8267 88.8638 26.7306 88.4765 25.5986 88.4648H21.81C20.5926 88.471 19.3941 88.7667 18.3134 89.3274C17.2328 89.8882 16.3011 90.698 15.5951 91.6899L0.903327 112.703C0.517585 113.257 0.247005 113.883 0.107642 114.543C-0.0317224 115.203 -0.0370313 115.885 0.0920298 116.547ZM19.7123 94.6141C19.9499 94.2782 20.2641 94.0038 20.6289 93.8135C20.9937 93.6231 21.3986 93.5225 21.81 93.5197L25.634 93.679C26.2268 95.8248 27.5113 97.715 29.2882 99.0562C31.065 100.397 33.2349 101.114 35.461 101.096C37.6871 101.078 39.845 100.326 41.5998 98.9558C43.3545 97.5858 44.608 95.675 45.1658 93.5197H48.9569C49.3621 93.5223 49.761 93.6205 50.1211 93.8063C50.4812 93.9921 50.7924 94.2602 51.0294 94.5889L65.7111 115.602L67.1037 117.713L65.6908 115.617L55.6014 122.409V116.267C55.6014 115.596 55.3352 114.954 54.8612 114.48C54.3872 114.006 53.7443 113.739 53.074 113.739C52.4037 113.739 51.7609 114.006 51.2869 114.48C50.8129 114.954 50.5466 115.596 50.5466 116.267V146.596H20.2178V116.267C20.2178 115.596 19.9515 114.954 19.4775 114.48C19.0035 114.006 18.3607 113.739 17.6904 113.739C17.02 113.739 16.3772 114.006 15.9032 114.48C15.4292 114.954 15.163 115.596 15.163 116.267V122.409L5.05333 115.584L19.7123 94.6141Z"
        fill="black"
      />
      <path
        d="M107.838 128.039C107.6 127.421 107.129 126.922 106.526 126.648C105.924 126.375 105.238 126.348 104.616 126.574C103.994 126.801 103.486 127.262 103.2 127.859C102.915 128.456 102.875 129.141 103.089 129.768C103.322 130.407 103.569 131.031 103.83 131.62C104.098 132.235 104.599 132.718 105.223 132.963C105.848 133.208 106.544 133.195 107.158 132.927C107.773 132.659 108.256 132.158 108.501 131.533C108.746 130.909 108.733 130.213 108.465 129.598C108.245 129.1 108.035 128.58 107.838 128.039Z"
        fill="black"
      />
      <path
        d="M111.202 106.152C105.627 106.152 101.093 111.821 101.093 118.79C101.093 119.46 101.359 120.103 101.833 120.577C102.307 121.051 102.95 121.317 103.62 121.317C104.29 121.317 104.933 121.051 105.407 120.577C105.881 120.103 106.148 119.46 106.148 118.79C106.148 114.68 108.463 111.207 111.202 111.207C111.873 111.207 112.516 110.941 112.99 110.467C113.464 109.993 113.73 109.35 113.73 108.68C113.73 108.009 113.464 107.367 112.99 106.893C112.516 106.419 111.873 106.152 111.202 106.152Z"
        fill="black"
      />
      <path
        d="M100.122 15.1975C100.792 15.1975 101.435 14.9312 101.909 14.4572C102.383 13.9832 102.649 13.3404 102.649 12.67C102.649 11.9997 102.383 11.3568 101.909 10.8829C101.435 10.4089 100.792 10.1426 100.122 10.1426C97.7652 10.156 95.5078 11.0924 93.8336 12.7509C91.9331 14.8463 90.9051 17.5888 90.9601 20.4173C91.0151 23.2457 92.1488 25.9462 94.1293 27.9662L96.7426 30.6857C97.2075 31.169 97.8453 31.4479 98.5158 31.4609C99.1862 31.4739 99.8344 31.2201 100.318 30.7552C100.801 30.2903 101.08 29.6525 101.093 28.9821C101.106 28.3116 100.852 27.6634 100.387 27.1801L97.7738 24.4631C96.7396 23.3926 96.1275 21.9842 96.0504 20.4977C95.9733 19.0112 96.4364 17.547 97.3543 16.3753C98.0877 15.6365 99.0809 15.2138 100.122 15.1975Z"
        fill="black"
      />
      <path
        d="M106.601 33.6315C106.371 33.3922 106.096 33.2005 105.792 33.0675C105.488 32.9344 105.16 32.8625 104.829 32.856C104.497 32.8494 104.167 32.9083 103.858 33.0292C103.549 33.1501 103.266 33.3307 103.027 33.5607C102.788 33.7908 102.596 34.0657 102.463 34.3697C102.33 34.6738 102.258 35.0011 102.251 35.333C102.245 35.6649 102.304 35.9948 102.425 36.3039C102.546 36.613 102.726 36.8953 102.956 37.1346L104.329 38.5626C104.793 39.0459 105.431 39.3247 106.102 39.3377C106.772 39.3508 107.42 39.0969 107.904 38.6321C108.387 38.1672 108.666 37.5294 108.679 36.8589C108.692 36.1885 108.438 35.5403 107.973 35.057L106.601 33.6315Z"
        fill="black"
      />
      <path
        d="M20.2178 15.1604H50.5467C51.217 15.1604 51.8599 14.8941 52.3338 14.4201C52.8078 13.9461 53.0741 13.3032 53.0741 12.6329C53.0741 11.9626 52.8078 11.3197 52.3338 10.8457C51.8599 10.3718 51.217 10.1055 50.5467 10.1055H20.2178C19.5475 10.1055 18.9047 10.3718 18.4307 10.8457C17.9567 11.3197 17.6904 11.9626 17.6904 12.6329C17.6904 13.3032 17.9567 13.9461 18.4307 14.4201C18.9047 14.8941 19.5475 15.1604 20.2178 15.1604Z"
        fill="black"
      />
    </g>
    <defs>
      <clipPath id="clip0_2898_32478">
        <rect width="151.644" height="151.647" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const IndigenousRights = ({
  width = 152,
  height = 152,
  ...restOfProps
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 152 152"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...restOfProps}
  >
    <g clipPath="url(#clip0_2898_32741)">
      <path
        d="M150.479 103.456C147.92 98.1151 141.752 95.492 136.131 97.3543L100.414 109.185C99.6128 103.616 95.1185 99.1188 89.3302 98.4995L72.9609 96.748L51.1412 91.4446C41.2206 89.0329 30.9946 92.5277 24.5992 100.073L24.4674 99.7351C24.1825 99.003 23.6183 98.4145 22.8992 98.0982C22.1801 97.7819 21.3647 97.7651 20.6329 98.0497L1.88892 105.347C0.364851 105.941 -0.389778 107.657 0.203441 109.182L15.9985 149.753C16.4546 150.924 17.5735 151.641 18.7591 151.641C19.1163 151.641 19.4799 151.576 19.8327 151.438L38.5767 144.141C39.3085 143.856 39.8973 143.292 40.2136 142.573C40.4878 141.949 40.5364 141.252 40.3584 140.601L83.0367 140.647H83.101C89.709 140.647 96.1571 139.367 102.265 136.843L144.344 119.455C147.37 118.204 149.682 115.832 150.854 112.775C152.026 109.718 151.893 106.408 150.479 103.456ZM20.4443 144.844L6.79815 109.792L20.0222 104.644L33.6683 139.695L20.4443 144.844ZM145.324 110.654C144.74 112.176 143.589 113.357 142.083 113.98L100.004 131.368C94.6168 133.594 88.9304 134.723 83.1013 134.723C83.0823 134.723 83.0634 134.723 83.0444 134.723L38.0702 134.675L27.1577 106.645C31.783 98.9245 40.9179 95.0551 49.7424 97.2009L71.7519 102.55C71.8784 102.581 72.0069 102.604 72.1364 102.617L88.7 104.39C92.1832 104.762 94.7794 107.795 94.6106 111.294C94.5247 113.076 93.7458 114.713 92.4175 115.905C91.0895 117.096 89.3782 117.695 87.5959 117.586L61.0133 115.979C59.3802 115.879 57.977 117.124 57.8784 118.756C57.7798 120.389 59.0233 121.793 60.6558 121.891C60.6558 121.891 87.7561 123.521 88.0141 123.521C91.1066 123.521 94.0502 122.398 96.3731 120.314C97.8213 119.015 98.9221 117.435 99.6291 115.685L137.994 102.977C140.792 102.05 143.863 103.356 145.137 106.015C145.841 107.485 145.907 109.132 145.324 110.654Z"
        fill="black"
      />
      <path
        d="M20.7082 8.49438C27.1628 9.99119 33.4768 11.9254 39.6133 14.2696C39.6717 23.7108 42.5806 33.0906 47.9086 40.8954C48.8309 42.2463 50.6736 42.5937 52.0244 41.6717C53.3752 40.7494 53.7229 38.9067 52.8007 37.5559C48.6025 31.4063 46.1192 24.1396 45.6261 16.7224C69.2204 26.9695 89.8803 43.4099 105.3 64.5197C105.88 65.3137 106.781 65.7345 107.694 65.7345C108.3 65.7345 108.911 65.5491 109.438 65.1644C110.759 64.1995 111.047 62.3467 110.083 61.0258C94.1131 39.1626 72.7382 22.1126 48.3256 11.4386C59.0012 4.07914 73.4073 4.03176 84.1927 11.7948L86.5425 13.4859L84.4933 14.3709C83.2634 14.9022 82.5431 16.1929 82.7371 17.5185C82.9311 18.8445 83.9907 19.8748 85.3217 20.0312C98.0855 21.5322 108.976 29.8479 113.881 41.5672L109.927 42.3502C108.7 42.5931 107.759 43.5799 107.573 44.8164C107.388 46.0529 107.999 47.2725 109.1 47.8642C113.791 50.3849 117.678 54.1231 120.341 58.6745C123.938 64.8212 129.106 70.0026 135.198 73.646C128.955 77.0383 122.179 79.187 114.989 80.0482C100.576 81.7748 87.4452 71.4529 85.7189 57.0394C85.5521 55.646 84.4299 54.5611 83.0318 54.4409C81.6339 54.3215 80.3429 55.1985 79.9407 56.543L78.732 60.583L71.6957 54.9769C70.4169 53.9581 68.5534 54.1687 67.5337 55.4478C66.5146 56.7273 66.7255 58.5904 68.0046 59.6098L78.4681 67.9463C79.2376 68.5594 80.2608 68.7504 81.1994 68.456C81.7609 68.2801 82.2481 67.9442 82.6094 67.5009C87.8136 78.677 99.1618 86.1617 111.835 86.1605C113.108 86.1605 114.398 86.0846 115.694 85.9295C125.553 84.7484 134.712 81.3733 142.915 75.8975C143.818 75.2948 144.319 74.246 144.22 73.1647C144.122 72.0834 143.439 71.1428 142.442 70.7137C135.38 67.6738 129.347 62.3357 125.454 55.6827C123.481 52.3105 120.953 49.3092 117.987 46.7918L118.42 46.7059C119.245 46.5427 119.961 46.0366 120.391 45.3136C120.82 44.5907 120.923 43.7197 120.672 42.9171C116.705 30.2249 106.936 20.3765 94.6938 16.1363C95.1141 15.6785 95.3875 15.0918 95.4568 14.4526C95.572 13.3924 95.1082 12.3522 94.2425 11.7294L87.6531 6.9866C73.7846 -2.99565 54.8836 -2.13381 41.9892 8.83674C35.5188 6.35132 28.8581 4.30334 22.0466 2.72359C20.4529 2.3525 18.8619 3.34643 18.4923 4.9395C18.1227 6.53376 19.1148 8.12476 20.7082 8.49438Z"
        fill="black"
      />
      <path
        d="M59.4451 51.9272C61.0807 51.9272 62.4067 50.6012 62.4067 48.9656C62.4067 47.3299 61.0807 46.0039 59.4451 46.0039C57.8094 46.0039 56.4834 47.3299 56.4834 48.9656C56.4834 50.6012 57.8094 51.9272 59.4451 51.9272Z"
        fill="black"
      />
    </g>
    <defs>
      <clipPath id="clip0_2898_32741">
        <rect width="151.644" height="151.644" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const ImmigrationRights = ({
  width = 152,
  height = 152,
  ...restOfProps
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    width={152}
    height={152}
    fill="none"
    {...restOfProps}
  >
    <g clipPath="url(#a)">
      <path fill="url(#b)" d="M0 0h152v152H0z" />
    </g>
    <defs>
      <clipPath id="a">
        <path fill="#fff" d="M0 0h151.644v151.644H0z" />
      </clipPath>
      <pattern
        id="b"
        width={1}
        height={1}
        patternContentUnits="objectBoundingBox"
      >
        <use xlinkHref="#c" transform="scale(.00781)" />
      </pattern>
      <image
        xlinkHref="data:image/png;base64,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"
        id="c"
        width={128}
        height={128}
      />
    </defs>
  </svg>
);

const LegalSystem = ({ width = 152, height = 152, ...restOfProps }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    fill="none"
    {...restOfProps}
  >
    <path
      fill="#000"
      d="m151.387 92.468.023-.007-24.897-54.324 6.038-3.005-2.26-4.524-5.886 2.932-.796-1.736a2.528 2.528 0 0 0-4.595 0l-.71 1.551a32.512 32.512 0 0 0-13.673-3.025h-21.23v-5.055h5.055v-5.054H84.11l1.817-7.272c1.395-5.583-2-11.24-7.583-12.636A10.42 10.42 0 0 0 65.71 12.95l1.817 7.271h-4.344v5.055h5.055v5.055H47.019a32.512 32.512 0 0 0-13.686 3.033l-.71-1.552a2.528 2.528 0 0 0-4.595 0l-.796 1.736-5.886-2.944-2.26 4.529 6.038 3.018L.227 92.46c-.153.33-.232.69-.23 1.055.011 9.766 7.926 17.68 17.692 17.691h25.274c9.766-.011 17.68-7.925 17.691-17.691a2.47 2.47 0 0 0-.252-1.047L35.436 37.94a27.49 27.49 0 0 1 11.583-2.555h21.218v92.467l-8.629 8.628h-9.063c-6.976.008-12.629 5.662-12.637 12.637a2.528 2.528 0 0 0 2.527 2.528h70.767a2.527 2.527 0 0 0 2.527-2.528c-.008-6.975-5.661-12.629-12.637-12.637h-9.063l-8.628-8.628V35.385h21.23a27.49 27.49 0 0 1 11.583 2.555L91.213 92.46a2.47 2.47 0 0 0-.23 1.055c.011 9.766 7.925 17.68 17.692 17.691h25.273c9.767-.011 17.681-7.925 17.692-17.691a2.455 2.455 0 0 0-.253-1.047ZM42.963 106.152H17.689a12.658 12.658 0 0 1-12.384-10.11h50.042a12.658 12.658 0 0 1-12.384 10.11Zm11.226-15.165H6.462L29.68 40.336c.424.114.87.114 1.294 0l23.216 50.651ZM71.59 7.12a5.53 5.53 0 0 1 8.457 0 5.335 5.335 0 0 1 .978 4.604l-2.126 8.498h-6.161l-2.126-8.498a5.336 5.336 0 0 1 .978-4.604Zm1.701 23.211v-5.055h5.055v5.055h-5.055Zm5.055 5.055v90.986h-5.055V35.385h5.055Zm22.746 106.15a7.597 7.597 0 0 1 7.15 5.055H43.395a7.598 7.598 0 0 1 7.15-5.055h50.547Zm-16.21-5.055H66.755l5.055-5.055h8.017l5.055 5.055Zm35.777-96.136c.418.146.876.127 1.279-.053l23.237 50.696H97.448l23.211-50.643Zm13.289 65.808h-25.273a12.658 12.658 0 0 1-12.385-10.11h50.043a12.658 12.658 0 0 1-12.385 10.11Z"
    />
  </svg>
);

const LGBTQIARights = ({ width = 152, height = 152, ...restOfProps }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 152 152"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...restOfProps}
  >
    <path
      d="M145.644 7.39272C144.871 6.98281 143.928 7.03493 143.203 7.53252C126.764 18.7566 111.394 23.4149 97.4944 21.3606C89.2914 20.1498 83.0835 16.9511 76.513 13.5604C68.3242 9.33803 59.8582 4.97115 47.4352 4.74842C38.7038 4.58019 29.9535 6.50655 21.3263 10.4398V7.11076C21.3263 5.80282 20.2672 4.74131 18.9569 4.74131H7.10968C5.79938 4.74131 4.74023 5.80282 4.74023 7.11076V144.538C4.74023 145.846 5.79938 146.908 7.10968 146.908H18.9569C20.2672 146.908 21.3263 145.846 21.3263 144.538V115.738C29.9464 111.47 38.6849 109.355 47.3476 109.518C58.664 109.719 66.277 113.646 74.3402 117.804C80.9652 121.221 87.8176 124.756 96.8026 126.08C99.1625 126.429 101.556 126.602 103.982 126.602C117.087 126.602 131.145 121.531 145.871 111.475C146.521 111.032 146.907 110.3 146.907 109.518V9.48731C146.907 8.61061 146.421 7.80263 145.644 7.39272ZM142.168 91.6572C126.12 102.377 111.1 106.812 97.4944 104.803C95.1534 104.457 93.028 103.91 91.0022 103.298C97.8593 101.699 103.949 98.1187 108.647 93.1808C119.251 92.2425 130.501 88.058 142.168 80.6985V91.6572ZM21.3263 32.8074C29.9511 28.5424 38.6991 26.4265 47.3476 26.5852C58.2967 26.7819 65.7794 30.4664 73.556 34.4683C69.028 35.7099 64.8672 37.8164 61.2514 40.6147C56.74 39.2522 52.2073 38.5177 47.4329 38.4324C38.6967 38.2713 29.9535 40.1953 21.3263 44.1262V32.8074ZM21.3263 49.3935C29.944 45.1285 38.6375 43.0078 47.3476 43.1737C50.6956 43.2329 53.9109 43.6452 57.0883 44.3916C54.1431 47.5192 51.7429 51.1611 50.0772 55.1939C49.1957 55.1346 48.3285 55.0375 47.4305 55.0209C38.6967 54.8456 29.9535 56.779 21.3263 60.7123V49.3935ZM21.3263 65.9796C29.9535 61.7122 38.7441 59.5987 47.3452 59.7574C47.7575 59.7645 48.1484 59.819 48.556 59.8356C47.8214 62.6813 47.3902 65.6455 47.3902 68.7163C47.3902 69.6925 47.4589 70.6545 47.5371 71.6117C47.5016 71.6117 47.4684 71.607 47.4329 71.607C38.6967 71.4506 29.9535 73.3675 21.3263 77.2984V65.9796ZM21.3263 82.5657C29.9464 78.3007 38.6754 76.18 47.3452 76.3459C47.6508 76.3506 47.9447 76.3719 48.2456 76.3838C49.2313 80.8455 51.0415 85.0014 53.5342 88.6646C51.5391 88.3921 49.5156 88.2334 47.4329 88.1955C38.6967 88.0249 29.9535 89.9512 21.3263 93.8845V82.5657ZM52.1291 68.7163C52.1291 51.7321 65.9477 37.9135 82.9318 37.9135C99.916 37.9135 113.735 51.7321 113.735 68.7163C113.735 85.7004 99.916 99.519 82.9318 99.519C65.9477 99.519 52.1291 85.7004 52.1291 68.7163ZM142.168 75.0593C131.939 81.888 122.113 86.1601 112.844 87.84C115.303 84.0063 117.042 79.6773 117.879 75.0308C125.684 73.0452 133.83 69.4081 142.168 64.1504V75.0593ZM142.168 58.4826C133.974 63.9537 126.001 67.8206 118.41 69.9887C118.424 69.5622 118.473 69.1451 118.473 68.7163C118.473 65.2213 117.945 61.8496 117.002 58.658C125.082 56.7222 133.519 53.0092 142.168 47.5524V58.4826ZM142.168 41.8942C132.858 48.1116 123.847 52.2297 115.329 54.1774C113.524 50.1706 111.017 46.5454 107.934 43.4888C118.765 42.669 130.238 38.4537 142.168 30.9308V41.8942ZM47.3476 9.48731C58.664 9.68871 66.277 13.6149 74.3402 17.7732C80.9652 21.19 87.8176 24.7252 96.8026 26.0497C110.832 28.1182 126.079 24.0262 142.168 13.8779V25.2939C127.928 34.8001 114.474 39.3944 102.195 38.8897C96.6391 35.2905 90.0331 33.1746 82.9318 33.1746C82.4769 33.1746 82.0362 33.2268 81.586 33.2433L81.5931 33.2291C79.8753 32.3974 78.193 31.5302 76.5107 30.663C68.3219 26.4407 59.8535 22.0738 47.4305 21.8511C38.6967 21.6662 29.9535 23.6044 21.3263 27.5401V15.7095C29.9464 11.4421 38.6849 9.33092 47.3476 9.48731ZM16.5874 142.169H9.47912V9.4802H16.5874V142.169ZM97.4944 121.389C89.2914 120.178 83.0835 116.979 76.513 113.589C68.3242 109.366 59.8582 105 47.4352 104.777C38.7086 104.62 29.9535 106.54 21.3263 110.471V99.1518C29.9511 94.8844 38.6991 92.7661 47.3476 92.9296C51.2287 92.9983 54.8919 93.5149 58.5408 94.4982C64.2725 99.9218 71.7884 103.457 80.1193 104.113C84.5786 106.244 90.0141 108.49 96.8049 109.49C99.1649 109.838 101.558 110.011 103.984 110.011C115.986 110.011 128.79 105.708 142.168 97.2728V108.258C126.122 118.977 111.102 123.403 97.4944 121.389Z"
      fill="black"
    />
    <path
      d="M81.1924 91.6496C81.6402 92.1329 82.2705 92.4078 82.9292 92.4078C83.5879 92.4078 84.2182 92.1329 84.666 91.6496L103.124 71.7534C107.763 66.7515 107.763 58.6101 103.124 53.6058C100.823 51.125 97.7477 49.7578 94.4636 49.7578C91.1819 49.7578 88.1064 51.125 85.8057 53.6058L82.9292 56.7074L80.0527 53.6058C77.7496 51.125 74.6764 49.7578 71.3947 49.7578C68.1107 49.7578 65.0351 51.125 62.7344 53.6058C58.095 58.6077 58.095 66.7491 62.7344 71.7534L81.1924 91.6496ZM66.208 56.8282C67.6036 55.326 69.4447 54.4967 71.3947 54.4967C73.3424 54.4967 75.1835 55.326 76.5791 56.8282L81.1924 61.8041C82.0904 62.7708 83.7703 62.7708 84.6683 61.8041L89.2817 56.8282C92.0752 53.8167 96.8615 53.8214 99.6503 56.8282C102.643 60.053 102.643 65.3037 99.6503 68.5285L82.9292 86.5553L66.208 68.5309C63.2178 65.3037 63.2178 60.0554 66.208 56.8282Z"
      fill="black"
    />
  </svg>
);

export const MilitaryAndVeterans = ({
  width = 111,
  height = 150,
  ...restOfProps
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    fill="none"
    {...restOfProps}
  >
    <path
      fill="#000"
      d="M76.437 73.81 95.15 42.715a39.965 39.965 0 0 0 5.734-20.64V20a19.344 19.344 0 0 0-1.087-6.444 1.267 1.267 0 0 0-.05-.171c-.015-.04-.037-.078-.052-.118l-.033-.074A19.796 19.796 0 0 0 92.178 3.5c-.036-.022-.074-.037-.108-.062l-.023-.02h-.035A19.818 19.818 0 0 0 81.22.024h-.048C81.075.02 80.982 0 80.885 0h-50c-.105 0-.206.023-.31.023h-.058A19.747 19.747 0 0 0 19.555 3.54h-.032l-.026.025c-.037.025-.08.042-.117.067a19.914 19.914 0 0 0-7.495 10.093c-.015.048-.02.1-.036.15l-.021.09A19.573 19.573 0 0 0 10.884 20v2.075a39.966 39.966 0 0 0 5.718 20.613l18.59 31.727-33.558 54.287a5.002 5.002 0 0 0 4.801 7.548c.113-.012.227-.032.338-.063l13.024-3.297a2.396 2.396 0 0 1 2.402 1.5l2.888 12.159a4.987 4.987 0 0 0 9.06.954l21.323-38.5 22.6 38.567a4.984 4.984 0 0 0 4.277 2.43h.25a5.068 5.068 0 0 0 4.355-3.058l4.635-12.617a2.477 2.477 0 0 1 2.393-1.431l10.88 3.276c.145.044.295.075.447.092a5.021 5.021 0 0 0 4.853-7.568L76.437 73.81Zm14.43-33.676-17.35 28.831-3.025-5.056 25.392-42.327v.5a34.988 34.988 0 0 1-5.017 18.052ZM73.614 10H38.28l-3-5H76.53l-2.916 5Zm-2.917 5-2.915 5H44.254l-3-5h29.443Zm-5.832 10-2.918 5H50.233l-3-5h17.632Zm-5.91 10-2.882 4.773-2.853-4.774h5.734Zm6.59-1.25L82.263 5.103c1.747.145 3.456.6 5.044 1.342L61.66 49.14l-2.69-4.5 6.575-10.89Zm25.86-24.415a14.645 14.645 0 0 1 3.185 4.687l-27 45.02L64.57 54 91.405 9.335ZM87.352 131.75 17.032 14.29a15.023 15.023 0 0 1 3.145-4.79l71.338 118.79a7.654 7.654 0 0 0-4.163 3.46ZM29.885 145.2l-2.883-12.15a7.48 7.48 0 0 0-7.895-5.11 2.356 2.356 0 0 0-.344.062l-12.849 3.25 32.138-51.955 14.48 24.718L29.885 145.2Zm52.472-.162-24.792-42.329-36.662-62.575a34.996 34.996 0 0 1-5.018-18.022l69.177 115.545-2.704 7.381Zm15.277-16.268L24.237 6.553a14.786 14.786 0 0 1 5.292-1.45l24.269 40.61c.036.075.074.15.116.222l17.448 29.17v.028l34.465 56.117-8.193-2.48Z"
    />
  </svg>
);

export const MonitoringAndData = ({
  width = 150,
  height = 150,
  ...restOfProps
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    fill="none"
    {...restOfProps}
  >
    <g fill="#000" clipPath="url(#a)">
      <path d="M128.471 111.761a2.2 2.2 0 0 0-3.109 0 2.196 2.196 0 0 0 0 3.108l7.222 7.222c.624.654.996 2.002 0 3.108l-6.894 6.894a2.2 2.2 0 0 1-3.108 0l-20.622-20.622a44.623 44.623 0 0 0 10.006-9.997l6.377 6.377a2.194 2.194 0 0 0 3.109 0 2.2 2.2 0 0 0 0-3.109l-7.035-7.035c9.955-17.137 7.605-39.515-7.055-54.176-17.463-17.463-45.878-17.463-63.34 0-8.292 8.291-12.95 19.313-13.114 31.036-.165 11.697 4.155 22.823 12.164 31.325a2.198 2.198 0 0 0 3.2-3.014c-15.063-15.992-14.686-40.695.858-56.239 15.75-15.75 41.375-15.75 57.123 0 15.749 15.75 15.749 41.374 0 57.123-13.258 13.258-34.356 15.604-50.165 5.579a2.198 2.198 0 1 0-2.354 3.712c7.15 4.534 15.525 6.933 23.996 6.933 1.548 0 3.1-.08 4.646-.242a44.794 44.794 0 0 0 17.815-5.825l21.282 21.281a6.57 6.57 0 0 0 4.662 1.928 6.578 6.578 0 0 0 4.663-1.928l6.893-6.893a6.601 6.601 0 0 0 0-9.325l-7.22-7.221Z" />
      <path d="M90.446 62.623a2.198 2.198 0 0 0-1.127-2.896c-4.603-2.025-9.175-3.051-13.591-3.051-12.813 0-23.765 8.58-29.153 13.696a6.976 6.976 0 0 0-2.163 5.038c0 1.897.788 3.733 2.163 5.038 5.388 5.115 16.34 13.696 29.153 13.696 12.813 0 23.765-8.58 29.153-13.696a6.974 6.974 0 0 0 2.163-5.038 6.975 6.975 0 0 0-2.163-5.038 63.097 63.097 0 0 0-6.058-5.074 2.198 2.198 0 0 0-2.602 3.543 58.635 58.635 0 0 1 5.633 4.719c.513.486.794 1.143.794 1.85 0 .707-.281 1.364-.794 1.85-4.912 4.663-14.84 12.488-26.126 12.488-11.286 0-21.214-7.825-26.126-12.489a2.527 2.527 0 0 1-.794-1.85c0-.706.282-1.364.794-1.85 4.912-4.663 14.84-12.487 26.126-12.487 3.803 0 7.78.901 11.82 2.678a2.197 2.197 0 0 0 2.898-1.127Z" />
      <path d="M64.941 75.41c0 5.947 4.84 10.785 10.786 10.785 5.948 0 10.787-4.838 10.787-10.786 0-5.947-4.84-10.786-10.787-10.786-5.947 0-10.786 4.839-10.786 10.786Zm17.177 0a6.397 6.397 0 0 1-6.39 6.39 6.397 6.397 0 0 1-6.39-6.39 6.397 6.397 0 0 1 6.39-6.391 6.398 6.398 0 0 1 6.39 6.39ZM113.741 35.856a2.19 2.19 0 0 0 1.554-.644l9.591-9.591 4.141 4.14a3.283 3.283 0 0 0 4.635 0l11.631-11.63v2.95a2.198 2.198 0 1 0 4.396 0v-8.143a2.198 2.198 0 0 0-2.198-2.198h-8.143a2.198 2.198 0 1 0 0 4.396h2.722l-10.726 10.726-4.141-4.14a3.281 3.281 0 0 0-4.635 0l-10.381 10.381a2.197 2.197 0 0 0 1.554 3.753ZM11.594 29.854c6.24 0 11.319-5.078 11.319-11.319 0-6.24-5.078-11.318-11.32-11.318-6.24 0-11.318 5.077-11.318 11.318s5.078 11.319 11.319 11.319Zm0-18.241a6.93 6.93 0 0 1 6.923 6.922 6.93 6.93 0 0 1-6.923 6.923 6.93 6.93 0 0 1-6.923-6.923 6.93 6.93 0 0 1 6.923-6.922ZM11.93 37.389C5.69 37.389.61 42.466.61 48.707S5.69 60.026 11.93 60.026c6.241 0 11.318-5.078 11.318-11.319 0-6.24-5.077-11.318-11.318-11.318Zm0 18.24a6.93 6.93 0 0 1-6.923-6.922 6.93 6.93 0 0 1 6.923-6.922 6.93 6.93 0 0 1 6.922 6.922 6.93 6.93 0 0 1-6.922 6.923ZM11.93 67.207C5.69 67.207.61 72.285.61 78.526c0 6.24 5.078 11.318 11.319 11.318 6.241 0 11.318-5.077 11.318-11.318 0-6.242-5.077-11.319-11.318-11.319Zm0 18.241a6.93 6.93 0 0 1-6.923-6.922 6.93 6.93 0 0 1 6.923-6.923 6.93 6.93 0 0 1 6.922 6.923 6.93 6.93 0 0 1-6.922 6.922ZM31.842 15.12h19.452a2.198 2.198 0 1 0 0-4.395H31.842a2.198 2.198 0 1 0 0 4.395ZM31.842 24.488h9.726a2.198 2.198 0 1 0 0-4.396h-9.726a2.198 2.198 0 1 0 0 4.396ZM147.802 41.828h-10.733a2.198 2.198 0 1 0 0 4.396h10.733a2.198 2.198 0 1 0 0-4.396ZM128.918 46.523a2.441 2.441 0 1 0 0-4.882 2.441 2.441 0 0 0 0 4.882ZM147.802 50.787h-10.733a2.198 2.198 0 1 0 0 4.396h10.733a2.198 2.198 0 1 0 0-4.396ZM128.918 55.482a2.441 2.441 0 1 0 0-4.882 2.441 2.441 0 0 0 0 4.882ZM89.704 129.125H78.97a2.198 2.198 0 1 0 0 4.396h10.734a2.198 2.198 0 1 0 0-4.396ZM70.82 128.939a2.442 2.442 0 1 0 0 4.884 2.442 2.442 0 0 0 0-4.884ZM89.704 138.084H78.97a2.198 2.198 0 1 0 0 4.396h10.734a2.198 2.198 0 1 0 0-4.396ZM70.82 142.781a2.441 2.441 0 1 0 0-4.882 2.441 2.441 0 0 0 0 4.882ZM147.802 59.764h-10.733a2.198 2.198 0 1 0 0 4.395h10.733a2.198 2.198 0 1 0 0-4.395ZM147.802 68.725h-10.733a2.198 2.198 0 1 0 0 4.395h10.733a2.198 2.198 0 1 0 0-4.395ZM128.918 73.422a2.441 2.441 0 1 0 0-4.883 2.441 2.441 0 0 0 0 4.883ZM147.802 77.684h-10.733a2.198 2.198 0 1 0 0 4.395h10.733a2.198 2.198 0 1 0 0-4.395ZM147.802 86.643h-10.733a2.198 2.198 0 1 0 0 4.395h10.733a2.198 2.198 0 1 0 0-4.395ZM128.918 86.457a2.441 2.441 0 1 0 0 4.883 2.441 2.441 0 0 0 0-4.883ZM59.317 138.1h-8.224v-12.567a3.374 3.374 0 0 0-3.37-3.37H39.75a3.374 3.374 0 0 0-3.37 3.37V138.1h-3.134v-20.435a3.374 3.374 0 0 0-3.37-3.37h-7.972a3.374 3.374 0 0 0-3.37 3.37V138.1h-2.707v-6.946a3.374 3.374 0 0 0-3.37-3.371H4.486a3.374 3.374 0 0 0-3.37 3.371v7.232a2.198 2.198 0 0 0 1.082 4.11h57.119a2.198 2.198 0 1 0 0-4.396Zm-18.54-11.541h5.92V138.1h-5.92v-11.541Zm-17.846-7.868h5.92V138.1h-5.92v-19.409ZM5.51 132.179h5.921v5.921h-5.92v-5.921Z" />
    </g>
    <defs>
      <clipPath id="a">
        <path fill="#fff" d="M0 0h150v150H0z" />
      </clipPath>
    </defs>
  </svg>
);

const PublicSafetyAndAccountability = ({
  width = 150,
  height = 150,
  ...restOfProps
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    fill="none"
    {...restOfProps}
  >
    <g clipPath="url(#a)">
      <mask
        id="b"
        width={151}
        height={151}
        x={-1}
        y={0}
        maskUnits="userSpaceOnUse"
        style={{
          maskType: "luminance",
        }}
      >
        <path fill="#fff" d="M-.002.002h150v150h-150v-150Z" />
      </mask>
      <g
        stroke="#000"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit={10}
        strokeWidth={5.859}
        mask="url(#b)"
      >
        <path d="m136.098 70.105-.011 17.091c-.38 15.898-10.673 33.056-25.068 41.769-15.722 9.516-30.717 14.976-36.02 18.107-5.304-3.131-20.3-8.591-36.022-18.107-14.394-8.714-24.687-25.873-25.067-41.768-.006-2.535-.012-61.066-.012-61.066 20.075 0 35.938-9.576 46.381-18.09 8.398-6.846 20.45-6.783 28.887.015 10.65 8.582 27.014 18.17 46.932 18.17v17.391" />
        <path d="M42.021 115.404c-8.736-6.928-14.926-18.231-15.222-28.385-.003-2.913-.006-32.218-.009-49.09 14.476-2.47 28.433-9.135 41.634-19.899 2.241-1.825 4.629-2.209 6.24-2.209 2.317 0 4.596.806 6.413 2.27 9.68 7.8 24.188 16.817 42.129 19.914-.003 16.84-.006 46.093-.009 49.01-.296 10.158-6.486 21.461-15.222 28.389" />
        <path d="M90.26 59.433v66.152c-4.298 2.115-8.277 3.917-11.643 5.44-1.286.583-2.493 1.128-3.618 1.647-1.125-.519-2.332-1.064-3.618-1.647-3.366-1.523-7.345-3.325-11.643-5.44V59.433H90.26Z" />
        <path d="M107.975 70.906v44.499a34.754 34.754 0 0 1-3.63 2.532c-4.823 2.92-9.627 5.455-14.086 7.649v-54.68h17.716ZM59.738 70.906v54.68c-4.46-2.194-9.264-4.729-14.086-7.649a34.788 34.788 0 0 1-3.63-2.532V70.906h17.716ZM83.857 59.434H66.14V46.573h17.718v12.86ZM74.999 81.442v31.925M74.999 40.459v5.152" />
      </g>
    </g>
    <defs>
      <clipPath id="a">
        <path fill="#fff" d="M0 0h150v150H0z" />
      </clipPath>
    </defs>
  </svg>
);

export const ResearchAndEvaluation = ({
  width = 146,
  height = 142,
  ...restOfProps
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    fill="none"
    {...restOfProps}
  >
    <path
      fill="#000"
      d="M30.698 66.584h19.473a6.226 6.226 0 0 0 6.22-6.22V38.832a6.226 6.226 0 0 0-6.22-6.219H30.698a6.226 6.226 0 0 0-6.218 6.219v21.532c0 3.43 2.79 6.22 6.218 6.22Zm-1.531-27.752c0-.83.7-1.531 1.531-1.531h19.473c.831 0 1.532.701 1.532 1.531v21.532c0 .83-.7 1.532-1.532 1.532H30.698c-.83 0-1.531-.701-1.531-1.532V38.832ZM64.433 38.373h26.092a2.343 2.343 0 1 0 0-4.688H64.433a2.343 2.343 0 1 0 0 4.688ZM64.433 52.478h26.092a2.343 2.343 0 1 0 0-4.687H64.433a2.343 2.343 0 1 0 0 4.688Z"
    />
    <path
      fill="#000"
      d="m144.86 129.413-13.852-17.718a3.738 3.738 0 0 0-2.509-1.418 3.734 3.734 0 0 0-2.778.769l-2.031 1.589-2.735-3.494c5.405-5.558 8.531-12.805 8.781-20.606.268-8.29-2.71-16.187-8.384-22.237-4.739-5.05-10.788-8.127-17.132-9.266V19.171c0-3.913-3.184-7.096-7.095-7.096H92.16V7.537c0-3.913-3.184-7.096-7.095-7.096H7.439C3.527.441.344 3.624.344 7.537V108.25c0 3.913 3.183 7.096 7.095 7.096h4.964v4.546c0 3.908 3.184 7.088 7.096 7.088h77.625c3.912 0 7.095-3.18 7.095-7.088v-1.801a30.746 30.746 0 0 0 13.233-5.823l2.547 3.254-2.038 1.594a3.765 3.765 0 0 0-.647 5.279l13.861 17.721a3.76 3.76 0 0 0 2.968 1.44 3.74 3.74 0 0 0 2.31-.796l7.757-6.069a3.764 3.764 0 0 0 .65-5.278ZM7.439 110.658a2.41 2.41 0 0 1-2.408-2.408V7.537A2.41 2.41 0 0 1 7.44 5.129h77.625a2.41 2.41 0 0 1 2.408 2.407v4.54H19.499c-3.911 0-7.095 3.182-7.095 7.094v91.488H7.439Zm92.093 9.234c0 1.323-1.08 2.4-2.408 2.4H19.5a2.407 2.407 0 0 1-2.408-2.4V19.171a2.41 2.41 0 0 1 2.408-2.408h77.625a2.41 2.41 0 0 1 2.408 2.407v37.353a30.98 30.98 0 0 0-18.274 5.373H64.433a2.343 2.343 0 1 0 0 4.687h11.379a30.766 30.766 0 0 0-5.925 9.418H26.823a2.343 2.343 0 1 0 0 4.687h41.63a31.259 31.259 0 0 0-.64 9.418h-40.99a2.343 2.343 0 1 0 0 4.687h41.73a30.87 30.87 0 0 0 3.975 9.417H26.823a2.343 2.343 0 1 0 0 4.687h49.351c5.663 5.973 13.298 9.412 21.532 9.677.616.019 1.209-.006 1.826-.021v1.339Zm-1.675-6.003c-7.038-.227-13.569-3.179-18.384-8.316-9.945-10.602-9.407-27.32 1.195-37.264 4.925-4.619 11.293-7.133 18.012-7.133.289 0 .577.005.868.014 7.038.226 13.568 3.179 18.384 8.315 9.945 10.603 9.407 27.32-1.197 37.264-5.134 4.818-11.806 7.334-18.878 7.12Zm36.437 22.608-12.716-16.259 6.303-4.931 12.715 16.262-6.302 4.928Z"
    />
    <path
      fill="#000"
      d="M114.052 73.143c-7.94-8.461-21.28-8.887-29.739-.951-8.466 7.932-8.894 21.276-.96 29.746 4.135 4.406 9.738 6.633 15.352 6.633a20.993 20.993 0 0 0 14.397-5.683c8.457-7.937 8.883-21.28.95-29.745Zm-4.157 26.326c-6.582 6.171-16.953 5.837-23.121-.736-6.169-6.584-5.835-16.956.744-23.122A16.29 16.29 0 0 1 98.7 71.192c4.362 0 8.718 1.732 11.931 5.156 6.166 6.58 5.834 16.953-.737 23.12Z"
    />
    <path
      fill="#000"
      d="M111.205 84.742c-1.464-6.719-8.127-10.989-14.847-9.525a2.344 2.344 0 0 0-1.792 2.789 2.352 2.352 0 0 0 2.79 1.791c4.218-.913 8.356 1.754 9.272 5.945a2.34 2.34 0 0 0 2.788 1.79 2.342 2.342 0 0 0 1.789-2.79Z"
    />
  </svg>
);

export const YouthEmpowerment = ({
  width = 152,
  height = 152,
  ...restOfProps
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    fill="none"
    {...restOfProps}
  >
    <g fill="#000" clipPath="url(#a)">
      <path d="M149.119 0H2.528A2.527 2.527 0 0 0 .001 2.526v50.549h5.055V5.055H146.59v55.603H58.131v5.055h90.987a2.527 2.527 0 0 0 2.527-2.527V2.526A2.526 2.526 0 0 0 149.119 0Z" />
      <path d="M133.952 12.635H83.404v5.055h50.548v-5.055ZM141.537 27.805H90.989v5.054h50.548v-5.054ZM131.424 42.963H80.876v5.055h50.548v-5.055ZM80.676 21.79a8.156 8.156 0 0 0-10.875-4.306L49.307 28.115a12.499 12.499 0 0 0 1.242-5.369c0-6.979-5.658-12.637-12.637-12.637-6.98 0-12.637 5.658-12.637 12.637.01 2.744.92 5.408 2.592 7.583h-.105a17.344 17.344 0 0 0-16.11 11.22L4.903 64.804a8.095 8.095 0 0 0 10.552 10.428 8.163 8.163 0 0 0 4.649-4.86l2.643-8.411V98.54a12.516 12.516 0 0 0-7.583-2.593c-6.968-.01-12.626 5.631-12.637 12.6a12.617 12.617 0 0 0 3.819 9.062 11.643 11.643 0 0 0-6.346 10.328v21.18a2.527 2.527 0 0 0 2.526 2.527H27.802a2.527 2.527 0 0 0 2.528-2.526v-21.181a11.616 11.616 0 0 0-4.51-9.149h19.13a11.614 11.614 0 0 0-4.51 9.149v21.18a2.527 2.527 0 0 0 2.526 2.527H68.24a2.527 2.527 0 0 0 2.528-2.526v-21.181a11.643 11.643 0 0 0-6.346-10.328c4.99-4.871 5.087-12.864.216-17.855-3-3.073-7.355-4.41-11.562-3.551V44.5l23.202-12.047a8.156 8.156 0 0 0 4.397-10.664Zm-42.764-6.626a7.582 7.582 0 1 1 0 15.165 7.59 7.59 0 0 1-7.582-7.583 7.582 7.582 0 0 1 7.582-7.582Zm-22.747 85.838a7.582 7.582 0 1 1-7.582 7.582 7.59 7.59 0 0 1 7.582-7.582Zm10.11 45.587H5.055v-18.652a6.632 6.632 0 0 1 6.624-6.622h6.973a6.632 6.632 0 0 1 6.623 6.622v18.652Zm40.438-18.652v18.652H45.494v-18.652a6.632 6.632 0 0 1 6.624-6.622h6.972a6.632 6.632 0 0 1 6.623 6.622Zm-10.11-26.935a7.59 7.59 0 0 1 7.583 7.582 7.583 7.583 0 1 1-7.582-7.582Zm20.449-74.995a3.25 3.25 0 0 1-1.908 1.87L49.385 40.723a2.528 2.528 0 0 0-1.363 2.244V98.54a12.467 12.467 0 0 0-3.933 15.193h-3.65V70.767h-5.054v42.966H26.68a12.522 12.522 0 0 0 1.113-5.055h.01V45.493a2.527 2.527 0 0 0-4.94-.758l-7.546 24.016a3.038 3.038 0 0 1-4.216 1.68 3.102 3.102 0 0 1-1.411-4.013l6.746-23.255a12.21 12.21 0 0 1 11.326-7.78h17.895c.405.001.805-.097 1.164-.283l25.12-13.04a3.111 3.111 0 0 1 3.977 1.474c.39.769.438 1.666.134 2.473ZM104.859 117.612c4.999-4.87 5.103-12.871.233-17.87-4.871-4.999-12.871-5.103-17.87-.233-5 4.871-5.103 12.872-.233 17.87.077.079.154.157.233.233a11.645 11.645 0 0 0-6.346 10.329v21.179a2.527 2.527 0 0 0 2.526 2.527H108.677a2.526 2.526 0 0 0 2.528-2.526v-21.18a11.644 11.644 0 0 0-6.346-10.329Zm-8.819-16.607a7.583 7.583 0 1 1-7.582 7.583 7.591 7.591 0 0 1 7.582-7.583Zm10.11 45.587H85.93v-18.651a6.632 6.632 0 0 1 6.624-6.623h6.973a6.632 6.632 0 0 1 6.623 6.623v18.651ZM145.297 117.612c4.999-4.87 5.103-12.871.233-17.87-4.87-4.999-12.871-5.103-17.87-.233-4.999 4.871-5.103 12.872-.233 17.87.077.079.155.157.233.233a11.648 11.648 0 0 0-6.346 10.329v21.179a2.527 2.527 0 0 0 2.527 2.527H149.116a2.526 2.526 0 0 0 2.527-2.526v-21.18a11.644 11.644 0 0 0-6.346-10.329Zm-8.818-16.607a7.583 7.583 0 1 1-7.582 7.583 7.59 7.59 0 0 1 7.582-7.583Zm10.11 45.587h-20.22v-18.651a6.633 6.633 0 0 1 6.624-6.623h6.972a6.633 6.633 0 0 1 6.624 6.623v18.651Z" />
    </g>
    <defs>
      <clipPath id="a">
        <path fill="#fff" d="M0 0h151.644v151.644H0z" />
      </clipPath>
    </defs>
  </svg>
);

export const sparksIcon = {
  "animal cares & services": () => <AnimalCareAndServices />,
  "arts & culture": () => <ArtsAndCulture />,
  agriculture: () => <Agriculture />,
  "aging well": () => <AgingWell />,
  "behavioral & mental health": () => <BehaviorAndMentalHealth />,
  "career development & training": () => <CareerDevelopmentAndTraining />,
  "civic engagement": () => <CivicEngagement />,
  "climate action": () => <ClimateAction />,
  "community power & advocacy": () => <CommunityPowerAndAdvocacy />,
  "digital inclusion": () => <DigitalInclusion />,
  "disaster relief": () => <DisasterRelief />,
  "disabiliy justice": () => <DisabilityJustice />,
  education: () => <Education />,
  "faith & spirituality": () => <FaithAndSpirituality />,
  "fraternity & sorority life": () => <FaternityAndSororityLife />,
  "economic 1": () => <Economic1 />,
  "health & wellness": () => <HealthAndWellness />,
  "human services": () => <HumanServices />,
  "indigenous rights": () => <IndigenousRights />,
  "immigration rights": () => <ImmigrationRights />,
  "legal system": () => <LegalSystem />,
  "lgbtqia rights": () => <LGBTQIARights />,
  "military & veterans": () => <MilitaryAndVeterans />,
  "monitoring & data": () => <MonitoringAndData />,
  "public safety & accountability": () => <PublicSafetyAndAccountability />,
  "research & evaluation": () => <ResearchAndEvaluation />,
  "youth empowerment": () => <YouthEmpowerment />,
};

export const VerticalMoreIcon = ({ color = "black", ...rest }) => (
  <Icon {...rest}>
    <svg
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_4000_1117)">
        <path
          d="M11.9999 5.37634C13.4727 5.37634 14.6666 4.18243 14.6666 2.70966C14.6666 1.23689 13.4727 0.0429688 11.9999 0.0429688C10.5272 0.0429688 9.33325 1.23689 9.33325 2.70966C9.33325 4.18243 10.5272 5.37634 11.9999 5.37634Z"
          fill={color}
        />
        <path
          d="M11.9999 14.7084C13.4727 14.7084 14.6666 13.5145 14.6666 12.0417C14.6666 10.5689 13.4727 9.375 11.9999 9.375C10.5272 9.375 9.33325 10.5689 9.33325 12.0417C9.33325 13.5145 10.5272 14.7084 11.9999 14.7084Z"
          fill={color}
        />
        <path
          d="M11.9999 24.0443C13.4727 24.0443 14.6666 22.8504 14.6666 21.3776C14.6666 19.9049 13.4727 18.7109 11.9999 18.7109C10.5272 18.7109 9.33325 19.9049 9.33325 21.3776C9.33325 22.8504 10.5272 24.0443 11.9999 24.0443Z"
          fill={color}
        />
      </g>
      <defs>
        <clipPath id="clip0_4000_1117">
          <rect
            width="24"
            height="24"
            fill="white"
            transform="translate(0 0.0429688)"
          />
        </clipPath>
      </defs>
    </svg>
  </Icon>
);

export const InviteMember = (props) => (
  <Icon {...props}>
    <svg
      width="25"
      height="25"
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_3988_91)">
        <path
          d="M16.5 21.5V19.5C16.5 18.4391 16.0786 17.4217 15.3284 16.6716C14.5783 15.9214 13.5609 15.5 12.5 15.5H5.5C4.43913 15.5 3.42172 15.9214 2.67157 16.6716C1.92143 17.4217 1.5 18.4391 1.5 19.5V21.5"
          stroke="#EE5A29"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M20.5 8.5V14.5"
          stroke="#EE5A29"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M23.5 11.5H17.5"
          stroke="#EE5A29"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M9 11.5C11.2091 11.5 13 9.70914 13 7.5C13 5.29086 11.2091 3.5 9 3.5C6.79086 3.5 5 5.29086 5 7.5C5 9.70914 6.79086 11.5 9 11.5Z"
          stroke="#EE5A29"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_3988_91">
          <rect
            width="24"
            height="24"
            fill="white"
            transform="translate(0.5 0.5)"
          />
        </clipPath>
      </defs>
    </svg>
  </Icon>
);

export const ImageBackground = (props) => (
  <Icon {...props}>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={props.width || 72}
      height={props.height || 72}
      viewBox={`0 0 ${props.width || 72} ${props.height || 72}`}
      fill="none"
      {...props}
    >
      <path
        fill="#082164"
        stroke="#F4F7FF"
        d="m48.985 38.151-.683.537.808.32a35.334 35.334 0 0 1 22.083 28.938 3.083 3.083 0 0 1-2.686 3.387h-.367a3.084 3.084 0 0 1-3.084-2.744 29.166 29.166 0 0 0-57.969 0 3.105 3.105 0 0 1-6.173-.679 35.334 35.334 0 0 1 21.978-28.902l.803-.322-.68-.535a21 21 0 1 1 25.97 0ZM27.759 34A14.834 14.834 0 1 0 44.241 9.332 14.834 14.834 0 0 0 27.76 34Z"
      />
    </svg>
  </Icon>
);
export const AddImage = (props) => (
  <Icon {...props}>
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.9294 14.5092L3.9 14.5385V14.58V17C3.9 17.2917 4.01589 17.5715 4.22218 17.7778C4.42847 17.9841 4.70826 18.1 5 18.1H15.41H15.6514L15.4807 17.9293L8.77071 11.2193L8.77071 11.2193L8.77 11.2186C8.56438 11.017 8.28793 10.9041 8 10.9041C7.71207 10.9041 7.43562 11.017 7.23 11.2186L7.2294 11.2192L3.9294 14.5092ZM18.1591 18.0705L18.1884 18.1H18.23H19C19.2917 18.1 19.5715 17.9841 19.7778 17.7778C19.9841 17.5715 20.1 17.2917 20.1 17V16.58V16.5385L20.0706 16.5092L16.7706 13.2192L16.77 13.2186C16.5644 13.017 16.2879 12.9041 16 12.9041C15.7121 12.9041 15.4356 13.017 15.23 13.2186L15.2293 13.2193L14.3493 14.0993L14.2788 14.1698L14.3491 14.2405L18.1591 18.0705ZM19.9295 13.8309L20.1 14.0005V13.76V7C20.1 6.70826 19.9841 6.42847 19.7778 6.22218C19.5715 6.01589 19.2917 5.9 19 5.9H5C4.70826 5.9 4.42847 6.01589 4.22218 6.22218C4.01589 6.42847 3.9 6.70826 3.9 7V11.76V12.0005L4.07052 11.8309L5.9499 9.96152C6.50114 9.43222 7.23576 9.13663 8 9.13663C8.76419 9.13663 9.49875 9.43218 10.05 9.96141L12.9293 12.8407L13 12.9114L13.0707 12.8407L13.95 11.9614C14.5012 11.4322 15.2358 11.1366 16 11.1366C16.7642 11.1366 17.4988 11.4322 18.0501 11.9615C18.0503 11.9617 18.0505 11.9619 18.0507 11.9621L19.9295 13.8309ZM5 4.1H19C19.7691 4.1 20.5068 4.40553 21.0506 4.94939C21.5945 5.49325 21.9 6.23087 21.9 7V17C21.9 17.7691 21.5945 18.5068 21.0506 19.0506C20.5068 19.5945 19.7691 19.9 19 19.9H5C4.23087 19.9 3.49325 19.5945 2.94939 19.0506C2.40553 18.5068 2.1 17.7691 2.1 17V7C2.1 6.23087 2.40553 5.49325 2.94939 4.94939C3.49325 4.40553 4.23087 4.1 5 4.1Z"
        fill="black"
        stroke="white"
        strokeWidth="0.2"
      />
    </svg>
  </Icon>
);
export const PencilWithoutSquare = (props) => (
  <Icon {...props}>
    <svg
      width="19"
      height="19"
      viewBox="0 0 19 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2 17H3.4L12.025 8.375L10.625 6.975L2 15.6V17ZM16.3 6.925L12.05 2.725L13.45 1.325C13.8333 0.941667 14.3043 0.75 14.863 0.75C15.421 0.75 15.8917 0.941667 16.275 1.325L17.675 2.725C18.0583 3.10833 18.2583 3.571 18.275 4.113C18.2917 4.65433 18.1083 5.11667 17.725 5.5L16.3 6.925ZM1 19C0.716667 19 0.479333 18.904 0.288 18.712C0.0960001 18.5207 0 18.2833 0 18V15.175C0 15.0417 0.025 14.9127 0.075 14.788C0.125 14.6627 0.2 14.55 0.3 14.45L10.6 4.15L14.85 8.4L4.55 18.7C4.45 18.8 4.33767 18.875 4.213 18.925C4.08767 18.975 3.95833 19 3.825 19H1Z"
        fill="#EF6B2D"
      />
    </svg>
  </Icon>
);

export const Agronomy = (props) => (
  <Icon viewBox="0 0 33 33" {...props}>
    <svg xmlns="http://www.w3.org/2000/svg" width="33" height="33" fill="none">
      <g clipPath="url(#clip0_2837_30824)">
        <path
          d="M23.2272 16.8935C23.172 16.705 23.0303 16.551 22.842 16.4822C22.804 16.4683 22.4959 16.3593 22.0174 16.2893C24.0617 14.114 23.3868 11.5727 23.2272 11.0764C23.172 10.8878 23.0303 10.7339 22.842 10.665C22.7543 10.6329 21.2242 10.0933 19.4809 10.7C19.5794 10.2962 19.6369 9.85228 19.6369 9.36515C19.6369 6.2484 17.2768 4.8785 16.8031 4.63531C16.6308 4.54093 16.4216 4.53231 16.2399 4.61681C16.1227 4.67125 13.3693 5.98896 13.3693 9.36515C13.3693 9.85328 13.4271 10.2982 13.5259 10.7026C11.7796 10.0918 10.2454 10.6328 10.1576 10.665C9.96925 10.7339 9.82757 10.8878 9.77238 11.0764C9.61282 11.5727 8.93788 14.114 10.9821 16.2893C10.5036 16.3593 10.1956 16.4683 10.1576 16.4822C9.96925 16.551 9.8275 16.705 9.77232 16.8935C9.60944 17.4002 8.90907 20.038 11.1129 22.2419C12.3883 23.5173 13.8038 23.8216 14.8643 23.8216C15.2569 23.8216 15.6001 23.7798 15.8703 23.7302V27.8198C15.8703 28.1649 16.1501 28.4448 16.4953 28.4448C16.8405 28.4448 17.1203 28.1649 17.1203 27.8198V23.7286C17.3918 23.7789 17.7383 23.8215 18.1352 23.8215C19.1956 23.8215 20.6113 23.5172 21.8866 22.2419C24.0904 20.0379 23.3901 17.4002 23.2272 16.8935ZM15.8703 21.7818C15.8564 22.0655 15.8166 22.3039 15.7786 22.4754C15.1105 22.6238 13.439 22.8002 11.9969 21.358C10.5764 19.9377 10.7253 18.2938 10.8826 17.5765C11.3026 17.4852 12.1223 17.3835 13.0298 17.678C13.0896 17.7004 13.1491 17.7215 13.2084 17.7412C13.689 17.9234 14.188 18.2209 14.6609 18.6938C15.5621 19.595 15.8313 20.5857 15.8703 21.3648V21.7818ZM15.8703 15.9648C15.8564 16.2485 15.8166 16.4869 15.7786 16.6583C15.3646 16.7503 14.5655 16.8525 13.6744 16.5744C13.5841 16.5396 13.4943 16.5079 13.4051 16.4792C12.939 16.2951 12.4563 16.0003 11.9968 15.5409C10.5764 14.1205 10.7253 12.4767 10.8826 11.7595C11.55 11.6144 13.2262 11.442 14.6609 12.8768C14.6701 12.8859 14.6783 12.8951 14.6873 12.9041C14.7421 12.9656 14.7971 13.0245 14.852 13.081C15.6001 13.9254 15.8342 14.8271 15.8703 15.5478V15.9648ZM16.5041 12.8288C16.3083 12.7032 16.026 12.4961 15.7393 12.1968C15.7101 12.1648 15.6805 12.1327 15.6501 12.1008C15.1279 11.5207 14.6193 10.6309 14.6193 9.36515C14.6193 7.3278 15.923 6.27071 16.4999 5.90271C17.1178 6.29809 18.3869 7.35517 18.3869 9.36515C18.3869 10.5595 17.9387 11.4166 17.4517 11.9958C17.3504 12.0972 17.2557 12.1996 17.1664 12.3024C16.9165 12.5454 16.6772 12.7186 16.5041 12.8288ZM17.1242 15.7622C17.1233 15.0284 17.3131 14.0574 18.0903 13.1455C18.1823 13.054 18.2749 12.9556 18.3666 12.8498C19.8008 11.4391 21.4528 11.6114 22.1167 11.7583C22.274 12.4748 22.4239 14.1197 21.0026 15.5409C20.544 15.9996 20.0623 16.2941 19.5969 16.4783C19.5063 16.5075 19.4149 16.5397 19.3231 16.5751C18.4321 16.8528 17.6335 16.7502 17.2212 16.6585C17.1749 16.4502 17.1259 16.1442 17.1241 15.7781C17.1241 15.7728 17.1242 15.7675 17.1242 15.7622ZM21.0026 21.358C19.5603 22.8005 17.8887 22.6238 17.2222 22.4759C17.0769 21.811 16.9012 20.1312 18.3386 18.6938C18.7984 18.2339 19.2815 17.9391 19.748 17.755C19.837 17.7264 19.9266 17.6949 20.0166 17.6601C20.9058 17.3826 21.7031 17.4839 22.1167 17.5753C22.274 18.2919 22.4239 19.9368 21.0026 21.358Z"
          fill="black"
        />
        <path
          d="M19.8347 0.848194C18.7453 0.61719 17.6233 0.5 16.5 0.5C12.2262 0.5 8.20831 2.16428 5.18631 5.1864C2.16431 8.20846 0.5 12.2265 0.5 16.5003C0.5 20.0615 1.69813 23.5377 3.881 26.3368C3.63544 26.7167 3.50325 27.1592 3.50325 27.6223C3.50325 28.2567 3.75031 28.8531 4.19887 29.3017C4.64744 29.7503 5.24388 29.9974 5.87825 29.9974C6.51263 29.9974 7.10906 29.7503 7.55762 29.3017C8.00625 28.8531 8.25325 28.2567 8.25325 27.6223C8.25325 26.9879 8.00619 26.3915 7.55762 25.9429C7.10906 25.4943 6.51263 25.2472 5.87825 25.2472C5.50225 25.2472 5.13981 25.3346 4.81337 25.4988C2.83512 22.9307 1.75 19.7542 1.75 16.5003C1.75 8.36696 8.36681 1.75002 16.5 1.75002C17.5364 1.75002 18.5711 1.85803 19.5754 2.07103C19.9133 2.14259 20.2449 1.9269 20.3165 1.58927C20.3881 1.25158 20.1724 0.91982 19.8347 0.848194ZM5.08275 26.8267C5.30206 26.6074 5.59013 26.4977 5.87825 26.4977C6.16638 26.4977 6.45444 26.6074 6.67375 26.8267C6.88625 27.0392 7.00325 27.3217 7.00325 27.6223C7.00325 27.9228 6.88625 28.2053 6.67375 28.4178C6.23513 28.8565 5.52137 28.8564 5.08275 28.4178C4.87025 28.2053 4.75325 27.9228 4.75325 27.6223C4.75325 27.3217 4.87025 27.0392 5.08275 26.8267Z"
          fill="black"
        />
        <path
          d="M29.1189 6.66447C29.3645 6.28459 29.4967 5.84208 29.4967 5.37895C29.4967 4.74456 29.2496 4.14811 28.801 3.69954C28.3525 3.25091 27.756 3.00391 27.1217 3.00391C26.4873 3.00391 25.8908 3.25097 25.4423 3.69954C24.9937 4.14811 24.7467 4.74456 24.7467 5.37895C24.7467 6.01334 24.9937 6.60979 25.4423 7.05836C25.8908 7.50699 26.4873 7.75399 27.1217 7.75399C27.4977 7.75399 27.8601 7.66656 28.1866 7.50243C30.1648 10.0705 31.2499 13.2471 31.2499 16.501C31.2499 24.6343 24.6331 31.2512 16.4999 31.2512C15.625 31.2512 14.7483 31.1741 13.8944 31.0219C13.5548 30.9615 13.23 31.1877 13.1695 31.5276C13.1089 31.8674 13.3353 32.192 13.6751 32.2526C14.6013 32.4176 15.5517 32.5013 16.4999 32.5013C20.7737 32.5013 24.7916 30.8369 27.8137 27.8149C30.8357 24.7929 32.4999 20.7748 32.4999 16.501C32.4999 12.9398 31.3018 9.46353 29.1189 6.66447ZM27.9172 6.17446C27.7048 6.38697 27.4222 6.50397 27.1217 6.50397C26.8212 6.50397 26.5387 6.38703 26.3262 6.17446C25.8875 5.73583 25.8875 5.02213 26.3262 4.58344C26.5387 4.37093 26.8212 4.25393 27.1217 4.25393C27.4222 4.25393 27.7047 4.37093 27.9172 4.58344C28.1297 4.79588 28.2467 5.07844 28.2467 5.37895C28.2467 5.67946 28.1297 5.96196 27.9172 6.17446Z"
          fill="black"
        />
        <path
          d="M11.0081 30.1948L10.7721 30.7736L11.0064 30.1941C10.6862 30.0649 10.3221 30.2193 10.1927 30.5393C10.0633 30.8593 10.2179 31.2236 10.5379 31.3531L10.5572 31.3607C10.6309 31.3889 10.7068 31.4023 10.7814 31.4023C11.0331 31.4023 11.2711 31.2499 11.3663 31.0013C11.4898 30.6789 11.3305 30.3182 11.0081 30.1948Z"
          fill="black"
        />
        <path
          d="M22.4891 1.6587L22.4779 1.65427C22.1575 1.52601 21.7937 1.68195 21.6655 2.00246C21.5372 2.32297 21.6932 2.6866 22.0137 2.81485L22.0208 2.81773C22.0976 2.84873 22.1767 2.86335 22.2547 2.86335C22.502 2.86335 22.7361 2.71566 22.8344 2.47234C22.9637 2.15228 22.8091 1.78802 22.4891 1.6587Z"
          fill="black"
        />
      </g>
      <defs>
        <clipPath id="clip0_2837_30824">
          <rect
            width="32"
            height="32.0006"
            fill="white"
            transform="translate(0.5 0.5)"
          />
        </clipPath>
      </defs>
    </svg>
  </Icon>
);

export const DoubleMask = (props) => (
  <Icon viewBox="0 0 33 33" {...props}>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="33"
      height="33"
      viewBox="0 0 33 33"
      fill="none"
    >
      <g clipPath="url(#clip0_2837_30798)">
        <path
          d="M19.9565 5.46656L8.05376 1.13431C6.64514 0.621619 5.08758 1.34793 4.57489 2.75656L1.93308 10.0148C1.13401 12.2102 1.3762 14.6497 2.59133 16.6451L5.18939 20.9114C6.06976 22.3571 7.83464 22.9994 9.43826 22.4578L14.1708 20.8597C16.3843 20.1122 18.1379 18.3991 18.9369 16.2037L21.5788 8.9455C22.0914 7.53687 21.3651 5.97924 19.9565 5.46656Z"
          stroke="black"
          strokeWidth="0.9375"
          stroke-miterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M9.67291 15.203C8.22885 14.6773 7.01916 13.883 6.1776 12.9885C5.70466 14.9724 6.78179 17.0391 8.7446 17.7536C10.7074 18.468 12.861 17.5771 13.774 15.7534C12.5543 15.8976 11.117 15.7286 9.67291 15.203Z"
          stroke="black"
          strokeWidth="0.9375"
          stroke-miterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M9.51995 10.332C9.3622 9.70147 8.85789 9.12822 8.12902 8.86297C7.40014 8.59766 6.64539 8.71259 6.11914 9.09428"
          stroke="black"
          strokeWidth="0.9375"
          stroke-miterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M16.3212 12.8086C16.1635 12.178 15.6592 11.6048 14.9303 11.3395C14.2014 11.0742 13.4467 11.1892 12.9204 11.5708"
          stroke="black"
          strokeWidth="0.9375"
          stroke-miterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M6.3125 7.23828C6.3125 7.23828 8.052 6.42716 10.6026 7.35547"
          stroke="black"
          strokeWidth="0.9375"
          stroke-miterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M17.3652 11.2617C17.3652 11.2617 16.554 9.52228 14.0034 8.59391"
          stroke="black"
          strokeWidth="0.9375"
          stroke-miterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M13.2246 23.285L14.0623 25.5866C14.8614 27.7819 16.615 29.4949 18.8284 30.2424L23.561 31.8406C25.1647 32.3822 26.9295 31.7398 27.8099 30.2941L30.4079 26.0279C31.623 24.0325 31.8652 21.5929 31.0662 19.3976L28.4244 12.1393C27.9117 10.7307 26.3542 10.0044 24.9455 10.5171L22.8458 11.2813"
          stroke="black"
          strokeWidth="0.9375"
          stroke-miterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M23.6358 25.4379C25.0799 24.9123 26.5172 24.7432 27.7369 24.8875C26.8239 23.0638 24.6703 22.1729 22.7075 22.8873C20.7447 23.6017 19.6676 25.6685 20.1405 27.6523C20.9821 26.7578 22.1917 25.9635 23.6358 25.4379Z"
          stroke="black"
          strokeWidth="0.9375"
          stroke-miterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M16.6523 21.7578C17.2597 21.9895 18.0183 21.9043 18.6532 21.4587C19.288 21.013 19.626 20.3284 19.6144 19.6785"
          stroke="black"
          strokeWidth="0.9375"
          stroke-miterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M26.6208 18.1293C26.3044 18.6971 25.6685 19.1196 24.8957 19.1863C24.1229 19.253 23.424 18.9457 23.0151 18.4404"
          stroke="black"
          strokeWidth="0.9375"
          stroke-miterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M26.6865 16.625C26.6865 16.625 24.947 15.8139 22.3965 16.7422"
          stroke="black"
          strokeWidth="0.9375"
          stroke-miterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_2837_30798">
          <rect
            width="32"
            height="32"
            fill="white"
            transform="translate(0.5 0.5)"
          />
        </clipPath>
      </defs>
    </svg>
  </Icon>
);

export const FollowIcon = (props) => {
  return (
    <Icon {...props}>
      <svg
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clipPath="url(#clip0_2934_36004)">
          <path
            d="M10.6666 14V12.6667C10.6666 11.9594 10.3857 11.2811 9.88558 10.781C9.38548 10.281 8.7072 10 7.99996 10H3.33329C2.62605 10 1.94777 10.281 1.44767 10.781C0.947578 11.2811 0.666626 11.9594 0.666626 12.6667V14"
            stroke="white"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M13.3334 5.33203V9.33203"
            stroke="white"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M15.3334 7.33203H11.3334"
            stroke="white"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M5.66667 7.33333C7.13943 7.33333 8.33333 6.13943 8.33333 4.66667C8.33333 3.19391 7.13943 2 5.66667 2C4.19391 2 3 3.19391 3 4.66667C3 6.13943 4.19391 7.33333 5.66667 7.33333Z"
            stroke="white"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
        <defs>
          <clipPath id="clip0_2934_36004">
            <rect width="16" height="16" fill="white" />
          </clipPath>
        </defs>
      </svg>
    </Icon>
  );
};

export const HamburgerIcon = (props) => (
  <Icon {...props}>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
    >
      <mask
        id="mask0_3826_6663"
        // style="mask-type:alpha"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="25"
        height="24"
      >
        <rect x="0.87207" width="24" height="24" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_3826_6663)">
        <path
          d="M4.87207 18C4.58874 18 4.35124 17.9042 4.15957 17.7125C3.9679 17.5208 3.87207 17.2833 3.87207 17C3.87207 16.7167 3.9679 16.4792 4.15957 16.2875C4.35124 16.0958 4.58874 16 4.87207 16H20.8721C21.1554 16 21.3929 16.0958 21.5846 16.2875C21.7762 16.4792 21.8721 16.7167 21.8721 17C21.8721 17.2833 21.7762 17.5208 21.5846 17.7125C21.3929 17.9042 21.1554 18 20.8721 18H4.87207ZM4.87207 13C4.58874 13 4.35124 12.9042 4.15957 12.7125C3.9679 12.5208 3.87207 12.2833 3.87207 12C3.87207 11.7167 3.9679 11.4792 4.15957 11.2875C4.35124 11.0958 4.58874 11 4.87207 11H20.8721C21.1554 11 21.3929 11.0958 21.5846 11.2875C21.7762 11.4792 21.8721 11.7167 21.8721 12C21.8721 12.2833 21.7762 12.5208 21.5846 12.7125C21.3929 12.9042 21.1554 13 20.8721 13H4.87207ZM4.87207 8C4.58874 8 4.35124 7.90417 4.15957 7.7125C3.9679 7.52083 3.87207 7.28333 3.87207 7C3.87207 6.71667 3.9679 6.47917 4.15957 6.2875C4.35124 6.09583 4.58874 6 4.87207 6H20.8721C21.1554 6 21.3929 6.09583 21.5846 6.2875C21.7762 6.47917 21.8721 6.71667 21.8721 7C21.8721 7.28333 21.7762 7.52083 21.5846 7.7125C21.3929 7.90417 21.1554 8 20.8721 8H4.87207Z"
          fill="#1C1B1F"
        />
      </g>
    </svg>
  </Icon>
);

export const MobileSearchIcon = (props) => (
  <Icon {...props}>
    <svg
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_3826_6660"
        // style="mask-type:alpha"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="25"
        height="24"
      >
        <rect x="0.87207" width="24" height="24" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_3826_6660)">
        <path
          d="M19.3266 19.7496L14.2357 14.6515C13.7812 15.0156 13.2584 15.3039 12.6675 15.5164C12.0766 15.7288 11.4478 15.835 10.7812 15.835C9.12965 15.835 7.73207 15.2624 6.58843 14.1171C5.44419 12.9712 4.87207 11.5714 4.87207 9.9175C4.87207 8.26363 5.44419 6.86376 6.58843 5.71789C7.73207 4.57263 9.12965 4 10.7812 4C12.4327 4 13.8306 4.57263 14.9748 5.71789C16.1184 6.86376 16.6903 8.26363 16.6903 9.9175C16.6903 10.5851 16.5842 11.2148 16.3721 11.8065C16.1599 12.3983 15.8721 12.9218 15.5084 13.377L20.6221 18.4979C20.7887 18.6648 20.8721 18.8696 20.8721 19.1124C20.8721 19.3551 20.7812 19.5676 20.5993 19.7496C20.4327 19.9165 20.2206 20 19.963 20C19.7054 20 19.4933 19.9165 19.3266 19.7496ZM10.7812 14.0142C11.9175 14.0142 12.8836 13.6161 13.6793 12.8198C14.4745 12.0229 14.8721 11.0555 14.8721 9.9175C14.8721 8.77952 14.4745 7.81208 13.6793 7.01519C12.8836 6.21891 11.9175 5.82077 10.7812 5.82077C9.6448 5.82077 8.67874 6.21891 7.88298 7.01519C7.08783 7.81208 6.69025 8.77952 6.69025 9.9175C6.69025 11.0555 7.08783 12.0229 7.88298 12.8198C8.67874 13.6161 9.6448 14.0142 10.7812 14.0142Z"
          fill="#1C1B1F"
        />
      </g>
    </svg>
  </Icon>
);

export const AdvocacyAndCommunityPowerIcon = (props) => (
  <Icon viewBox="0 0 45 44" {...props}>
    <svg
      width="45"
      height="44"
      viewBox="0 0 45 44"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_1582_7987)">
        <path
          d="M35.8299 16.3272C35.5074 16.7003 35.0296 16.9365 34.4962 16.9365C33.5249 16.9365 32.7375 16.1529 32.7375 15.1863V8.75415C32.7375 7.78744 33.5249 7.00386 34.4962 7.00386C35.4675 7.00386 36.2549 7.78744 36.2549 8.75415V13.6073"
          stroke="#060606"
          strokeWidth="1.28906"
          stroke-miterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M39.7694 13.7402H36.2543C36.2536 13.7402 36.2532 13.7397 36.2532 13.7391V9.33559C36.2532 8.36613 37.0391 7.58023 38.0085 7.58023H38.0152C38.9846 7.58023 39.7705 8.36613 39.7705 9.33559V13.7391C39.7705 13.7397 39.77 13.7402 39.7694 13.7402Z"
          stroke="#060606"
          strokeWidth="1.28906"
          stroke-miterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M28.0805 31.2812V29.1177C28.0805 27.8359 27.5944 26.69 26.8934 25.6397C26.1184 24.4402 25.7063 23.0441 25.7063 21.618V18.7773"
          stroke="#060606"
          strokeWidth="1.28906"
          stroke-miterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M28.0803 43.3545V34.6318"
          stroke="#060606"
          strokeWidth="1.28906"
          stroke-miterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M34.6643 23.8743C34.6643 20.9509 37.0462 18.581 39.9843 18.581V17.2395H38.2027C36.5762 17.2395 35.2575 15.9275 35.2575 14.3092C35.2575 13.9948 35.5137 13.7399 35.8297 13.7399H41.9296C42.901 13.7399 43.6883 14.5233 43.6883 15.4897V18.2402C43.6883 20.3724 42.8371 22.4173 41.322 23.9248L39.896 25.3435C38.9039 26.3307 38.3466 27.6697 38.3466 29.0659V43.3545"
          stroke="#060606"
          strokeWidth="1.28906"
          stroke-miterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M29.2236 13.8663C29.2236 14.4638 28.9251 14.9916 28.469 15.3086"
          stroke="#060606"
          strokeWidth="1.28906"
          stroke-miterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M30.9839 16.4531H30.9773C30.0078 16.4531 29.2219 15.6672 29.2219 14.6978V9.33629C29.2219 8.36675 30.0078 7.58085 30.9773 7.58085H30.9839C31.9534 7.58085 32.7393 8.36675 32.7393 9.33629V14.6978C32.7393 15.6672 31.9534 16.4531 30.9839 16.4531Z"
          stroke="#060606"
          strokeWidth="1.28906"
          stroke-miterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M21.3582 9.96687C21.0357 10.3399 20.5579 10.5762 20.0245 10.5762C19.0532 10.5762 18.2659 9.79259 18.2659 8.82597V2.3938C18.2659 1.42718 19.0532 0.643513 20.0245 0.643513C20.9958 0.643513 21.7832 1.42718 21.7832 2.3938V7.24695"
          stroke="#060606"
          strokeWidth="1.28906"
          stroke-miterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M25.2977 7.37988H21.7826C21.7819 7.37988 21.7815 7.37937 21.7815 7.37877V2.97524C21.7815 2.00578 22.5674 1.21988 23.5369 1.21988H23.5435C24.5129 1.21988 25.2988 2.00578 25.2988 2.97524V7.37877C25.2988 7.37937 25.2983 7.37988 25.2977 7.37988Z"
          stroke="#060606"
          strokeWidth="1.28906"
          stroke-miterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M11.2346 14.7422V6.27244"
          stroke="#060606"
          strokeWidth="1.28906"
          stroke-miterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M20.1926 17.5153C20.1926 14.5919 22.5745 12.2221 25.5126 12.2221V10.8805H23.731C22.1045 10.8805 20.7859 9.56862 20.7859 7.95024C20.7859 7.63579 21.042 7.3809 21.358 7.3809H27.458C28.4293 7.3809 29.2167 8.16431 29.2167 9.13076V11.8813C29.2167 14.0135 28.3655 16.0584 26.8503 17.5659L25.4243 18.9846C24.4322 19.9717 23.8749 21.3108 23.8749 22.7069V43.3555"
          stroke="#060606"
          strokeWidth="1.28906"
          stroke-miterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M12.9966 9.26172H12.99C12.0205 9.26172 11.2346 8.47582 11.2346 7.50636V3.80718C11.2346 2.83772 12.0205 2.05182 12.99 2.05182H12.9966C13.9661 2.05182 14.752 2.83772 14.752 3.80718V7.50636C14.752 8.47582 13.9661 9.26172 12.9966 9.26172Z"
          stroke="#060606"
          strokeWidth="1.28906"
          stroke-miterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M16.5122 10.0928H16.5055C15.5361 10.0928 14.7502 9.30687 14.7502 8.33741V2.97586C14.7502 2.0064 15.5361 1.22058 16.5055 1.22058H16.5122C17.4817 1.22058 18.2676 2.0064 18.2676 2.97586V8.33741C18.2676 9.30687 17.4817 10.0928 16.5122 10.0928Z"
          stroke="#060606"
          strokeWidth="1.28906"
          stroke-miterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M8.00864 16.9564C8.00864 16.5089 7.95837 16.0222 8.03228 15.5776C8.24446 14.3033 9.786 13.6955 10.8185 14.4623C11.4769 14.9512 11.526 15.6581 11.526 16.3975V18.8713V20.7188"
          stroke="#060606"
          strokeWidth="1.28906"
          stroke-miterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M11.101 23.4387C10.3349 24.3237 8.8841 24.2089 8.26896 23.2147C7.99491 22.7716 8.00866 22.2986 8.00866 21.8044V20.8397"
          stroke="#060606"
          strokeWidth="1.28906"
          stroke-miterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M15.0407 20.8525H11.5255C11.5249 20.8525 11.5244 20.852 11.5244 20.8514V16.4479C11.5244 15.4784 12.3104 14.6925 13.2798 14.6925H13.2865C14.2559 14.6925 15.0418 15.4784 15.0418 16.4479V20.8514C15.0418 20.852 15.0413 20.8525 15.0407 20.8525Z"
          stroke="#060606"
          strokeWidth="1.28906"
          stroke-miterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M3.35149 43.3555V36.2292C3.35149 34.9474 2.86543 33.8015 2.16435 32.7511C1.38928 31.5516 0.977295 30.1556 0.977295 28.7295V19.7441"
          stroke="#060606"
          strokeWidth="1.28906"
          stroke-miterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M9.93555 30.9858C9.93555 28.0623 12.3174 25.6925 15.2555 25.6925V24.351H13.4739C11.8474 24.351 10.5288 23.039 10.5288 21.4207C10.5288 21.1062 10.7849 20.8513 11.1009 20.8513H17.2009C18.1721 20.8513 18.9595 21.6347 18.9595 22.6012V25.3517C18.9595 27.4839 18.1084 29.5288 16.5932 31.0363L15.1672 32.455C14.1751 33.4421 13.6177 34.7812 13.6177 36.1773V43.3545"
          stroke="#060606"
          strokeWidth="1.28906"
          stroke-miterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M2.73927 22.7334H2.73257C1.76319 22.7334 0.977295 21.9475 0.977295 20.978V17.2789C0.977295 16.3094 1.76319 15.5235 2.73257 15.5235H2.73927C3.70873 15.5235 4.49463 16.3094 4.49463 17.2789V20.978C4.49463 21.9475 3.70873 22.7334 2.73927 22.7334Z"
          stroke="#060606"
          strokeWidth="1.28906"
          stroke-miterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M7.98145 17.1864C7.99134 17.1864 8.0007 17.1878 8.0105 17.1879V16.4466C8.0105 15.4771 7.2246 14.6913 6.25523 14.6913H6.24852C5.27906 14.6913 4.49316 15.4771 4.49316 16.4466V21.8081C4.49316 22.7776 5.27906 23.5635 6.24852 23.5635H6.25523C7.2246 23.5635 8.0105 22.7776 8.0105 21.8081V20.6231C8.00087 20.6233 7.99116 20.6239 7.98145 20.6239"
          stroke="#060606"
          strokeWidth="1.28906"
          stroke-miterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_1582_7987">
          <rect
            width="44"
            height="44"
            fill="white"
            transform="translate(0.333252)"
          />
        </clipPath>
      </defs>
    </svg>
  </Icon>
);

export const ArtsAndCultureIcon = (props) => (
  <Icon viewBox="0 0 45 44" {...props}>
    <svg
      width="45"
      height="44"
      viewBox="0 0 45 44"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_1582_7677)">
        <path
          d="M27.42 6.82608L11.0537 0.869241C9.11686 0.164296 6.97521 1.16298 6.27027 3.09983L2.63778 13.0799C1.53907 16.0986 1.87208 19.4529 3.54287 22.1965L7.11521 28.0627C8.32572 30.0505 10.7524 30.9337 12.9574 30.1891L19.4647 27.9916C22.5082 26.9638 24.9194 24.6083 26.0181 21.5897L29.6506 11.6096C30.3555 9.67277 29.3569 7.53103 27.42 6.82608Z"
          stroke="black"
          strokeWidth="1.28906"
          stroke-miterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M13.2796 20.2127C11.294 19.4899 9.63066 18.3977 8.47351 17.1678C7.82322 19.8956 9.30427 22.7374 12.0031 23.7198C14.702 24.702 17.6631 23.4771 18.9185 20.9695C17.2415 21.1679 15.2652 20.9354 13.2796 20.2127Z"
          stroke="black"
          strokeWidth="1.28906"
          stroke-miterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M13.0697 13.5166C12.8528 12.6496 12.1593 11.8614 11.1571 11.4966C10.1549 11.1318 9.11715 11.2899 8.39355 11.8147"
          stroke="black"
          strokeWidth="1.28906"
          stroke-miterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M22.4212 16.9199C22.2043 16.0528 21.5109 15.2647 20.5087 14.9C19.5065 14.5352 18.4687 14.6932 17.7451 15.2179"
          stroke="black"
          strokeWidth="1.28906"
          stroke-miterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M8.66016 9.26465C8.66016 9.26465 11.052 8.14935 14.559 9.42578"
          stroke="black"
          strokeWidth="1.28906"
          stroke-miterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M23.8568 14.7969C23.8568 14.7969 22.7415 12.4051 19.2344 11.1286"
          stroke="black"
          strokeWidth="1.28906"
          stroke-miterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M18.1631 31.3265L19.3149 34.4911C20.4136 37.5097 22.8249 39.8651 25.8683 40.8929L32.3756 43.0904C34.5807 43.8351 37.0073 42.9518 38.2178 40.964L41.7901 35.0979C43.4609 32.3543 43.7939 28.9999 42.6953 25.9813L39.0628 16.0011C38.3579 14.0643 36.2162 13.0656 34.2793 13.7705L31.3922 14.8214"
          stroke="black"
          strokeWidth="1.28906"
          stroke-miterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M32.4788 34.2852C34.4645 33.5625 36.4407 33.33 38.1177 33.5284C36.8624 31.0208 33.9012 29.7958 31.2024 30.7781C28.5035 31.7605 27.0224 34.6022 27.6727 37.3301C28.8299 36.1001 30.4932 35.008 32.4788 34.2852Z"
          stroke="black"
          strokeWidth="1.28906"
          stroke-miterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M22.8765 29.2265C23.7115 29.5452 24.7547 29.428 25.6277 28.8152C26.5005 28.2024 26.9652 27.2611 26.9493 26.3675"
          stroke="black"
          strokeWidth="1.28906"
          stroke-miterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M36.5832 24.2393C36.1483 25.0201 35.2739 25.6009 34.2113 25.6926C33.1487 25.7843 32.1877 25.3619 31.6255 24.6671"
          stroke="black"
          strokeWidth="1.28906"
          stroke-miterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M36.6737 22.167C36.6737 22.167 34.2819 21.0517 30.7749 22.3281"
          stroke="black"
          strokeWidth="1.28906"
          stroke-miterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_1582_7677">
          <rect
            width="44"
            height="44"
            fill="white"
            transform="translate(0.666504)"
          />
        </clipPath>
      </defs>
    </svg>
  </Icon>
);

export const AnimalCareAndServicesIcon = (props) => (
  <Icon viewBox="0 0 45 44" {...props}>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="44"
      height="44"
      viewBox="0 0 44 44"
      fill="none"
    >
      <path
        d="M6.94117 27.9293L4.35703 25.3451C-0.592969 20.3951 -0.592969 12.3686 4.35703 7.41856C6.77187 5.00372 10.0109 3.7052 13.322 3.7052C14.6102 3.7052 15.9079 3.902 17.1729 4.30505L22 5.84419L26.8271 4.30505C31.1498 2.92575 35.8643 3.96645 39.2004 6.99661"
        stroke="black"
        strokeWidth="0.9375"
        stroke-miterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M41.1693 9.26172C42.6268 11.4033 43.3556 13.8929 43.3556 16.3825C43.3556 19.6266 42.1181 22.8708 39.6431 25.3458L26.5986 38.3902C25.3792 39.6097 23.7249 40.2946 22.0001 40.2946C21.1373 40.2946 20.2934 40.1236 19.5114 39.7996C18.7293 39.4765 18.0109 39.0004 17.4016 38.3902L9.06738 30.056"
        stroke="black"
        strokeWidth="0.9375"
        stroke-miterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M32.9309 19.9849C34.1421 19.9849 35.124 19.003 35.124 17.7918C35.124 16.5805 34.1421 15.5986 32.9309 15.5986C31.7197 15.5986 30.7378 16.5805 30.7378 17.7918C30.7378 19.003 31.7197 19.9849 32.9309 19.9849Z"
        stroke="black"
        strokeWidth="0.9375"
        stroke-miterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M26.2493 14.6167C27.4605 14.6167 28.4424 13.6348 28.4424 12.4236C28.4424 11.2124 27.4605 10.2305 26.2493 10.2305C25.038 10.2305 24.0562 11.2124 24.0562 12.4236C24.0562 13.6348 25.038 14.6167 26.2493 14.6167Z"
        stroke="black"
        strokeWidth="0.9375"
        stroke-miterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.0691 19.9849C12.2803 19.9849 13.2622 19.003 13.2622 17.7918C13.2622 16.5805 12.2803 15.5986 11.0691 15.5986C9.85787 15.5986 8.87598 16.5805 8.87598 17.7918C8.87598 19.003 9.85787 19.9849 11.0691 19.9849Z"
        stroke="black"
        strokeWidth="0.9375"
        stroke-miterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.7507 14.6167C18.962 14.6167 19.9439 13.6348 19.9439 12.4236C19.9439 11.2124 18.962 10.2305 17.7507 10.2305C16.5395 10.2305 15.5576 11.2124 15.5576 12.4236C15.5576 13.6348 16.5395 14.6167 17.7507 14.6167Z"
        stroke="black"
        strokeWidth="0.9375"
        stroke-miterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M27.019 21.6497L28.4825 23.1132C30.3018 24.9325 30.3018 27.8811 28.4825 29.7004C27.5957 30.5872 26.4063 31.0642 25.1894 31.0642C24.7159 31.0642 24.2389 30.992 23.774 30.8442L22.0003 30.2787L20.2265 30.8442C18.5662 31.3736 16.7495 30.9327 15.518 29.7004C14.6079 28.7903 14.1533 27.5992 14.1533 26.4064C14.1533 25.2153 14.6079 24.0225 15.518 23.1132L20.3107 18.3205C20.7585 17.8719 21.3669 17.6201 22.0003 17.6201C22.3165 17.6201 22.6276 17.6829 22.9146 17.8023C23.2017 17.9209 23.4664 18.0962 23.6898 18.3205L24.8929 19.5236"
        stroke="black"
        strokeWidth="0.9375"
        stroke-miterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  </Icon>
);

export const ExportIcon = (props) => (
  <Icon viewBox="0 0 20 20" {...props}>
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.6482 6.90039H12.6596V8.67368H15.6482C16.5369 8.67368 17.2264 9.12764 17.2264 9.51835V17.3817C17.2264 17.7724 16.5369 18.2264 15.6482 18.2264H4.35175C3.46304 18.2264 2.77353 17.7724 2.77353 17.3817V9.51865C2.77353 9.12793 3.46304 8.67397 4.35175 8.67397H7.33974V6.90069H4.35175C2.47237 6.90069 1.00024 8.05066 1.00024 9.51865V17.382C1.00024 18.8503 2.47237 19.9999 4.35175 19.9999H15.6485C17.5276 19.9999 19 18.85 19 17.382V9.51865C18.9997 8.05037 17.5276 6.90039 15.6482 6.90039Z"
        fill="#EE5A29"
      />
      <path
        d="M7.3762 4.41991C7.60318 4.41991 7.82986 4.33332 8.00305 4.16013L9.11313 3.05005V6.90045V8.67373V12.0708C9.11313 12.5605 9.51005 12.9574 9.99977 12.9574C10.4895 12.9574 10.8864 12.5605 10.8864 12.0708V8.67373V6.90045V2.99006L12.0565 4.16013C12.2297 4.33332 12.4567 4.41991 12.6833 4.41991C12.91 4.41991 13.137 4.33332 13.3102 4.16013C13.6566 3.81404 13.6566 3.2525 13.3102 2.90641L10.663 0.259195C10.4898 0.0860043 10.2631 0 10.0364 0C10.0341 0 10.032 0 10.0296 0C10.0273 0 10.0252 0 10.0228 0C9.79614 0 9.56945 0.0860043 9.39626 0.259195L6.74904 2.90641C6.40266 3.2525 6.40266 3.81404 6.74904 4.16013C6.92253 4.33332 7.14922 4.41991 7.3762 4.41991Z"
        fill="#EE5A29"
      />
    </svg>
  </Icon>
);

export const EditGoalsIcon = (props) => (
  <Icon {...props}>
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.16446 16.3491C3.97246 16.3491 3.78083 16.2759 3.63421 16.1293C3.34133 15.8364 3.34133 15.3617 3.63421 15.0688L15.3545 3.34856C15.647 3.05569 16.1221 3.05569 16.415 3.34856C16.7078 3.64144 16.7078 4.11619 16.415 4.40906L4.69471 16.1293C4.54846 16.2756 4.35646 16.3491 4.16446 16.3491Z"
        fill="#EE5A29"
      />
      <path
        d="M3.00636 21.7499C2.95424 21.7499 2.90136 21.7443 2.84849 21.733C2.44349 21.646 2.18549 21.2474 2.27249 20.8424L3.43124 15.4413C3.51824 15.0363 3.91874 14.779 4.32186 14.8653C4.72686 14.9523 4.98486 15.3509 4.89786 15.7559L3.73911 21.157C3.66374 21.5092 3.35249 21.7499 3.00636 21.7499Z"
        fill="#EE5A29"
      />
      <path
        d="M8.40664 20.5909C8.21464 20.5909 8.02302 20.5178 7.87639 20.3711C7.58352 20.0783 7.58352 19.6035 7.87639 19.3106L19.5966 7.59075C19.8891 7.29787 20.3643 7.29787 20.6571 7.59075C20.95 7.88363 20.95 8.35837 20.6571 8.65125L8.93727 20.3711C8.79064 20.5178 8.59864 20.5909 8.40664 20.5909Z"
        fill="#EE5A29"
      />
      <path
        d="M3.00488 21.7496C2.65876 21.7496 2.34788 21.5088 2.27213 21.1567C2.18551 20.7517 2.44313 20.3531 2.84813 20.2661L8.24926 19.1073C8.65463 19.0215 9.05326 19.2787 9.13988 19.6833C9.22651 20.0883 8.96888 20.487 8.56388 20.574L3.16276 21.7327C3.10988 21.7443 3.05701 21.7496 3.00488 21.7496Z"
        fill="#EE5A29"
      />
      <path
        d="M18.0057 10.9923C17.8137 10.9923 17.6217 10.9192 17.4755 10.7725L13.2331 6.53016C12.9402 6.23728 12.9402 5.76253 13.2331 5.46966C13.5256 5.17678 14.0011 5.17678 14.2936 5.46966L18.536 9.71203C18.8288 10.0049 18.8288 10.4797 18.536 10.7725C18.3897 10.9192 18.1977 10.9923 18.0057 10.9923Z"
        fill="#EE5A29"
      />
      <path
        d="M20.1271 8.87147C19.9351 8.87147 19.7431 8.79834 19.5964 8.65172C19.3036 8.35884 19.3036 7.88409 19.5964 7.59084C20.0138 7.17347 20.2437 6.60834 20.2437 6.00009C20.2437 5.39184 20.0138 4.82672 19.5964 4.40934C19.1787 3.99159 18.6136 3.76172 18.0053 3.76172C17.3971 3.76172 16.8319 3.99159 16.4146 4.40934C16.1221 4.70222 15.6473 4.70259 15.3537 4.40934C15.0608 4.11647 15.0608 3.64172 15.3537 3.34847C16.0542 2.64759 16.9958 2.26172 18.0053 2.26172C19.0144 2.26172 19.9564 2.64759 20.6569 3.34847C21.3578 4.04897 21.7437 4.99059 21.7437 6.00009C21.7437 7.00959 21.3578 7.95122 20.6569 8.65172C20.5111 8.79797 20.3191 8.87147 20.1271 8.87147Z"
        fill="#EE5A29"
      />
    </svg>
  </Icon>
);

export const BackIcon = (props) => (
  <Icon {...props}>
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16 7.71429L11 12L16 16.2857L15 18L8 12L15 6L16 7.71429Z"
        fill="black"
      />
    </svg>
  </Icon>
);

export const GoalCarretDown = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    {...props}
  >
    <mask
      id="a"
      width={24}
      height={24}
      x={0}
      y={0}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: "alpha",
      }}
    >
      <path fill="#D9D9D9" d="M24 24H0V0h24z" />
    </mask>
    <g mask="url(#a)">
      <path
        fill="#1C1B1F"
        d="M17.3 9.327a.948.948 0 0 1 .275.7.949.949 0 0 1-.275.7l-4.6 4.6c-.1.1-.208.17-.325.212a1.109 1.109 0 0 1-.375.063c-.133 0-.258-.021-.375-.063a.877.877 0 0 1-.325-.212l-4.625-4.625a.918.918 0 0 1-.275-.675c0-.267.1-.5.3-.7a.948.948 0 0 1 .7-.275c.283 0 .517.091.7.275l3.9 3.9 3.925-3.925a.918.918 0 0 1 .675-.275c.267 0 .5.1.7.3Z"
      />
    </g>
  </svg>
);

export const CarretDown = (props) => (
  <Icon {...props}>
    <svg
      width="12"
      height="7"
      viewBox="0 0 12 7"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.99999 6.66141C5.88589 6.66141 5.77532 6.64218 5.66827 6.60371C5.56122 6.56524 5.4609 6.49922 5.36732 6.40564L0.857691 1.89604C0.712824 1.75117 0.642957 1.57809 0.648091 1.37681C0.653207 1.17553 0.728207 1.00245 0.873091 0.857586C1.01796 0.712719 1.19359 0.640286 1.39999 0.640286C1.60639 0.640286 1.78202 0.712719 1.92689 0.857586L5.99999 4.93069L10.0885 0.842211C10.2333 0.697344 10.4064 0.627469 10.6077 0.632586C10.809 0.637719 10.982 0.712719 11.1269 0.857586C11.2718 1.00245 11.3442 1.17809 11.3442 1.38451C11.3442 1.59091 11.2718 1.76654 11.1269 1.91141L6.63267 6.40564C6.53908 6.49922 6.44037 6.56524 6.33652 6.60371C6.23268 6.64218 6.12051 6.66141 5.99999 6.66141Z"
        fill="#1C1B1F"
      />
    </svg>
  </Icon>
);

export const CarretUp = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    {...props}
  >
    <mask
      id="a"
      width={24}
      height={24}
      x={0}
      y={0}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: "alpha",
      }}
    >
      <path fill="#D9D9D9" d="M0 0h24v24H0z" />
    </mask>
    <g mask="url(#a)">
      <path
        fill="#1C1B1F"
        d="M6.7 14.673a.948.948 0 0 1-.275-.7c0-.283.092-.516.275-.7l4.6-4.6c.1-.1.208-.17.325-.212.117-.042.242-.063.375-.063s.258.021.375.063a.877.877 0 0 1 .325.212l4.625 4.625a.918.918 0 0 1 .275.675c0 .267-.1.5-.3.7a.948.948 0 0 1-.7.275.948.948 0 0 1-.7-.275l-3.9-3.9-3.925 3.925a.917.917 0 0 1-.675.275.96.96 0 0 1-.7-.3Z"
      />
    </g>
  </svg>
);

export const Union = (props) => (
  <Icon viewBox="0 0 166 120" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M124.354 11.1687C127.295 10.4141 130.39 10.5118 133.277 11.4504C136.165 12.389 138.726 14.1298 140.661 16.4694C142.596 18.8091 143.826 21.651 144.206 24.6634C144.587 27.6758 144.102 30.7342 142.809 33.4815C141.517 36.2288 139.469 38.5516 136.905 40.1787C134.406 41.7647 131.518 42.6258 128.561 42.6684C128.483 42.6681 128.406 42.6679 128.328 42.668C125.475 42.6704 123.147 44.9122 123.006 47.7294C123.002 47.8089 123 47.8889 122.999 47.9693C122.999 47.9808 122.999 47.9923 122.999 48.0038C122.999 50.9493 125.387 53.3369 128.333 53.3367C128.42 53.3367 128.508 53.3362 128.596 53.3354C133.888 53.3705 139.103 54.6192 143.839 56.9868C148.653 59.3929 152.838 62.8884 156.064 67.1955C157.83 69.5531 161.173 70.0329 163.53 68.2671C165.888 66.5014 166.368 63.1588 164.602 60.8012C160.382 55.1665 154.906 50.5937 148.609 47.4459C147.849 47.0659 147.079 46.708 146.301 46.3724C148.87 44.0294 150.968 41.1961 152.461 38.0231C154.615 33.4444 155.423 28.3473 154.789 23.3269C154.155 18.3065 152.105 13.5702 148.88 9.67092C145.655 5.77168 141.387 2.87051 136.575 1.30623C131.762 -0.258052 126.604 -0.420875 121.703 0.836775C116.801 2.09442 112.359 4.72064 108.894 8.40871C105.429 12.0968 103.085 16.6945 102.136 21.6649C101.583 24.5581 103.481 27.3515 106.374 27.9041C109.267 28.4567 112.06 26.5593 112.613 23.6661C113.183 20.6838 114.589 17.925 116.668 15.7121C118.747 13.4991 121.413 11.9233 124.354 11.1687ZM41.645 11.1684C38.7044 10.4141 35.6099 10.5119 32.7229 11.4505C29.8358 12.389 27.2753 14.1296 25.3404 16.4689C23.4056 18.8082 22.1761 21.6497 21.7957 24.6615C21.4153 27.6734 21.8995 30.7313 23.192 33.4783C24.4844 36.2252 26.5317 38.5477 29.0947 40.1747C31.6577 41.8017 34.6307 42.6659 37.6665 42.6665C38.5723 42.6666 39.4254 42.8926 40.1724 43.2912C41.8572 44.1887 43.0034 45.9637 43.0017 48.0057C42.9992 50.9513 40.6094 53.3371 37.6639 53.3346C32.2825 53.3301 26.9742 54.5808 22.1607 56.9871C17.3473 59.3935 13.1614 62.8893 9.93557 67.1968C8.16996 69.5544 4.82737 70.0344 2.46971 68.2688C0.112036 66.5032 -0.367919 63.1606 1.3977 60.8029C5.61776 55.1678 11.0939 50.5944 17.391 47.4463C18.1522 47.0658 18.9229 46.7074 19.702 46.3712C17.1319 44.0277 15.0338 41.1935 13.5403 38.0194C11.3862 33.4412 10.5791 28.3446 11.2132 23.3248C11.8472 18.3051 13.8963 13.5693 17.1211 9.67045C20.3459 5.77163 24.6133 2.87071 29.4251 1.30644C34.2369 -0.257831 39.3944 -0.420894 44.2954 0.836291C49.1964 2.09348 53.6386 4.71903 57.1032 8.40634C60.5679 12.0937 62.912 16.6906 63.8619 21.6603C64.4149 24.5534 62.5178 27.347 59.6247 27.9C56.7315 28.453 53.9379 26.5559 53.3849 23.6628C52.815 20.681 51.4085 17.9228 49.3297 15.7104C47.2509 13.498 44.5856 11.9227 41.645 11.1684ZM61.6657 64.0038C61.6657 52.2217 71.2169 42.6705 82.9989 42.6705C94.7809 42.6705 104.332 52.2217 104.332 64.0038C104.332 75.6335 95.0262 85.0897 83.4546 85.3322C83.3042 85.3308 83.1538 85.3301 83.0033 85.3301C82.8509 85.3301 82.6985 85.3308 82.5461 85.3323C70.9731 85.0913 61.6657 75.6345 61.6657 64.0038ZM63.575 89.4362C55.9301 83.5886 50.999 74.372 50.999 64.0038C50.999 46.3307 65.3259 32.0039 82.9989 32.0039C100.672 32.0039 114.999 46.3307 114.999 64.0038C114.999 74.3705 110.069 83.5859 102.426 89.4336C104.504 90.3527 106.522 91.4215 108.463 92.6352C116.096 97.409 122.234 104.233 126.175 112.328C127.465 114.976 126.363 118.168 123.715 119.458C121.067 120.747 117.875 119.645 116.585 116.997C113.519 110.7 108.745 105.392 102.807 101.679C97.007 98.0519 90.3248 96.0891 83.4907 95.9999C83.3271 96.0024 83.1631 96.0036 82.9989 96.0036C82.8361 96.0036 82.6735 96.0024 82.5113 96C75.6788 96.09 68.9985 98.0528 63.1996 101.679C57.2617 105.392 52.4874 110.701 49.4217 116.997C48.1323 119.646 44.9402 120.747 42.2919 119.458C39.6436 118.169 38.542 114.976 39.8313 112.328C43.7725 104.233 49.9103 97.4091 57.544 92.6353C59.4832 91.4227 61.499 90.3547 63.575 89.4362Z"
      fill="#B3B3B3"
    />
  </Icon>
);

export const TwoUsers = (props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.3 12.22C12.8336 11.7581 13.2616 11.1869 13.5549 10.545C13.8482 9.90316 14 9.20571 14 8.5C14 7.17392 13.4732 5.90215 12.5355 4.96447C11.5979 4.02678 10.3261 3.5 9 3.5C7.67392 3.5 6.40215 4.02678 5.46447 4.96447C4.52678 5.90215 4 7.17392 4 8.5C3.99999 9.20571 4.1518 9.90316 4.44513 10.545C4.73845 11.1869 5.16642 11.7581 5.7 12.22C4.30014 12.8539 3.11247 13.8775 2.27898 15.1685C1.4455 16.4596 1.00147 17.9633 1 19.5C1 19.7652 1.10536 20.0196 1.29289 20.2071C1.48043 20.3946 1.73478 20.5 2 20.5C2.26522 20.5 2.51957 20.3946 2.70711 20.2071C2.89464 20.0196 3 19.7652 3 19.5C3 17.9087 3.63214 16.3826 4.75736 15.2574C5.88258 14.1321 7.4087 13.5 9 13.5C10.5913 13.5 12.1174 14.1321 13.2426 15.2574C14.3679 16.3826 15 17.9087 15 19.5C15 19.7652 15.1054 20.0196 15.2929 20.2071C15.4804 20.3946 15.7348 20.5 16 20.5C16.2652 20.5 16.5196 20.3946 16.7071 20.2071C16.8946 20.0196 17 19.7652 17 19.5C16.9985 17.9633 16.5545 16.4596 15.721 15.1685C14.8875 13.8775 13.6999 12.8539 12.3 12.22ZM9 11.5C8.40666 11.5 7.82664 11.3241 7.33329 10.9944C6.83994 10.6648 6.45542 10.1962 6.22836 9.64805C6.0013 9.09987 5.94189 8.49667 6.05764 7.91473C6.1734 7.33279 6.45912 6.79824 6.87868 6.37868C7.29824 5.95912 7.83279 5.6734 8.41473 5.55764C8.99667 5.44189 9.59987 5.5013 10.1481 5.72836C10.6962 5.95542 11.1648 6.33994 11.4944 6.83329C11.8241 7.32664 12 7.90666 12 8.5C12 9.29565 11.6839 10.0587 11.1213 10.6213C10.5587 11.1839 9.79565 11.5 9 11.5ZM18.74 11.82C19.38 11.0993 19.798 10.2091 19.9438 9.25634C20.0896 8.30362 19.9569 7.32907 19.5618 6.45C19.1666 5.57093 18.5258 4.8248 17.7165 4.30142C16.9071 3.77805 15.9638 3.49974 15 3.5C14.7348 3.5 14.4804 3.60536 14.2929 3.79289C14.1054 3.98043 14 4.23478 14 4.5C14 4.76522 14.1054 5.01957 14.2929 5.20711C14.4804 5.39464 14.7348 5.5 15 5.5C15.7956 5.5 16.5587 5.81607 17.1213 6.37868C17.6839 6.94129 18 7.70435 18 8.5C17.9986 9.02524 17.8593 9.5409 17.5961 9.99542C17.3328 10.4499 16.9549 10.8274 16.5 11.09C16.3517 11.1755 16.2279 11.2977 16.1404 11.4447C16.0528 11.5918 16.0045 11.7589 16 11.93C15.9958 12.0998 16.0349 12.2678 16.1137 12.4183C16.1924 12.5687 16.3081 12.6967 16.45 12.79L16.84 13.05L16.97 13.12C18.1754 13.6917 19.1923 14.596 19.901 15.7263C20.6096 16.8566 20.9805 18.1659 20.97 19.5C20.97 19.7652 21.0754 20.0196 21.2629 20.2071C21.4504 20.3946 21.7048 20.5 21.97 20.5C22.2352 20.5 22.4896 20.3946 22.6771 20.2071C22.8646 20.0196 22.97 19.7652 22.97 19.5C22.9782 17.9654 22.5938 16.4543 21.8535 15.1101C21.1131 13.7659 20.0413 12.6333 18.74 11.82Z"
        fill={props.color}
      />
    </svg>
  </Icon>
);

export const AddMemberIcon = (props) => (
  <Icon viewBox="0 0 16 16" {...props}>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
    >
      <g clipPath="url(#clip0_2734_16247)">
        <path
          d="M8 0C3.58853 0 0 3.58853 0 8C0 12.4115 3.58853 16 8 16C12.4115 16 16 12.4108 16 8C16 3.58916 12.4115 0 8 0ZM8 14.7607C4.27266 14.7607 1.23934 11.728 1.23934 8C1.23934 4.27203 4.27266 1.23934 8 1.23934C11.7273 1.23934 14.7607 4.27203 14.7607 8C14.7607 11.728 11.728 14.7607 8 14.7607Z"
          fill={props.color}
        />
        <path
          d="M11.0984 7.32445H8.61969V4.84576C8.61969 4.5037 8.34269 4.22607 8 4.22607C7.65731 4.22607 7.38031 4.5037 7.38031 4.84576V7.32445H4.90162C4.55894 7.32445 4.28194 7.60207 4.28194 7.94414C4.28194 8.2862 4.55894 8.56382 4.90162 8.56382H7.38031V11.0425C7.38031 11.3846 7.65731 11.6622 8 11.6622C8.34269 11.6622 8.61969 11.3846 8.61969 11.0425V8.56382H11.0984C11.4411 8.56382 11.7181 8.2862 11.7181 7.94414C11.7181 7.60207 11.4411 7.32445 11.0984 7.32445Z"
          fill={props.color}
        />
      </g>
      <defs>
        <clipPath id="clip0_2734_16247">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  </Icon>
);

export const CircleWayvyCheck = (props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.85607 3.337C9.53746 3.61152 9.1571 3.89721 8.71816 4.07882C8.28516 4.25798 7.81752 4.3188 7.40573 4.34553C7.13684 4.36299 6.83661 4.36764 6.56284 4.37188C6.43203 4.3739 6.30725 4.37583 6.19483 4.37902C5.36992 4.40244 4.94994 4.50386 4.7269 4.7269C4.50386 4.94994 4.40244 5.36992 4.37903 6.19482C4.37584 6.30725 4.37391 6.43202 4.37188 6.56283C4.36764 6.8366 4.36299 7.13683 4.34554 7.40572C4.31881 7.81751 4.25798 8.28515 4.07883 8.71815C3.89721 9.15709 3.61152 9.53745 3.33701 9.85605C3.14795 10.0755 2.93009 10.3027 2.73273 10.5085C2.65106 10.5937 2.5729 10.6752 2.50175 10.751C2.23673 11.0333 2.0321 11.2726 1.89285 11.498C1.75715 11.7177 1.71429 11.8759 1.71429 12C1.71429 12.1241 1.75715 12.2822 1.89285 12.5019C2.03211 12.7274 2.23673 12.9666 2.50175 13.2489C2.5729 13.3247 2.65106 13.4062 2.73272 13.4914C2.93008 13.6973 3.14795 13.9245 3.337 14.1439C3.61152 14.4625 3.89721 14.8429 4.07882 15.2818C4.25798 15.7148 4.3188 16.1825 4.34553 16.5943C4.36299 16.8632 4.36764 17.1634 4.37188 17.4372C4.3739 17.568 4.37583 17.6927 4.37902 17.8052C4.40244 18.6301 4.50386 19.0501 4.7269 19.2731C4.94994 19.4961 5.36992 19.5976 6.19482 19.621C6.30724 19.6242 6.43201 19.6261 6.56282 19.6281C6.83659 19.6324 7.13683 19.637 7.40572 19.6545C7.81751 19.6812 8.28515 19.742 8.71815 19.9212C9.15709 20.1028 9.53745 20.3885 9.85605 20.663C10.0755 20.8521 10.3027 21.0699 10.5086 21.2673C10.5937 21.3489 10.6752 21.4271 10.751 21.4982C11.0333 21.7633 11.2726 21.9679 11.498 22.1072C11.7177 22.2428 11.8759 22.2857 12 22.2857C12.1241 22.2857 12.2822 22.2428 12.5019 22.1072C12.7274 21.9679 12.9666 21.7633 13.2489 21.4982C13.3247 21.4271 13.4062 21.349 13.4914 21.2673C13.6973 21.0699 13.9245 20.8521 14.1439 20.663C14.4625 20.3885 14.8429 20.1028 15.2818 19.9212C15.7148 19.742 16.1825 19.6812 16.5943 19.6545C16.8632 19.637 17.1634 19.6324 17.4372 19.6281C17.568 19.6261 17.6928 19.6242 17.8052 19.621C18.6301 19.5976 19.0501 19.4961 19.2731 19.2731C19.4961 19.0501 19.5976 18.6301 19.621 17.8052C19.6242 17.6928 19.6261 17.568 19.6281 17.4372C19.6324 17.1634 19.637 16.8632 19.6545 16.5943C19.6812 16.1825 19.742 15.7148 19.9212 15.2819C20.1028 14.8429 20.3885 14.4626 20.663 14.144C20.8521 13.9245 21.0699 13.6973 21.2673 13.4914C21.3489 13.4063 21.4271 13.3248 21.4982 13.249C21.7633 12.9667 21.9679 12.7274 22.1072 12.502C22.2428 12.2823 22.2857 12.1241 22.2857 12C22.2857 11.8759 22.2428 11.7178 22.1072 11.4981C21.9679 11.2726 21.7633 11.0334 21.4982 10.7511C21.4271 10.6753 21.349 10.5938 21.2673 10.5086C21.0699 10.3027 20.8521 10.0755 20.663 9.85607C20.3885 9.53746 20.1028 9.1571 19.9212 8.71816C19.742 8.28516 19.6812 7.81752 19.6545 7.40573C19.637 7.13684 19.6324 6.8366 19.6281 6.56283C19.6261 6.43202 19.6242 6.30725 19.621 6.19483C19.5976 5.36992 19.4961 4.94994 19.2731 4.7269C19.0501 4.50386 18.6301 4.40244 17.8052 4.37903C17.6928 4.37584 17.568 4.37391 17.4372 4.37188C17.1634 4.36764 16.8632 4.36299 16.5943 4.34554C16.1825 4.31881 15.7148 4.25798 15.2819 4.07883L15.6096 3.2868L15.2819 4.07883C14.8429 3.89721 14.4626 3.61152 14.144 3.33701C13.9245 3.14795 13.6973 2.93009 13.4915 2.73273C13.4063 2.65106 13.3248 2.5729 13.249 2.50175C12.9667 2.23673 12.7274 2.0321 12.502 1.89285C12.2823 1.75715 12.1241 1.71429 12 1.71429C11.8759 1.71429 11.7178 1.75715 11.4981 1.89285C11.2726 2.03211 11.0334 2.23673 10.7511 2.50175C10.6753 2.57291 10.5938 2.65107 10.5086 2.73273C10.3027 2.93009 10.0755 3.14795 9.85607 3.337ZM10.5972 0.43436C10.9834 0.195798 11.4542 0 12 0C12.5459 0 13.0167 0.195802 13.4029 0.434366C13.7833 0.66937 14.1269 0.974598 14.4223 1.25195C14.5278 1.35093 14.6253 1.44453 14.7186 1.53405C14.9074 1.71519 15.0788 1.87966 15.263 2.03831C15.5297 2.26813 15.7474 2.41623 15.9373 2.49478C16.1108 2.56659 16.3569 2.61224 16.7053 2.63485C16.9351 2.64977 17.156 2.65299 17.4001 2.65656C17.5415 2.65862 17.6906 2.6608 17.8538 2.66543C18.6139 2.687 19.7222 2.75162 20.4853 3.51472C21.2484 4.27782 21.313 5.3861 21.3346 6.14619C21.3392 6.30935 21.3414 6.45852 21.3434 6.59993C21.347 6.84401 21.3502 7.06495 21.3652 7.29468C21.3878 7.6431 21.4334 7.88918 21.5052 8.06275L20.7132 8.39045L21.5052 8.06275C21.5838 8.2526 21.7319 8.47035 21.9617 8.73708C22.1204 8.92121 22.2848 9.09263 22.466 9.28143C22.5555 9.37473 22.6491 9.47229 22.7481 9.57772C23.0254 9.87315 23.3306 10.2167 23.5656 10.5972C23.8042 10.9834 24 11.4542 24 12C24 12.5459 23.8042 13.0167 23.5656 13.4029C23.3306 13.7833 23.0254 14.1269 22.748 14.4223C22.6491 14.5278 22.5555 14.6253 22.466 14.7186C22.2848 14.9074 22.1203 15.0788 21.9617 15.263C21.7319 15.5297 21.5838 15.7474 21.5052 15.9373C21.4334 16.1108 21.3878 16.3569 21.3651 16.7053C21.3502 16.935 21.347 17.156 21.3434 17.4C21.3414 17.5415 21.3392 17.6906 21.3346 17.8538C21.313 18.6139 21.2484 19.7222 20.4853 20.4853C19.7222 21.2484 18.6139 21.313 17.8538 21.3346C17.6907 21.3392 17.5415 21.3414 17.4001 21.3434C17.156 21.347 16.9351 21.3502 16.7053 21.3652C16.3569 21.3878 16.1108 21.4334 15.9373 21.5052C15.7474 21.5838 15.5297 21.7319 15.2629 21.9617C15.0788 22.1204 14.9074 22.2848 14.7186 22.466C14.6253 22.5555 14.5277 22.6491 14.4223 22.7481C14.1269 23.0254 13.7833 23.3306 13.4028 23.5656C13.0166 23.8042 12.5458 24 12 24C11.4541 24 10.9833 23.8042 10.5971 23.5656C10.2167 23.3306 9.87309 23.0254 9.57767 22.748C9.47224 22.6491 9.37469 22.5555 9.2814 22.466C9.09259 22.2848 8.92118 22.1203 8.73705 21.9617C8.47032 21.7319 8.25257 21.5838 8.06274 21.5052C7.88917 21.4334 7.64309 21.3878 7.29467 21.3651C7.06495 21.3502 6.84403 21.347 6.59996 21.3434C6.45855 21.3414 6.30936 21.3392 6.14619 21.3346C5.38609 21.313 4.27782 21.2484 3.51472 20.4853C2.75162 19.7222 2.687 18.6139 2.66543 17.8538C2.6608 17.6906 2.65862 17.5415 2.65655 17.4001C2.65299 17.156 2.64976 16.935 2.63485 16.7053C2.61223 16.3569 2.56659 16.1108 2.49477 15.9373C2.41622 15.7474 2.26812 15.5297 2.0383 15.2629C1.87964 15.0788 1.71518 14.9074 1.53404 14.7186C1.44452 14.6253 1.35092 14.5277 1.25194 14.4223C0.974587 14.1269 0.669361 13.7833 0.43436 13.4028C0.195798 13.0166 0 12.5458 0 12C0 11.4541 0.195802 10.9833 0.434366 10.5971C0.66937 10.2167 0.974598 9.87309 1.25195 9.57767C1.35093 9.47224 1.44452 9.37469 1.53404 9.28139C1.71519 9.09259 1.87966 8.92118 2.03831 8.73705C2.26813 8.47032 2.41623 8.25257 2.49478 8.06274C2.56659 7.88917 2.61224 7.64309 2.63485 7.29467C2.64977 7.06495 2.65299 6.84402 2.65656 6.59994C2.65862 6.45853 2.6608 6.30935 2.66543 6.14619C2.687 5.38609 2.75162 4.27782 3.51472 3.51472C4.27782 2.75162 5.3861 2.687 6.14619 2.66543C6.30936 2.6608 6.45854 2.65862 6.59995 2.65655C6.84403 2.65299 7.06495 2.64976 7.29468 2.63485C7.6431 2.61223 7.88918 2.56659 8.06275 2.49477L8.39045 3.2868L8.06275 2.49477C8.2526 2.41622 8.47035 2.26812 8.73708 2.0383C8.92122 1.87964 9.09263 1.71518 9.28143 1.53404C9.37474 1.44452 9.47229 1.35092 9.57772 1.25194C9.87315 0.974587 10.2167 0.669361 10.5972 0.43436Z"
        fill="black"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.3344 8.83758C17.6613 9.18 17.6487 9.72257 17.3063 10.0494L11.0205 16.0494C10.6893 16.3656 10.1681 16.3656 9.83684 16.0494L6.69402 13.0494C6.35159 12.7226 6.33898 12.18 6.66584 11.8376C6.9927 11.4951 7.53527 11.4825 7.8777 11.8094L10.4287 14.2445L16.1226 8.80939C16.465 8.48253 17.0076 8.49515 17.3344 8.83758Z"
        fill="black"
      />
    </svg>
  </Icon>
);

export const Flag = (props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4 22V15"
        stroke="black"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4 15C4 15 5 14 8 14C11 14 13 16 16 16C19 16 20 15 20 15V3C20 3 19 4 16 4C13 4 11 2 8 2C5 2 4 3 4 3V15Z"
        stroke="black"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  </Icon>
);

export const MoreIcon = (props) => (
  <Icon viewBox="0 0 24 24">
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_2794_15771"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="24"
        height="24"
      >
        <rect width="24" height="24" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_2794_15771)">
        <path
          d="M6 14C5.45 14 4.97917 13.8042 4.5875 13.4125C4.19583 13.0208 4 12.55 4 12C4 11.45 4.19583 10.9792 4.5875 10.5875C4.97917 10.1958 5.45 10 6 10C6.55 10 7.02083 10.1958 7.4125 10.5875C7.80417 10.9792 8 11.45 8 12C8 12.55 7.80417 13.0208 7.4125 13.4125C7.02083 13.8042 6.55 14 6 14ZM12 14C11.45 14 10.9792 13.8042 10.5875 13.4125C10.1958 13.0208 10 12.55 10 12C10 11.45 10.1958 10.9792 10.5875 10.5875C10.9792 10.1958 11.45 10 12 10C12.55 10 13.0208 10.1958 13.4125 10.5875C13.8042 10.9792 14 11.45 14 12C14 12.55 13.8042 13.0208 13.4125 13.4125C13.0208 13.8042 12.55 14 12 14ZM18 14C17.45 14 16.9792 13.8042 16.5875 13.4125C16.1958 13.0208 16 12.55 16 12C16 11.45 16.1958 10.9792 16.5875 10.5875C16.9792 10.1958 17.45 10 18 10C18.55 10 19.0208 10.1958 19.4125 10.5875C19.8042 10.9792 20 11.45 20 12C20 12.55 19.8042 13.0208 19.4125 13.4125C19.0208 13.8042 18.55 14 18 14Z"
          fill="#1C1B1F"
        />
      </g>
    </svg>
  </Icon>
);

export const Google = ({ className, ...rest }: any) => (
  <svg
    aria-hidden="true"
    focusable="false"
    role="img"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="none"
    className={`chakra-icon ${className || ""}`}
    {...rest}
  >
    <path
      d="M23.7666 9.6498H22.8V9.6H12V14.4H18.7818C17.7924 17.1942 15.1338 19.2 12 19.2C8.0238 19.2 4.8 15.9762 4.8 12C4.8 8.0238 8.0238 4.8 12 4.8C13.8354 4.8 15.5052 5.4924 16.7766 6.6234L20.1708 3.2292C18.0276 1.2318 15.1608 0 12 0C5.373 0 0 5.373 0 12C0 18.627 5.373 24 12 24C18.627 24 24 18.627 24 12C24 11.1954 23.9172 10.41 23.7666 9.6498Z"
      fill="#FFC107"
    />
    <path
      d="M1.38428 6.4146L5.32688 9.306C6.39368 6.6648 8.97728 4.8 12.0007 4.8C13.8361 4.8 15.5059 5.4924 16.7773 6.6234L20.1715 3.2292C18.0283 1.2318 15.1615 0 12.0007 0C7.39148 0 3.39428 2.6022 1.38428 6.4146Z"
      fill="#FF3D00"
    />
    <path
      d="M11.9999 24.0006C15.0995 24.0006 17.9159 22.8144 20.0453 20.8854L16.3313 17.7426C15.1265 18.6552 13.6289 19.2006 11.9999 19.2006C8.87869 19.2006 6.22849 17.2104 5.23009 14.433L1.31689 17.448C3.30289 21.3342 7.33609 24.0006 11.9999 24.0006Z"
      fill="#4CAF50"
    />
    <path
      d="M23.7666 9.64965H22.8V9.59985H12V14.3999H18.7818C18.3066 15.7421 17.4432 16.8995 16.3296 17.7425C16.3302 17.7419 16.3308 17.7419 16.3314 17.7413L20.0454 20.8841C19.7826 21.1229 24 17.9999 24 11.9999C24 11.1953 23.9172 10.4099 23.7666 9.64965Z"
      fill="#1976D2"
    />
  </svg>
);

export const Facebook = ({ className, ...rest }: any) => (
  <svg
    aria-hidden="true"
    focusable="false"
    role="img"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 13 24"
    fill="none"
    className={`chakra-icon ${className || ""}`}
    {...rest}
  >
    <path
      d="M12 13.5H8.48438V24H3.79688V13.5H0V9.14062H3.79688V5.85938C3.79688 4.60938 4.03125 3.54688 4.5 2.67188C4.96875 1.79688 5.625 1.14062 6.46875 0.703125C7.34375 0.234375 8.34375 0 9.46875 0C9.96875 0 10.5 0.03125 11.0625 0.09375C11.625 0.125 12.0625 0.171875 12.375 0.234375L12.8438 0.28125V3.98438H10.9688C10.0938 3.98438 9.45312 4.21875 9.04688 4.6875C8.67188 5.125 8.48438 5.67188 8.48438 6.32812V9.14062H12.6562L12 13.5Z"
      fill="#3B5999"
    />
  </svg>
);

export const LinkedIn = ({ className, ...rest }: any) => (
  <svg
    aria-hidden="true"
    focusable="false"
    role="img"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 21 21"
    fill="none"
    className={`chakra-icon ${className || ""}`}
    {...rest}
  >
    <path
      d="M4.6875 21H0.328125V6.98438H4.6875V21ZM2.53125 5.0625C1.84375 5.0625 1.25 4.8125 0.75 4.3125C0.25 3.8125 0 3.21875 0 2.53125C0 1.84375 0.25 1.25 0.75 0.75C1.25 0.25 1.84375 0 2.53125 0C2.96875 0 3.375 0.109375 3.75 0.328125C4.15625 0.546875 4.46875 0.859375 4.6875 1.26562C4.9375 1.64062 5.0625 2.0625 5.0625 2.53125C5.0625 2.96875 4.9375 3.39062 4.6875 3.79688C4.46875 4.17188 4.15625 4.48438 3.75 4.73438C3.375 4.95312 2.96875 5.0625 2.53125 5.0625ZM21 21H16.6406V14.1562C16.6406 13.625 16.625 13.2031 16.5938 12.8906C16.5625 12.5469 16.4844 12.1719 16.3594 11.7656C16.2344 11.3281 16 11 15.6562 10.7812C15.3438 10.5625 14.9219 10.4531 14.3906 10.4531C13.3594 10.4531 12.6562 10.7812 12.2812 11.4375C11.9375 12.0938 11.7656 12.9688 11.7656 14.0625V21H7.40625V6.98438H11.625V8.90625H11.6719C11.9844 8.28125 12.5 7.75 13.2188 7.3125C13.9375 6.84375 14.7969 6.60938 15.7969 6.60938C16.8594 6.60938 17.7344 6.78125 18.4219 7.125C19.1406 7.4375 19.6719 7.92188 20.0156 8.57812C20.3906 9.20312 20.6406 9.89062 20.7656 10.6406C20.9219 11.3906 21 12.2812 21 13.3125V21Z"
      fill="#0077B5"
    />
  </svg>
);

export const Email = ({ className, ...rest }: any) => (
  <svg
    aria-hidden="true"
    focusable="false"
    role="img"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 20 20"
    fill="none"
    className={`chakra-icon ${className || ""}`}
    {...rest}
  >
    <path
      d="M3.33341 3.33398H16.6667C17.5834 3.33398 18.3334 4.08398 18.3334 5.00065V15.0006C18.3334 15.9173 17.5834 16.6673 16.6667 16.6673H3.33341C2.41675 16.6673 1.66675 15.9173 1.66675 15.0006V5.00065C1.66675 4.08398 2.41675 3.33398 3.33341 3.33398Z"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M18.3334 5L10.0001 10.8333L1.66675 5"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const Password = ({ className, ...rest }: any) => (
  <svg
    aria-hidden="true"
    focusable="false"
    role="img"
    viewBox="0 0 14 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={`chakra-icon ${className || ""}`}
    {...rest}
  >
    <path
      d="M11.375 6.37408H4.375V4.62408C4.37372 4.10449 4.52667 3.59621 4.81448 3.16362C5.10228 2.73102 5.51199 2.39357 5.99172 2.19399C6.47145 1.99442 6.99962 1.9417 7.50933 2.04252C8.01904 2.14333 8.48737 2.39315 8.855 2.76033C9.18395 3.09639 9.41925 3.51267 9.5375 3.96783C9.56623 4.07928 9.61663 4.18399 9.68582 4.27598C9.75501 4.36796 9.84165 4.44541 9.94077 4.50391C10.0399 4.56241 10.1496 4.60082 10.2635 4.61693C10.3775 4.63304 10.4935 4.62655 10.605 4.59783C10.7165 4.5691 10.8212 4.5187 10.9132 4.44951C11.0051 4.38031 11.0826 4.29368 11.1411 4.19455C11.1996 4.09543 11.238 3.98575 11.2541 3.87178C11.2702 3.75781 11.2637 3.64178 11.235 3.53033C11.0357 2.77328 10.6403 2.08214 10.0887 1.52658C9.47641 0.916146 8.69692 0.500844 7.84871 0.333113C7.00051 0.165382 6.12162 0.252742 5.32303 0.584162C4.52444 0.915582 3.84195 1.4762 3.36176 2.19523C2.88156 2.91425 2.62518 3.75944 2.625 4.62408V6.37408C1.92881 6.37408 1.26113 6.65064 0.768845 7.14292C0.276562 7.6352 0 8.30288 0 8.99907V15.1241C0 15.8203 0.276562 16.4879 0.768845 16.9802C1.26113 17.4725 1.92881 17.7491 2.625 17.7491H11.375C12.0712 17.7491 12.7389 17.4725 13.2312 16.9802C13.7234 16.4879 14 15.8203 14 15.1241V8.99907C14 8.30288 13.7234 7.6352 13.2312 7.14292C12.7389 6.65064 12.0712 6.37408 11.375 6.37408ZM12.25 15.1241C12.25 15.3561 12.1578 15.5787 11.9937 15.7428C11.8296 15.9069 11.6071 15.9991 11.375 15.9991H2.625C2.39294 15.9991 2.17038 15.9069 2.00628 15.7428C1.84219 15.5787 1.75 15.3561 1.75 15.1241V8.99907C1.75 8.76701 1.84219 8.54445 2.00628 8.38036C2.17038 8.21626 2.39294 8.12408 2.625 8.12408H11.375C11.6071 8.12408 11.8296 8.21626 11.9937 8.38036C12.1578 8.54445 12.25 8.76701 12.25 8.99907V15.1241Z"
      fill="currentColor"
    />
  </svg>
);

export const Eye = ({ className, ...rest }: any) => (
  <svg
    aria-hidden="true"
    focusable="false"
    role="img"
    viewBox="0 0 20 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={`chakra-icon ${className || ""}`}
    {...rest}
  >
    <path
      d="M12.9974 5.99812C12.9974 7.54508 11.653 8.79913 9.99457 8.79913C8.33617 8.79913 6.99177 7.54508 6.99177 5.99812C6.99177 4.45116 8.33617 3.19712 9.99457 3.19712C11.653 3.1971 12.9974 4.45117 12.9974 5.99812ZM10 0.166016C8.28292 0.173431 6.5031 0.580425 4.81827 1.35964C3.5673 1.96202 2.34817 2.8119 1.2899 3.86091C0.770133 4.39639 0.107183 5.17176 0 5.99903C0.0126667 6.71564 0.802167 7.60015 1.2899 8.13717C2.28228 9.14498 3.46967 9.97114 4.81827 10.6391C6.38945 11.3815 8.12853 11.8089 10 11.8327C11.7187 11.8252 13.4981 11.4135 15.1811 10.6391C16.4321 10.0367 17.6518 9.18618 18.7101 8.13717C19.2299 7.60169 19.8928 6.82631 20 5.99903C19.9873 5.28243 19.1978 4.39788 18.7101 3.86088C17.7177 2.85307 16.5297 2.02755 15.1811 1.3596C13.6107 0.617764 11.8674 0.193261 10 0.166016ZM9.99873 1.61426C12.6007 1.61426 14.71 3.57765 14.71 5.99967C14.71 8.42167 12.6007 10.3851 9.99873 10.3851C7.39675 10.3851 5.28748 8.42165 5.28748 5.99967C5.28748 3.57765 7.39675 1.61426 9.99873 1.61426Z"
      fill="currentColor"
    />
  </svg>
);

export const SercurityIcon = ({ className, ...rest }: any) => (
  <svg
    aria-hidden="true"
    focusable="false"
    role="img"
    viewBox="0 0 20 10"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={`chakra-icon ${className || ""}`}
    {...rest}
  >
    <path
      d="M18.3333 0.833984H1.66668C0.747461 0.833984 0 1.58148 0 2.50066V7.50066C0 8.41984 0.747461 9.16734 1.66668 9.16734H18.3334C19.2525 9.16734 20 8.41984 20 7.50066V2.50066C20 1.58148 19.2525 0.833984 18.3333 0.833984ZM19.1667 7.50066C19.1667 7.96004 18.7927 8.33398 18.3334 8.33398H1.66668C1.2073 8.33398 0.833359 7.96004 0.833359 7.50066V2.50066C0.833359 2.04129 1.2073 1.66734 1.66668 1.66734H18.3334C18.7927 1.66734 19.1667 2.04129 19.1667 2.50066V7.50066Z"
      fill="#262626"
    />
    <path
      d="M5.19323 4.16734C5.07769 3.96715 4.82175 3.9 4.62397 4.01477L4.16663 4.27883V3.75066C4.16663 3.52035 3.98026 3.33398 3.74995 3.33398C3.51964 3.33398 3.33327 3.52035 3.33327 3.75066V4.27883L2.87593 4.01477C2.67694 3.9 2.42183 3.96715 2.30667 4.16734C2.19151 4.36672 2.25987 4.62145 2.45925 4.7366L2.91655 5.00066L2.45925 5.26473C2.25987 5.37988 2.19151 5.63461 2.30667 5.83398C2.38397 5.96785 2.52397 6.0423 2.668 6.0423C2.73882 6.0423 2.81042 6.02441 2.87593 5.98656L3.33327 5.7225V6.25066C3.33327 6.48098 3.51964 6.66734 3.74995 6.66734C3.98026 6.66734 4.16663 6.48098 4.16663 6.25066V5.7225L4.62397 5.98656C4.68948 6.02441 4.76108 6.0423 4.8319 6.0423C4.97597 6.0423 5.11593 5.96785 5.19323 5.83398C5.30839 5.63461 5.24003 5.37988 5.04065 5.26473L4.58335 5.00066L5.04065 4.7366C5.24003 4.62145 5.30839 4.36672 5.19323 4.16734Z"
      fill="#262626"
    />
    <path
      d="M9.35998 4.16734C9.244 3.96715 8.98889 3.9 8.79072 4.01477L8.33338 4.27883V3.75066C8.33338 3.52035 8.14701 3.33398 7.9167 3.33398C7.68639 3.33398 7.50002 3.52035 7.50002 3.75066V4.27883L7.04268 4.01477C6.8433 3.9 6.58818 3.96715 6.47342 4.16734C6.35826 4.36672 6.42662 4.62145 6.626 4.7366L7.0833 5.00066L6.626 5.26473C6.42662 5.37988 6.35826 5.63461 6.47342 5.83398C6.55072 5.96785 6.69072 6.0423 6.83475 6.0423C6.90557 6.0423 6.97717 6.02441 7.04268 5.98656L7.50002 5.7225V6.25066C7.50002 6.48098 7.68639 6.66734 7.9167 6.66734C8.14701 6.66734 8.33338 6.48098 8.33338 6.25066V5.7225L8.79072 5.98656C8.85623 6.02441 8.92783 6.0423 8.99865 6.0423C9.14271 6.0423 9.28268 5.96785 9.35998 5.83398C9.47514 5.63461 9.40678 5.37988 9.2074 5.26473L8.75006 5.00066L9.20736 4.7366C9.40678 4.62145 9.47514 4.36672 9.35998 4.16734Z"
      fill="#262626"
    />
    <path
      d="M13.5266 4.16734C13.4111 3.96715 13.1551 3.9 12.9573 4.01477L12.5 4.27883V3.75066C12.5 3.52035 12.3136 3.33398 12.0833 3.33398C11.853 3.33398 11.6666 3.52035 11.6666 3.75066V4.27883L11.2093 4.01477C11.0103 3.9 10.7552 3.96715 10.64 4.16734C10.5249 4.36672 10.5932 4.62145 10.7926 4.7366L11.2499 5.00066L10.7926 5.26473C10.5932 5.37988 10.5249 5.63461 10.64 5.83398C10.7173 5.96785 10.8573 6.0423 11.0014 6.0423C11.0722 6.0423 11.1438 6.02441 11.2093 5.98656L11.6666 5.7225V6.25066C11.6666 6.48098 11.853 6.66734 12.0833 6.66734C12.3136 6.66734 12.5 6.48098 12.5 6.25066V5.7225L12.9573 5.98656C13.0229 6.02441 13.0945 6.0423 13.1653 6.0423C13.3093 6.0423 13.4493 5.96785 13.5266 5.83398C13.6418 5.63461 13.5734 5.37988 13.374 5.26473L12.9167 5.00066L13.374 4.7366C13.5734 4.62145 13.6418 4.36672 13.5266 4.16734Z"
      fill="#262626"
    />
    <path
      d="M17.6932 4.16734C17.5781 3.96715 17.3221 3.9 17.124 4.01477L16.6666 4.27883V3.75066C16.6666 3.52035 16.4803 3.33398 16.25 3.33398C16.0196 3.33398 15.8333 3.52035 15.8333 3.75066V4.27883L15.3759 4.01477C15.1761 3.9 14.9222 3.96715 14.8067 4.16734C14.6915 4.36672 14.7599 4.62145 14.9592 4.7366L15.4166 5.00066L14.9592 5.26473C14.7599 5.37988 14.6915 5.63461 14.8067 5.83398C14.884 5.96785 15.024 6.0423 15.168 6.0423C15.2388 6.0423 15.3104 6.02441 15.3759 5.98656L15.8333 5.7225V6.25066C15.8333 6.48098 16.0196 6.66734 16.25 6.66734C16.4803 6.66734 16.6666 6.48098 16.6666 6.25066V5.7225L17.124 5.98656C17.1895 6.02441 17.2611 6.0423 17.3319 6.0423C17.476 6.0423 17.6159 5.96785 17.6932 5.83398C17.8084 5.63461 17.74 5.37988 17.5407 5.26473L17.0833 5.00066L17.5407 4.7366C17.74 4.62145 17.8084 4.36672 17.6932 4.16734Z"
      fill="#262626"
    />
  </svg>
);

export const User = ({ className, ...rest }: any) => (
  <svg
    viewBox="0 0 133 132"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={`chakra-icon ${className || ""}`}
    {...rest}
  >
    <path
      d="M66.7083 0.00292969C30.2613 0.00292969 0.708252 29.5501 0.708252 66C0.708252 102.45 30.2584 131.997 66.7083 131.997C103.161 131.997 132.708 102.45 132.708 66C132.708 29.5501 103.161 0.00292969 66.7083 0.00292969ZM66.7083 19.7368C78.7683 19.7368 88.5411 29.5125 88.5411 41.5667C88.5411 53.6239 78.7683 63.3967 66.7083 63.3967C54.654 63.3967 44.8812 53.6239 44.8812 41.5667C44.8812 29.5125 54.654 19.7368 66.7083 19.7368ZM66.6938 114.742C54.6656 114.742 43.6491 110.361 35.152 103.111C33.0821 101.345 31.8876 98.7565 31.8876 96.0401C31.8876 83.8147 41.7821 74.0304 54.0104 74.0304H79.4119C91.6431 74.0304 101.5 83.8147 101.5 96.0401C101.5 98.7594 100.311 101.342 98.2384 103.108C89.7442 110.361 78.7249 114.742 66.6938 114.742Z"
      fill="currentColor"
    />
  </svg>
);

export const Pencil = ({ className, ...rest }: any) => (
  <svg
    viewBox="0 0 26 26"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={`chakra-icon ${className || ""}`}
    {...rest}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.9837 0.669677C12.4918 0.669677 12.9042 1.08208 12.9042 1.59022C12.9042 2.09836 12.4918 2.51076 11.9837 2.51076H7.39443C4.22285 2.51076 2.17434 4.68325 2.17434 8.04507V18.2496C2.17434 21.6114 4.22285 23.7839 7.39443 23.7839H18.2249C21.3965 23.7839 23.4463 21.6114 23.4463 18.2496V13.3057C23.4463 12.7975 23.8587 12.3851 24.3668 12.3851C24.8749 12.3851 25.2873 12.7975 25.2873 13.3057V18.2496C25.2873 22.6608 22.4484 25.625 18.2249 25.625H7.39443C3.17098 25.625 0.333252 22.6608 0.333252 18.2496V8.04507C0.333252 3.63383 3.17098 0.669677 7.39443 0.669677H11.9837ZM22.6737 1.74806L24.1675 3.2418C24.8953 3.96841 25.2954 4.93437 25.2942 5.96292C25.2942 6.99148 24.8941 7.95621 24.1675 8.6816L14.951 17.8981C14.2747 18.5744 13.3738 18.9475 12.4164 18.9475H7.81862C7.57069 18.9475 7.33257 18.8469 7.15951 18.6689C6.98645 18.4921 6.89194 18.2528 6.89808 18.0036L7.01345 13.3653C7.03677 12.4423 7.40867 11.5746 8.06164 10.9204H8.06287L17.2352 1.74806C18.735 0.250646 21.1739 0.250646 22.6737 1.74806ZM16.4796 5.10621L9.36391 12.2226C9.04601 12.5405 8.86559 12.9627 8.85454 13.4107L8.76248 17.1064H12.4164C12.8828 17.1064 13.3198 16.926 13.65 16.5958L20.8086 9.43521L16.4796 5.10621ZM18.5362 3.05033L17.7806 3.80394L22.1096 8.13418L22.8664 7.37933C23.2445 7.0013 23.4531 6.49807 23.4531 5.96292C23.4531 5.42656 23.2445 4.9221 22.8664 4.54406L21.3727 3.05033C20.5909 2.27093 19.3193 2.27093 18.5362 3.05033Z"
      fill="currentColor"
    />
  </svg>
);

export const CameraIcon = ({ className, ...rest }: any) => (
  <svg
    viewBox="0 0 20 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={`chakra-icon ${className || ""}`}
    {...rest}
  >
    <path
      d="M2 16C1.45 16 0.979333 15.8043 0.588 15.413C0.196 15.021 0 14.55 0 14V2C0 1.45 0.196 0.979333 0.588 0.588C0.979333 0.196 1.45 0 2 0H14C14.55 0 15.021 0.196 15.413 0.588C15.8043 0.979333 16 1.45 16 2V6.5L19.15 3.35C19.3167 3.18333 19.5 3.14167 19.7 3.225C19.9 3.30833 20 3.46667 20 3.7V12.3C20 12.5333 19.9 12.6917 19.7 12.775C19.5 12.8583 19.3167 12.8167 19.15 12.65L16 9.5V14C16 14.55 15.8043 15.021 15.413 15.413C15.021 15.8043 14.55 16 14 16H2ZM2 14H14V2H2V14ZM4.025 12H11.975C12.1917 12 12.346 11.9083 12.438 11.725C12.5293 11.5417 12.5083 11.3667 12.375 11.2L9.95 8.025C9.85 7.89167 9.71667 7.825 9.55 7.825C9.38333 7.825 9.25 7.89167 9.15 8.025L7.25 10.5L6.1 9C6 8.86667 5.86667 8.8 5.7 8.8C5.53333 8.8 5.4 8.86667 5.3 9L3.625 11.2C3.49167 11.3667 3.47067 11.5417 3.562 11.725C3.654 11.9083 3.80833 12 4.025 12Z"
      fill="currentColor"
    />
  </svg>
);

export const GoalsIcon = ({ className, ...rest }: any) => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={`chakra-icon ${className || ""}`}
    {...rest}
  >
    <path
      d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12 18C15.3137 18 18 15.3137 18 12C18 8.68629 15.3137 6 12 6C8.68629 6 6 8.68629 6 12C6 15.3137 8.68629 18 12 18Z"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12 14C13.1046 14 14 13.1046 14 12C14 10.8954 13.1046 10 12 10C10.8954 10 10 10.8954 10 12C10 13.1046 10.8954 14 12 14Z"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const MessageIcon = ({ className, ...rest }: any) => (
  <svg
    viewBox="0 0 24 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={`chakra-icon ${className || ""}`}
    {...rest}
  >
    <path
      d="M23.6039 0.896166C23.2317 0.523885 22.6961 0.404869 22.1708 0.577979L0.859176 7.60548C0.61117 7.6871 0.387074 7.82853 0.206676 8.01728C0.122821 8.1054 0.0616594 8.2126 0.0284647 8.32962C-0.00472998 8.44665 -0.00896117 8.56999 0.016136 8.68902C0.0412332 8.80805 0.0949055 8.91919 0.172525 9.01285C0.250144 9.10651 0.34938 9.17989 0.461676 9.22665L10.304 13.3239C10.5285 13.4173 11.0826 13.9714 11.1759 14.1958L15.2731 24.0381C15.3199 24.1504 15.3933 24.2497 15.4869 24.3273C15.5806 24.4049 15.6917 24.4586 15.8107 24.4837C15.9298 24.5088 16.0531 24.5046 16.1702 24.4714C16.2872 24.4382 16.3944 24.3771 16.4825 24.2932C16.6713 24.1128 16.8127 23.8888 16.8944 23.6408L23.922 2.32909C24.095 1.80399 23.9763 1.26826 23.6039 0.896166ZM2.87579 8.6071L2.75911 8.55854L20.8446 2.59473L11.2753 12.164C11.1519 12.0755 11.0196 12.0001 10.8805 11.939L2.87579 8.6071ZM15.9416 21.7408L12.5608 13.6194C12.4998 13.4804 12.4244 13.348 12.3358 13.2247L21.9052 3.65532L15.9416 21.7408Z"
      fill="currentColor"
    />
  </svg>
);

export const MyOrganizationIcon = ({ className, ...rest }: any) => (
  <svg
    width="26"
    height="19"
    viewBox="0 0 26 19"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={`chakra-icon ${className || ""}`}
    {...rest}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M19.2449 1.92256C19.7013 1.80546 20.1816 1.82062 20.6297 1.96627C21.0777 2.11192 21.4751 2.38205 21.7754 2.7451C22.0757 3.10816 22.2665 3.54916 22.3256 4.01661C22.3846 4.48405 22.3094 4.95864 22.1088 5.38496C21.9082 5.81128 21.5905 6.17172 21.1927 6.42419C20.8102 6.66691 20.369 6.80022 19.9169 6.81019C19.8985 6.81006 19.8801 6.81001 19.8617 6.81002C19.4072 6.8104 19.0387 7.17695 19.0348 7.63036C19.0348 7.63306 19.0347 7.63576 19.0347 7.63847C19.0348 8.09554 19.4053 8.46603 19.8624 8.46599C19.8832 8.46599 19.9039 8.46584 19.9246 8.46552C20.7385 8.47417 21.5401 8.66775 22.2686 9.03194C23.0155 9.40532 23.6651 9.94773 24.1657 10.6161C24.4396 10.9819 24.9583 11.0564 25.3242 10.7824C25.69 10.5084 25.7645 9.98969 25.4905 9.62385C24.8356 8.74949 23.9859 8.03989 23.0088 7.55143C22.8909 7.49253 22.7716 7.43704 22.651 7.385C23.0495 7.02148 23.3749 6.58194 23.6065 6.0897C23.9408 5.37921 24.0661 4.58826 23.9677 3.80922C23.8693 3.03018 23.5513 2.29521 23.0509 1.69014C22.5504 1.08508 21.8881 0.634885 21.1413 0.392147C20.3946 0.14941 19.5942 0.124144 18.8336 0.3193C18.073 0.514456 17.3836 0.92198 16.846 1.49428C16.3083 2.06657 15.9446 2.78002 15.7973 3.55131C15.7115 4.00026 16.006 4.43373 16.4549 4.51948C16.9039 4.60524 17.3373 4.31081 17.4231 3.86185C17.5115 3.39906 17.7297 2.97097 18.0523 2.62758C18.3749 2.28419 18.7886 2.03966 19.2449 1.92256ZM6.41061 1.92251C5.9543 1.80546 5.47411 1.82064 5.02611 1.96629C4.57811 2.11193 4.18079 2.38202 3.88054 2.74502C3.58029 3.10802 3.38951 3.54895 3.33048 4.01631C3.27145 4.48368 3.3466 4.9582 3.54715 5.38446C3.74771 5.81071 4.06539 6.17112 4.46311 6.42358C4.85261 6.67083 5.30313 6.80456 5.76406 6.81006L5.79422 6.81002C6.25129 6.8104 6.62151 7.18124 6.62113 7.63831C6.62085 7.96593 6.43025 8.24893 6.15399 8.38281C6.04487 8.43577 5.92237 8.46546 5.79293 8.46544L5.75953 8.46529C4.93588 8.46972 4.12412 8.66356 3.38712 9.032C2.64019 9.40541 1.99064 9.94787 1.49008 10.6163C1.2161 10.9821 0.697415 11.0566 0.331563 10.7826C-0.0342894 10.5087 -0.108767 9.98997 0.165213 9.62412C0.820064 8.74968 1.66983 8.04001 2.64698 7.5515C2.76499 7.49251 2.88446 7.43694 3.00525 7.38482C2.60659 7.02122 2.28113 6.58154 2.04945 6.08913C1.71519 5.3787 1.58994 4.58784 1.68833 3.80889C1.78672 3.02995 2.10469 2.29507 2.6051 1.69007C3.10551 1.08507 3.76771 0.634917 4.51438 0.392181C5.26105 0.149444 6.06137 0.124141 6.82188 0.319225C7.58239 0.514309 8.27171 0.92173 8.80934 1.49391C9.34697 2.06609 9.71072 2.77942 9.85812 3.55059C9.94393 3.99954 9.64955 4.43304 9.20061 4.51885C8.75166 4.60465 8.31816 4.31028 8.23235 3.86133C8.14391 3.39863 7.92566 2.97063 7.60309 2.62732C7.28051 2.28402 6.86692 2.03956 6.41061 1.92251ZM9.51732 10.1208C9.51732 8.29253 10.9994 6.81042 12.8277 6.81042C14.656 6.81042 16.1381 8.29253 16.1381 10.1208C16.1381 11.94 14.6706 13.4165 12.8549 13.4311L12.8284 13.431L12.8006 13.4311C10.9848 13.4165 9.51732 11.9401 9.51732 10.1208ZM9.81435 14.0679C8.62763 13.1605 7.86212 11.73 7.86212 10.1208C7.86212 7.37839 10.0853 5.15522 12.8277 5.15522C15.5701 5.15522 17.7933 7.37839 17.7933 10.1208C17.7933 11.7298 17.028 13.1601 15.8416 14.0675C16.1643 14.2102 16.4777 14.3761 16.7791 14.5646C17.9636 15.3054 18.9161 16.3643 19.5277 17.6204C19.7277 18.0314 19.5568 18.5267 19.1458 18.7268C18.7349 18.9269 18.2396 18.7559 18.0395 18.345C17.5637 17.3679 16.8229 16.5442 15.9015 15.968C14.9882 15.3969 13.9341 15.0917 12.8574 15.0863L12.8277 15.0864L12.7987 15.0863C11.7222 15.0918 10.6684 15.397 9.75536 15.968C8.83393 16.5442 8.09308 17.3679 7.61736 18.345C7.41728 18.756 6.92194 18.9269 6.51099 18.7268C6.10004 18.5268 5.92909 18.0314 6.12917 17.6205C6.74075 16.3643 7.69318 15.3054 8.87774 14.5646C9.17889 14.3763 9.49194 14.2105 9.81435 14.0679Z"
      fill="currentColor"
    />
  </svg>
);
export const OptionDotIcon = ({ className, ...rest }: any) => (
  <svg
    width="6"
    height="25"
    viewBox="0 0 6 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={`${className || ""}`}
    {...rest}
  >
    <path
      d="M2.99994 5.68054C4.47271 5.68054 5.66663 4.48663 5.66663 3.01386C5.66663 1.54108 4.47271 0.347168 2.99994 0.347168C1.52717 0.347168 0.333252 1.54108 0.333252 3.01386C0.333252 4.48663 1.52717 5.68054 2.99994 5.68054Z"
      fill="black"
    />
    <path
      d="M2.99994 15.014C4.47271 15.014 5.66663 13.8201 5.66663 12.3474C5.66663 10.8746 4.47271 9.68066 2.99994 9.68066C1.52717 9.68066 0.333252 10.8746 0.333252 12.3474C0.333252 13.8201 1.52717 15.014 2.99994 15.014Z"
      fill="black"
    />
    <path
      d="M2.99994 24.347C4.47271 24.347 5.66663 23.1531 5.66663 21.6804C5.66663 20.2076 4.47271 19.0137 2.99994 19.0137C1.52717 19.0137 0.333252 20.2076 0.333252 21.6804C0.333252 23.1531 1.52717 24.347 2.99994 24.347Z"
      fill="black"
    />
  </svg>
);

export const SearchIcon = ({ className, ...rest }: any) => (
  <svg
    width="16"
    height="17"
    viewBox="0 0 16 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={`chakra-icon ${className || ""}`}
    {...rest}
  >
    <path
      d="M15.2825 14.8738L12.5001 12.0497C13.5801 10.6716 14.1032 8.92256 13.9617 7.16205C13.8201 5.40154 13.0248 3.76342 11.7392 2.58452C10.4536 1.40562 8.77541 0.775558 7.04974 0.823876C5.32408 0.872195 3.68209 1.59523 2.46141 2.8443C1.24072 4.09337 0.534124 5.77354 0.486903 7.53934C0.439683 9.30513 1.05543 11.0223 2.20753 12.3378C3.35964 13.6534 4.96053 14.4672 6.68103 14.612C8.40152 14.7568 10.1109 14.2216 11.4576 13.1164L14.2176 15.9406C14.2873 16.0125 14.3702 16.0696 14.4616 16.1086C14.553 16.1475 14.651 16.1676 14.7501 16.1676C14.8491 16.1676 14.9471 16.1475 15.0385 16.1086C15.1299 16.0696 15.2128 16.0125 15.2825 15.9406C15.4177 15.7975 15.4933 15.6062 15.4933 15.4072C15.4933 15.2082 15.4177 15.0169 15.2825 14.8738ZM7.25005 13.1164C6.2117 13.1164 5.19666 12.8013 4.33331 12.211C3.46995 11.6207 2.79704 10.7817 2.39968 9.80012C2.00232 8.8185 1.89836 7.73835 2.10093 6.69626C2.3035 5.65418 2.80351 4.69696 3.53774 3.94566C4.27197 3.19436 5.20743 2.68272 6.22583 2.47544C7.24423 2.26815 8.29983 2.37454 9.25914 2.78114C10.2185 3.18774 11.0384 3.87629 11.6153 4.75973C12.1921 5.64317 12.5001 6.68181 12.5001 7.74431C12.5001 9.16907 11.9469 10.5355 10.9624 11.5429C9.97779 12.5504 8.64244 13.1164 7.25005 13.1164Z"
      fill="#262626"
    />
  </svg>
);

export const Share = ({ className, ...rest }: any) => (
  <svg
    width="28"
    height="25"
    viewBox="0 0 28 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={`${className || ""}`}
    {...rest}
  >
    <path
      d="M0.92305 24.694C0.852667 24.694 0.781592 24.6859 0.71121 24.6698C0.294684 24.5705 0 24.199 0 23.7709C0 15.3832 1.06105 8.40725 13.8457 8.08995V1.61775C13.8457 1.25084 14.0629 0.919237 14.3984 0.772241C14.7328 0.626168 15.1249 0.689397 15.3953 0.940005L27.395 12.0166C27.5842 12.1904 27.6915 12.4366 27.6915 12.6944C27.6915 12.9521 27.5842 13.1983 27.395 13.3723L15.3953 24.4489C15.1258 24.6995 14.7337 24.7644 14.3984 24.6167C14.0629 24.4695 13.8457 24.1379 13.8457 23.7709V17.3204C5.07585 17.5304 3.45774 20.7657 1.74872 24.1838C1.59018 24.502 1.26642 24.694 0.92305 24.694ZM14.7688 15.4635C15.279 15.4635 15.6918 15.8763 15.6918 16.3865V21.6625L25.4074 12.6944L15.6918 3.72623V9.00215C15.6918 9.51237 15.279 9.9252 14.7688 9.9252C4.57187 9.9252 2.37616 13.8689 1.9444 20.1681C3.85627 17.5999 7.11487 15.4635 14.7688 15.4635Z"
      fill="#262626"
    />
  </svg>
);

export const Comment = ({ className, color = "black", ...rest }: any) => (
  <svg
    width="25"
    height="25"
    viewBox="0 0 25 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={`${className || ""}`}
    {...rest}
  >
    <path
      d="M0.948651 10.041C1.50031 7.43796 2.96784 5.06528 5.08344 3.36209C7.22047 1.64283 9.92522 0.694824 12.6996 0.694824C15.9614 0.694824 19.0089 1.95347 21.2852 4.23511C23.4865 6.44176 24.6969 9.36075 24.6862 12.4404C24.6862 14.7113 24.0274 16.9073 22.7795 18.8033L22.7527 18.8461C22.7206 18.8836 22.6938 18.9265 22.667 18.9693C22.6081 19.0711 22.5813 19.1461 22.5653 19.1889L23.5936 22.9006C23.6257 23.0131 23.6472 23.1309 23.6579 23.2487V23.3183C23.6579 23.6825 23.5186 24.0307 23.2615 24.2878C23.0044 24.5502 22.6617 24.6895 22.2921 24.6948H22.2439L22.1957 24.6895C22.035 24.6734 21.8743 24.6306 21.7244 24.5716L18.1091 23.2701L18.0663 23.2541C17.9699 23.2112 17.8627 23.1898 17.7556 23.1898C17.6539 23.1898 17.5574 23.2059 17.4664 23.2434C17.4343 23.2594 16.6094 23.5754 15.7632 23.8111C15.0723 24.0039 13.6369 24.2931 12.5068 24.2931C9.30929 24.2931 6.32602 23.0559 4.10866 20.8064C1.90737 18.5783 0.691566 15.6165 0.691566 12.4565C0.691566 11.6424 0.777261 10.8336 0.948651 10.041V10.041ZM12.5068 22.5685C13.353 22.5685 14.5795 22.3543 15.3026 22.1507C16.0738 21.9365 16.8237 21.6473 16.8558 21.6366C17.145 21.5241 17.4503 21.4705 17.7556 21.4705C18.0877 21.4705 18.409 21.5348 18.7143 21.658L21.7726 22.7613L20.8888 19.5638V19.5585C20.7764 19.1407 20.8728 18.6533 21.1834 18.1124L21.1941 18.0963C21.2477 18.0106 21.3013 17.9249 21.3602 17.8446C22.4153 16.2324 22.9723 14.3686 22.9723 12.4404C22.983 9.81065 21.9493 7.33084 20.0747 5.44555C18.1198 3.48527 15.5008 2.40873 12.6996 2.40873C7.84176 2.40873 3.6052 5.76691 2.62506 10.3998C2.48045 11.0746 2.40547 11.7602 2.40547 12.4511C2.40547 18.032 6.9366 22.5685 12.5068 22.5685Z"
      fill={color}
    />
  </svg>
);

export const Heart = ({ className, color = "black", ...rest }: any) => (
  <svg
    viewBox="221 153 30 23"
    width="27"
    height="25"
    className={`${className || ""}`}
    {...rest}
  >
    <path
      d="M 248.282 156.08 L 248.281 156.079 C 247.373 154.887 246.092 154.034 244.641 153.658 C 243.191 153.282 241.657 153.404 240.284 154.006 L 240.279 154.008 C 239.046 154.54 237.92 155.448 236.99 156.689 L 236.189 157.759 L 235.389 156.689 C 234.459 155.445 233.334 154.537 232.102 154.008 L 232.096 154.006 C 230.723 153.404 229.189 153.282 227.738 153.658 C 226.288 154.034 225.006 154.887 224.099 156.079 L 224.098 156.08 C 223.142 157.332 222.622 158.916 222.622 160.682 C 222.622 163.115 224.084 165.977 227.34 169.202"
      fill="white"
      stroke={`${color}`}
      strokeWidth="2"
    ></path>
    <path
      d="M 234.76 175.026 C 233.114 173.969 229.978 171.814 227.341 169.202 L 234.76 175.026 Z"
      fill="white"
      stroke={`${color}`}
      strokeWidth="2"
    ></path>
    <path
      d="M 248.282 156.08 C 249.237 157.332 249.758 158.916 249.758 160.682 C 249.758 163.115 248.295 165.978 245.039 169.202 C 242.401 171.814 239.264 173.969 237.619 175.026 C 237.192 175.299 236.696 175.444 236.19 175.444 C 235.683 175.444 235.187 175.299 234.76 175.026"
      fill="white"
      stroke={`${color}`}
      strokeWidth="2"
    ></path>
  </svg>
);

export const SnapReact = ({ className, ...rest }: any) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={`${className || ""}`}
    {...rest}
  >
    <path
      d="M9.35667 6.66312V5.35746C9.35667 5.2452 9.39055 5.13554 9.45392 5.04283L11.3072 2.33059C11.7715 1.65119 11.597 0.72415 10.9176 0.259907C10.2383 -0.204336 9.31121 -0.0299131 8.84696 0.649487L6.77657 3.67945C6.51624 4.06044 6.37695 4.51116 6.37695 4.97261V9.15693V12.6863L9.61415 10.4874L9.35667 6.66312Z"
      fill="#CCA180"
    />
    <path
      d="M13.1622 10.997L14.014 6.65095L10.6795 9.4449L10.6819 9.46035C11.0333 9.40581 11.403 9.5004 11.6906 9.7451L13.1622 10.997ZM15.1125 4.35121L15.1492 4.33577C15.3171 4.21125 15.5015 4.107 15.6979 4.0264C15.8943 3.9458 16.1028 3.88933 16.32 3.85941C17.0792 3.75516 17.7394 4.38113 17.6762 5.14466L17.3278 9.35658C17.3128 9.54143 17.3471 9.72628 17.4277 9.89327L18.0725 11.2263C18.9291 12.998 18.9581 15.0579 18.1521 16.8533L16.1752 21.2554V23.4698C16.1752 23.763 15.9372 24.0004 15.644 23.9997L7.75525 23.9788C7.46316 23.978 7.22677 23.741 7.22677 23.4489V21.6342L5.65484 19.6583C4.98688 18.819 4.58533 17.7997 4.50135 16.7307L4.17075 12.5304C4.0998 11.6312 4.46901 10.7528 5.16111 10.1737L12.7848 3.79329C13.0637 3.55921 13.4035 3.44531 13.7413 3.44531C14.1665 3.44531 14.5893 3.6263 14.8837 3.97814C14.9802 4.09349 15.0565 4.21945 15.1125 4.35121V4.35121Z"
      fill="#CCA180"
    />
    <path
      d="M15.9815 3.92953C15.8848 3.95641 15.7898 3.98894 15.6979 4.02664C15.5015 4.10724 15.3171 4.21148 15.1492 4.336L15.1125 4.35145C15.0565 4.21969 14.9803 4.09372 14.8837 3.97837C14.8095 3.88967 14.7271 3.81191 14.6386 3.74512L13.9717 6.68666L14.0141 6.65119L13.7188 8.15796L15.3192 6.81697C16.1789 6.09611 16.4193 4.90609 15.9815 3.92953V3.92953Z"
      fill="#947E6F"
    />
    <path
      d="M7.72465 9.27908L9.45464 8.11782L9.35672 6.66317V5.71929L8.24338 6.65106C8.00608 6.84966 7.64483 6.68093 7.64483 6.37147V5.28077C7.64483 4.81928 7.78411 4.3686 8.04444 3.98756L10.1148 0.957599C10.3382 0.630664 10.6689 0.421058 11.0275 0.34292C10.9924 0.313913 10.956 0.286114 10.9176 0.259907C10.2383 -0.204336 9.31121 -0.029913 8.84696 0.649487L6.77657 3.67945C6.51624 4.06048 6.37695 4.51116 6.37695 4.97266V9.15697V9.27903H7.72465V9.27908Z"
      fill="#947E6F"
    />
    <path
      d="M14.8831 3.97814C15.4116 4.60894 15.3286 5.54862 14.6983 6.0771L10.6789 9.4449L10.6813 9.46035C10.453 9.4951 10.2325 9.59355 10.0476 9.75475L8.10794 11.443L4.31445 11.402C4.47758 10.93 4.76668 10.5033 5.16051 10.1737L12.7842 3.79329C13.0631 3.55921 13.4029 3.44531 13.7407 3.44531C14.1659 3.44531 14.5887 3.6263 14.8831 3.97814V3.97814Z"
      fill="#CCA180"
    />
    <path
      d="M9.81266 23.9788C9.52057 23.978 9.28418 23.741 9.28418 23.4489V22.4529C9.28418 21.9228 9.1045 21.4083 8.77447 20.9935L7.71225 19.6583C7.04429 18.819 6.64274 17.7997 6.55876 16.7307L6.22816 12.5303C6.15721 11.6312 6.52642 10.7528 7.21852 10.1736L14.7684 3.85502C14.4843 3.58417 14.1138 3.44531 13.7413 3.44531C13.4035 3.44531 13.0637 3.55921 12.7848 3.79329L5.16111 10.1737C4.46901 10.7528 4.0998 11.6312 4.17075 12.5304L4.50135 16.7307C4.58533 17.7997 4.98688 18.8191 5.65484 19.6583L7.22677 21.6342V23.4489C7.22677 23.741 7.46316 23.978 7.75525 23.9788H9.81266V23.9788Z"
      fill="#947E6F"
    />
    <path
      d="M15.3467 14.8093C15.687 14.4092 15.8744 13.9 15.8744 13.3755C15.8744 12.7246 15.5901 12.1097 15.0948 11.689L13.3231 10.1819L13.1634 10.9967L11.6919 9.74476C11.4896 9.57265 11.2466 9.47511 10.998 9.45117V15.6454C10.998 16.6683 11.447 17.6397 12.2262 18.3025C12.6261 18.6426 13.1351 18.8299 13.6596 18.8299C14.3106 18.8299 14.9256 18.5456 15.3467 18.0502C15.687 17.65 15.8744 17.141 15.8744 16.6169C15.8744 15.9989 15.6176 15.4135 15.1673 14.995C15.2301 14.9365 15.2906 14.8753 15.3467 14.8093V14.8093Z"
      fill="#947E6F"
    />
    <path
      d="M15.15 13.3759C15.15 13.7171 15.0332 14.0602 14.7948 14.3406C14.5559 14.6215 14.2354 14.7919 13.8976 14.8464L13.8899 14.8556L11.6915 12.9859C11.217 12.5824 10.5187 12.5863 10.0491 12.9955L8.10938 14.6838V11.4429L10.0491 9.75467C10.2339 9.59347 10.4545 9.49501 10.6828 9.46026C11.0341 9.40573 11.4038 9.50032 11.6915 9.74502L13.163 10.997L14.6254 12.2407C14.9719 12.5351 15.15 12.954 15.15 13.3759V13.3759Z"
      fill="#CCA180"
    />
    <path
      d="M14.7833 14.3529C14.6988 14.2006 14.5864 14.0603 14.4458 13.9409L12.9834 12.6972L11.5119 11.4452C11.2242 11.2005 10.8545 11.1059 10.5032 11.1605C10.2749 11.1952 10.0543 11.2937 9.86948 11.4549L8.45894 12.6825C8.23684 12.8758 8.10938 13.1559 8.10938 13.4503V14.6838L10.0491 12.9955C10.5187 12.5862 11.217 12.5824 11.6915 12.9859L13.8899 14.8556L13.8976 14.8464C14.2302 14.7927 14.5457 14.6262 14.7833 14.3529Z"
      fill="#947E6F"
    />
    <path
      d="M15.15 16.6178C15.15 16.959 15.0332 17.3017 14.7948 17.5821C14.262 18.2091 13.3213 18.2848 12.6949 17.752L10.8787 16.2071L10.3396 16.7462L8.10938 14.6844L10.0491 12.9962C10.5187 12.5869 11.217 12.583 11.6915 12.9865L14.6254 15.4822C14.9719 15.7771 15.15 16.196 15.15 16.6178Z"
      fill="#CCA180"
    />
    <path
      d="M16.8695 2.27539C16.8099 2.27539 16.7495 2.26067 16.6937 2.22963C16.5191 2.13234 16.4564 1.91192 16.5536 1.73725L17.2974 0.401716C17.3947 0.2271 17.6151 0.164358 17.7898 0.261608C17.9644 0.358906 18.0271 0.579324 17.9299 0.753988L17.1861 2.08953C17.1199 2.20835 16.9966 2.27539 16.8695 2.27539Z"
      fill="#FBE88C"
    />
    <path
      d="M18.1768 3.4674C18.0556 3.4674 17.9373 3.40654 17.8688 3.29597C17.7635 3.12603 17.8159 2.90286 17.9859 2.79765L19.2855 1.99276C19.4556 1.8875 19.6786 1.93996 19.7839 2.1099C19.8892 2.27983 19.8367 2.503 19.6667 2.60822L18.3671 3.4131C18.3077 3.44988 18.2419 3.4674 18.1768 3.4674Z"
      fill="#FBE88C"
    />
  </svg>
);

export const FistReact = ({ className, ...rest }: any) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={`${className || ""}`}
    {...rest}
  >
    <path
      d="M7.15942 9.96051H6.9917C5.9328 9.96051 5.07422 9.10193 5.07422 8.04285V2.97028C5.07422 1.86487 5.97034 0.96875 7.07556 0.96875C8.18097 0.96875 9.07709 1.86487 9.07709 2.97028V8.04285C9.07709 9.10193 8.21851 9.96051 7.15942 9.96051Z"
      fill="#CCA180"
    />
    <path
      d="M7.37622 24.0004V21.7694C7.37622 19.7759 6.72089 17.8378 5.51111 16.2534L4.3396 14.7188C3.44019 13.5408 2.95312 12.1 2.95312 10.6179C2.95312 9.7218 3.03772 8.82751 3.20563 7.94733C3.25378 7.69501 3.30194 7.44269 3.34991 7.19019C3.52899 6.25177 4.40057 5.60706 5.34979 5.71637V2.90332L20.0914 3.9809L21.0862 6.14832V11.3353C21.0862 14.4058 19.8755 17.3524 17.7169 19.5361C17.3937 19.8629 17.2125 20.304 17.2125 20.7636V24.0004"
      fill="#CCA180"
    />
    <path
      d="M6.05383 8.04266V2.97009C6.05383 2.03369 6.6969 1.2478 7.56537 1.02936C7.40863 0.989807 7.24457 0.96875 7.07556 0.96875C5.97034 0.96875 5.07422 1.86469 5.07422 2.97009V8.04266C5.07422 9.10175 5.93262 9.96033 6.9917 9.96033H7.15942C7.29877 9.96033 7.43463 9.94513 7.56537 9.91693C6.70148 9.73053 6.05383 8.9624 6.05383 8.04266Z"
      fill="#947E6F"
    />
    <path
      d="M13.0792 3.66638V8.73914C13.0792 9.75061 12.2961 10.5788 11.3033 10.6517C10.7518 10.2042 10.09 9.88776 9.36475 9.75006C9.18146 9.45673 9.07617 9.11029 9.07617 8.73914V3.66638C9.07617 2.56134 9.97247 1.66504 11.0781 1.66504C11.6305 1.66504 12.1311 1.88879 12.4929 2.25134C12.8549 2.61371 13.0792 3.11377 13.0792 3.66638Z"
      fill="#947E6F"
    />
    <path
      d="M15.1653 10.6566H14.9976C13.9387 10.6566 13.0801 9.79822 13.0801 8.73914V3.66656C13.0801 2.56116 13.9762 1.66504 15.0814 1.66504C16.1868 1.66504 17.0829 2.56116 17.0829 3.66656V8.73914C17.0829 9.79822 16.2244 10.6566 15.1653 10.6566Z"
      fill="#947E6F"
    />
    <path
      d="M19.1672 10.0811H18.9997C17.9406 10.0811 17.082 9.22253 17.082 8.16345V4.82947C17.082 3.72424 17.9781 2.82812 19.0836 2.82812C20.1888 2.82812 21.0849 3.72424 21.0849 4.82947V8.16345C21.0849 9.22253 20.2263 10.0811 19.1672 10.0811Z"
      fill="#947E6F"
    />
    <path
      d="M13.0808 2.00134V7.0741C13.0808 8.133 12.2226 8.99158 11.1631 8.99158H10.9958C9.93671 8.99158 9.07812 8.133 9.07812 7.0741V2.00134C9.07812 0.896301 9.97406 0 11.0795 0C11.6324 0 12.1325 0.223755 12.4945 0.586304C12.8569 0.948669 13.0808 1.44873 13.0808 2.00134Z"
      fill="#CCA180"
    />
    <path
      d="M10.0577 7.07391V2.00134C10.0577 1.06494 10.7008 0.279053 11.5693 0.0604248C11.4125 0.0210571 11.2487 0 11.0795 0C9.97424 0 9.07812 0.895935 9.07812 2.00134V7.07391C9.07812 8.133 9.93671 8.99158 10.9958 8.99158H11.1633C11.3027 8.99158 11.4385 8.97638 11.5693 8.948C10.7054 8.76178 10.0577 7.99365 10.0577 7.07391Z"
      fill="#947E6F"
    />
    <path
      d="M15.1653 8.99158H14.9976C13.9387 8.99158 13.0801 8.13318 13.0801 7.0741V2.00153C13.0801 0.896118 13.9762 0 15.0814 0C16.1868 0 17.0829 0.896118 17.0829 2.00153V7.0741C17.0829 8.13318 16.2244 8.99158 15.1653 8.99158Z"
      fill="#CCA180"
    />
    <path
      d="M14.0597 7.07391V2.00134C14.0597 1.06494 14.7028 0.279053 15.5714 0.0604248C15.4145 0.0210571 15.2506 0 15.0816 0C13.9762 0 13.0801 0.895935 13.0801 2.00134V7.07391C13.0801 8.133 13.9387 8.99158 14.9977 8.99158H15.1655C15.3048 8.99158 15.4405 8.97638 15.5714 8.948C14.7073 8.76178 14.0597 7.99365 14.0597 7.07391Z"
      fill="#947E6F"
    />
    <path
      d="M19.1692 8.4151H19.0016C17.9426 8.4151 17.084 7.55652 17.084 6.49744V3.16364C17.084 2.05823 17.9801 1.16211 19.0855 1.16211C20.1907 1.16211 21.0869 2.05823 21.0869 3.16364V6.49744C21.0869 7.55652 20.2283 8.4151 19.1692 8.4151Z"
      fill="#CCA180"
    />
    <path
      d="M18.0636 6.49744V3.16364C18.0636 2.22723 18.7067 1.44135 19.5751 1.22272C19.4184 1.18335 19.2545 1.16211 19.0855 1.16211C17.9801 1.16211 17.084 2.05823 17.084 3.16364V6.49744C17.084 7.55652 17.9426 8.4151 19.0016 8.4151H19.1692C19.3087 8.4151 19.4444 8.3999 19.5751 8.3717C18.7112 8.1853 18.0636 7.41718 18.0636 6.49744Z"
      fill="#947E6F"
    />
    <path
      d="M13.0808 6.29592V7.07411C13.0808 8.13301 12.2226 8.99159 11.1631 8.99159H10.9958C9.93671 8.99159 9.07812 8.13301 9.07812 7.07411V5.86525C9.88873 5.86049 10.6984 5.81288 11.505 5.72188C12.1115 5.65376 12.687 5.88191 13.0808 6.29592Z"
      fill="#947E6F"
    />
    <path
      d="M7.37622 24.0002V21.7692C7.37622 19.7757 6.72089 17.8376 5.51111 16.2532L4.3396 14.7185C3.44019 13.5406 2.95312 12.0998 2.95312 10.6177C2.95312 9.7216 3.03772 8.82731 3.20563 7.94713C3.25378 7.69481 3.30194 7.44249 3.34991 7.18998C3.52899 6.25157 4.40057 5.60685 5.34979 5.71617C7.06897 5.91392 8.80518 5.91594 10.5247 5.72203C11.5034 5.61162 12.4017 6.27391 12.5863 7.24144L12.5934 7.27879C12.7994 8.35838 12.0417 9.38267 10.9495 9.50572C9.92395 9.62126 8.89343 9.67711 7.86292 9.67326"
      fill="#CCA180"
    />
    <path
      d="M7.61737 16.2532C8.82715 17.8376 9.48267 19.7757 9.48267 21.7692V24.0002H7.3764V21.7692C7.3764 19.7757 6.72107 17.8376 5.51129 16.2532L4.33978 14.7185C3.44055 13.5406 2.95312 12.0996 2.95312 10.6181C2.95312 10.1698 2.97418 9.72215 3.0163 9.27647C3.05841 8.83079 3.12213 8.38695 3.20581 7.94713C3.25378 7.69499 3.30194 7.44267 3.35028 7.18998C3.52917 6.25157 4.40094 5.60685 5.34961 5.71617C5.76453 5.76359 6.18091 5.8004 6.59729 5.82493C6.02417 6.04484 5.57849 6.54875 5.45654 7.18998C5.40802 7.44267 5.36005 7.69499 5.31189 7.94713C5.14398 8.82731 5.0592 9.72178 5.0592 10.6181C5.0592 11.3591 5.18115 12.0893 5.41534 12.7824C5.64954 13.4751 5.99615 14.1293 6.44586 14.7185L7.61737 16.2532Z"
      fill="#947E6F"
    />
    <path
      d="M12.9323 14.431C12.7294 14.431 12.565 14.2664 12.565 14.0635C12.565 12.8445 12.0215 11.7051 11.074 10.9375C10.5593 10.5197 9.94531 10.2342 9.29822 10.1113C9.05139 10.0643 8.79688 10.0403 8.54181 10.0403H7.8634C7.66052 10.0403 7.49609 9.87585 7.49609 9.67297C7.49609 9.47009 7.66052 9.30566 7.8634 9.30566H8.54181C8.84302 9.30566 9.14368 9.33386 9.43555 9.38953C10.2013 9.53491 10.928 9.87292 11.5367 10.3669C12.6571 11.2744 13.2996 12.6219 13.2996 14.0635C13.2996 14.2664 13.1352 14.431 12.9323 14.431Z"
      fill="#947E6F"
    />
  </svg>
);

export const ClappingReact = ({ className, ...rest }: any) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={` ${className || ""}`}
    {...rest}
  >
    <path
      d="M20.9864 9.25617L19.333 10.2788L11.8683 14.8969C11.397 15.1881 10.8625 15.3624 10.3095 15.4039L9.9748 15.4285C8.96278 15.5048 7.98353 15.8225 7.12001 16.357L6.35023 16.8333L5.59309 17.3016C5.36512 17.4426 5.0663 17.3721 4.92476 17.1438L0.775769 10.4372C0.634778 10.2089 0.705273 9.90985 0.933056 9.76886L1.49611 9.42023C2.21809 8.97363 2.8368 8.39319 3.32295 7.71716C3.80928 7.04205 4.16414 6.27191 4.35878 5.44556C4.57118 4.54303 5.13331 3.76263 5.92195 3.27448L10.8248 0.241882C11.0894 0.0781861 11.3825 0 11.6722 0C12.2125 0 12.7404 0.271362 13.0457 0.764832C13.3082 1.18982 13.3504 1.68823 13.203 2.12714C13.087 2.47192 12.8552 2.77954 12.5222 2.98572L13.6265 2.30237L16.9473 0.248108C17.1478 0.124146 17.3703 0.0651856 17.59 0.0651856C18 0.0651856 18.3999 0.270813 18.6311 0.644714C18.7243 0.795227 18.7809 0.958557 18.8031 1.12372C18.8635 1.57031 18.6732 2.03101 18.2805 2.29852C18.2656 2.30859 18.2501 2.31885 18.2347 2.32855L19.2222 1.71753C19.4225 1.59338 19.6442 1.53461 19.8643 1.53461C20.2739 1.53461 20.6737 1.74042 20.9055 2.1145C20.9983 2.26465 21.0547 2.42688 21.0774 2.59113C21.1122 2.84564 21.0653 3.10492 20.9461 3.33051V3.33087C20.8582 3.49658 20.7323 3.64343 20.5704 3.75678C20.5642 3.76172 20.5583 3.76556 20.5521 3.76996L20.5491 3.77179C20.5361 3.78095 20.5226 3.78919 20.509 3.79779L19.5216 4.40881C20.089 4.05762 20.832 4.22717 21.1924 4.78546C21.2933 4.94129 21.3522 5.11322 21.3729 5.28717C21.4275 5.74109 21.2228 6.21185 20.8225 6.47937L20.8205 6.48084C20.809 6.48853 20.7974 6.4964 20.7854 6.50354L19.7224 7.16071C20.2899 6.81024 21.0331 6.97925 21.3933 7.53735C21.7653 8.11414 21.5692 8.89545 20.9864 9.25617Z"
      fill="#CCA180"
    />
    <path
      d="M19.3327 10.2791L11.8682 14.897C11.3969 15.1884 10.8624 15.3625 10.3094 15.4039L9.97455 15.4286C8.96234 15.5048 7.98327 15.8228 7.11975 16.3571L6.34979 16.8334L4.78186 11.9985C4.39203 10.7957 5.05322 9.5 6.25567 9.1098C6.48565 9.03546 6.72351 8.99756 6.96338 8.99756C7.04486 8.99756 7.12561 9.00195 7.20508 9.01019L6.24634 6.05304C6.0896 5.56946 6.13043 5.05402 6.36133 4.60156C6.5924 4.14856 6.98572 3.81311 7.46911 3.65637C7.65991 3.5943 7.85748 3.56317 8.05652 3.56317C8.07849 3.56317 8.10028 3.56317 8.1217 3.56409C8.12793 3.28174 8.19787 3.00159 8.33044 2.74231C8.56097 2.28949 8.95465 1.95404 9.43805 1.7973C9.62848 1.73505 9.82586 1.7041 10.0254 1.7041C10.6346 1.7041 11.1895 1.99084 11.5416 2.45648C11.7021 2.33032 11.8862 2.22833 12.0885 2.15839C12.2846 2.091 12.4895 2.0564 12.6964 2.0564C12.8696 2.0564 13.0395 2.08075 13.2027 2.12744C13.0872 2.47205 12.855 2.77985 12.5221 2.98602L13.6264 2.30249C13.886 2.44824 14.1129 2.65314 14.2838 2.9007C14.439 2.78168 14.6157 2.68555 14.8094 2.61853C15.0059 2.55115 15.2104 2.51654 15.4177 2.51654C16.2404 2.51654 16.9939 3.06751 17.2497 3.85632L19.3327 10.2791Z"
      fill="#947E6F"
    />
    <path
      d="M18.2806 2.29883L12.4569 5.90179C12.3976 5.93842 12.3319 5.95636 12.2667 5.95636C12.1455 5.95636 12.0272 5.89502 11.9585 5.78442C11.8532 5.6145 11.906 5.3913 12.0759 5.28601L18.803 1.12402C18.8634 1.57062 18.6732 2.03131 18.2806 2.29883Z"
      fill="#947E6F"
    />
    <path
      d="M20.9465 3.3302V3.33075C20.8586 3.49628 20.7325 3.64313 20.5708 3.75665L13.7446 7.98145C13.6851 8.01862 13.619 8.03601 13.5544 8.03601C13.4331 8.03601 13.3143 7.97522 13.2456 7.86408C13.1403 7.69415 13.1931 7.47095 13.363 7.36585L21.0778 2.59082C21.1126 2.84534 21.0657 3.10461 20.9465 3.3302Z"
      fill="#947E6F"
    />
    <path
      d="M20.8228 6.47931L20.8208 6.48077L15.0314 10.0618C14.9721 10.0989 14.9063 10.1163 14.8411 10.1163C14.7199 10.1163 14.6011 10.0555 14.5326 9.94458C14.4277 9.77448 14.4799 9.55145 14.6503 9.44617L21.3732 5.28711C21.4278 5.74084 21.2231 6.21179 20.8228 6.47931Z"
      fill="#947E6F"
    />
    <path
      d="M20.4406 21.5432L12.9388 23.9765C12.6839 24.0591 12.4102 23.9196 12.327 23.6647L12.1227 23.0344C11.861 22.2269 11.4443 21.4881 10.9039 20.8545C10.3636 20.2216 9.69946 19.6938 8.94379 19.3079C8.11798 18.8869 7.49377 18.1548 7.2074 17.273L5.42889 11.7888C5.37524 11.6237 5.34961 11.4561 5.34961 11.2909C5.34961 10.6105 5.78375 9.9779 6.46619 9.75634C6.77289 9.65673 7.0882 9.65435 7.37842 9.73162C7.83032 9.85229 8.22144 10.1667 8.42725 10.6114C8.45471 10.6699 8.47833 10.7308 8.49866 10.7936L6.89355 5.84393C6.85291 5.71832 6.83368 5.59124 6.83368 5.46582C6.83368 4.95001 7.16254 4.47045 7.67963 4.30291C7.84735 4.24835 8.01819 4.23242 8.18243 4.24981C8.60742 4.29339 8.99066 4.55944 9.1723 4.96447C9.19061 5.00457 9.20654 5.04614 9.22064 5.08917L8.86212 3.98468C8.82166 3.85906 8.80243 3.73217 8.80243 3.60656C8.80243 3.09094 9.1311 2.61138 9.64838 2.44384C9.82233 2.38726 9.99939 2.37188 10.1695 2.39257C10.6291 2.44714 11.0372 2.76098 11.1894 3.22991L11.5475 4.33422C11.5424 4.31829 11.538 4.30291 11.5336 4.28698L11.5327 4.28314C11.3597 3.66314 11.6997 3.0122 12.3111 2.80108C12.4878 2.73974 12.6698 2.72326 12.8447 2.74505C13.3107 2.80291 13.7289 3.13195 13.8829 3.60565L14.2683 4.79455C14.2592 4.7669 14.2515 4.73889 14.2447 4.71087C14.0931 4.10058 14.4315 3.4685 15.0322 3.26123C15.6802 3.03729 16.3925 3.41394 16.604 4.06634L19.9114 14.2646C20.0823 14.7919 20.1238 15.3526 20.0327 15.8992L19.977 16.2304C19.8094 17.2314 19.8858 18.2585 20.1987 19.2238L20.7526 20.9318C20.8356 21.1869 20.6955 21.4606 20.4406 21.5432Z"
      fill="#CCA180"
    />
    <path
      d="M16.6029 4.06385L19.9107 14.2637C20.0817 14.7909 20.1235 15.3518 20.0317 15.8985L19.9766 16.2296C19.8091 17.2308 19.8851 18.2576 20.1982 19.2233L20.7521 20.9315C20.8348 21.1864 20.6951 21.4601 20.4402 21.5429L19.7584 21.7641L19.0547 19.5941C18.7414 18.6286 18.6656 17.6018 18.8331 16.6003L18.8882 16.2695C18.9798 15.7227 18.9382 15.1619 18.7672 14.6347L15.4512 4.4101C15.3104 3.97541 14.9493 3.67383 14.5312 3.58905C14.6765 3.4303 14.8656 3.3078 15.0877 3.2428C15.7269 3.05512 16.3973 3.43012 16.6029 4.06385Z"
      fill="#947E6F"
    />
    <path
      d="M11.431 13.0643C11.3939 13.0764 11.3563 13.0817 11.3195 13.0817C11.1664 13.0817 11.0245 12.9845 10.9747 12.8316L8.18164 4.25C8.60663 4.2934 8.99005 4.55945 9.17169 4.96466L11.6638 12.608C11.7256 12.7983 11.6213 13.0024 11.431 13.0643Z"
      fill="#947E6F"
    />
    <path
      d="M13.7592 12.3094C13.722 12.3215 13.6843 12.3271 13.6471 12.3271C13.4946 12.3271 13.3527 12.2296 13.3029 12.0765L10.1699 2.39258C10.6295 2.44714 11.0377 2.76099 11.1896 3.22992L13.9919 11.8529C14.0538 12.0432 13.9494 12.2475 13.7592 12.3094Z"
      fill="#947E6F"
    />
    <path
      d="M16.0849 11.5545C16.0477 11.5666 16.01 11.5724 15.9728 11.5724C15.8203 11.5724 15.6784 11.4749 15.6286 11.3218L12.8438 2.74512C13.3098 2.80298 13.728 3.13184 13.882 3.60553L16.3176 11.0982C16.3795 11.2885 16.2751 11.4928 16.0849 11.5545Z"
      fill="#947E6F"
    />
    <path
      d="M9.46069 14.9543C9.42352 14.9664 9.3858 14.9723 9.34863 14.9723C9.19611 14.9723 9.05402 14.8752 9.00439 14.7216L7.37695 9.73145C7.82904 9.85211 8.22015 10.1665 8.42578 10.6113L9.69342 14.4986C9.75531 14.6888 9.65094 14.8932 9.46069 14.9543Z"
      fill="#947E6F"
    />
    <path
      d="M3.953 2.53389C3.86035 2.53389 3.76752 2.49855 3.69684 2.42787L3.10797 1.839C2.96661 1.69765 2.96661 1.46822 3.10797 1.32686C3.24951 1.18532 3.47876 1.18532 3.6203 1.32686L4.20917 1.91554C4.35053 2.05708 4.35053 2.28633 4.20917 2.42787C4.13831 2.49855 4.04565 2.53389 3.953 2.53389Z"
      fill="#65BAFC"
    />
    <path
      d="M5.1049 1.79228C4.93626 1.79228 4.78538 1.67418 4.75041 1.50261L4.5836 0.686876C4.5435 0.490953 4.66984 0.299425 4.86576 0.259325C5.0615 0.219408 5.25303 0.345568 5.29313 0.541674L5.46012 1.35741C5.50004 1.55333 5.3737 1.74486 5.17777 1.78478C5.15342 1.7899 5.12888 1.79228 5.1049 1.79228Z"
      fill="#65BAFC"
    />
    <path
      d="M3.21159 3.6873C3.1876 3.6873 3.16325 3.68474 3.13871 3.6798L2.32298 3.51299C2.12687 3.47289 2.00053 3.28136 2.04063 3.08544C2.08073 2.88951 2.27226 2.76335 2.468 2.80327L3.28391 2.97008C3.47984 3.01018 3.60618 3.20171 3.56608 3.39763C3.53111 3.56902 3.38004 3.6873 3.21159 3.6873Z"
      fill="#65BAFC"
    />
    <path
      d="M22.413 12.423C22.3509 12.423 22.2879 12.4071 22.2304 12.3734L21.5115 11.9533C21.3389 11.8522 21.2806 11.6305 21.3815 11.4578C21.4824 11.2852 21.7044 11.2269 21.877 11.3278L22.5959 11.7481C22.7686 11.8489 22.8268 12.0707 22.7259 12.2434C22.6587 12.3587 22.5375 12.423 22.413 12.423Z"
      fill="#65BAFC"
    />
    <path
      d="M21.1353 13.7592C21.0017 13.7592 20.8733 13.6853 20.8101 13.5573L20.4417 12.8106C20.3533 12.6311 20.4269 12.414 20.6063 12.3255C20.7856 12.2371 21.0029 12.3107 21.0914 12.49L21.4598 13.2368C21.5482 13.4163 21.4746 13.6334 21.2952 13.7219C21.2437 13.7473 21.1892 13.7592 21.1353 13.7592Z"
      fill="#65BAFC"
    />
    <path
      d="M22.1177 10.6995C21.9269 10.6995 21.767 10.5501 21.7564 10.3571C21.7454 10.1574 21.8985 9.98671 22.0983 9.97572L22.9298 9.93013C23.1282 9.92042 23.3002 10.0722 23.3112 10.272C23.3222 10.4718 23.1691 10.6424 22.9693 10.6534L22.1378 10.699C22.131 10.6994 22.1245 10.6995 22.1177 10.6995Z"
      fill="#65BAFC"
    />
  </svg>
);

export const HeartReact = ({ className, ...rest }: any) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={`${className || ""}`}
    {...rest}
  >
    <path
      d="M21.06 5.692C20.3266 4.72837 19.2905 4.03925 18.1183 3.73533C16.946 3.43141 15.7057 3.53034 14.5964 4.01622C13.6036 4.44466 12.7181 5.167 12 6.1256C11.2819 5.16466 10.3964 4.44232 9.40359 4.01622C8.29435 3.53034 7.05397 3.43141 5.88173 3.73533C4.7095 4.03925 3.67344 4.72837 2.94 5.692C2.16656 6.70544 1.75781 7.972 1.75781 9.35435C1.75781 11.3437 2.94422 13.5262 5.28375 15.8437C7.19016 17.7314 9.44297 19.2773 10.6158 20.0306C11.029 20.2951 11.5094 20.4356 12 20.4356C12.4906 20.4356 12.971 20.2951 13.3842 20.0306C14.5561 19.2773 16.8098 17.7314 18.7162 15.8437C21.0558 13.5272 22.2422 11.3437 22.2422 9.35435C22.2422 7.972 21.8334 6.70544 21.06 5.692Z"
      fill="#F9595F"
    />
  </svg>
);

export const UserPlus = ({ className, ...rest }: any) => (
  <svg
    width="25"
    height="25"
    viewBox="0 0 25 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={`${className || ""}`}
    {...rest}
  >
    <path
      d="M16.5 21.5V19.5C16.5 18.4391 16.0786 17.4217 15.3284 16.6716C14.5783 15.9214 13.5609 15.5 12.5 15.5H5.5C4.43913 15.5 3.42172 15.9214 2.67157 16.6716C1.92143 17.4217 1.5 18.4391 1.5 19.5V21.5"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M20.5 8.5V14.5"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M23.5 11.5H17.5"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9 11.5C11.2091 11.5 13 9.70914 13 7.5C13 5.29086 11.2091 3.5 9 3.5C6.79086 3.5 5 5.29086 5 7.5C5 9.70914 6.79086 11.5 9 11.5Z"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const Bell = ({ color, className, ...rest }: any) => (
  <svg
    viewBox="0 0 22 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={`chakra-icon ${className || ""}`}
    {...rest}
  >
    <path
      d="M18.5816 15.178V10.618C18.5816 7.23095 16.4139 4.27743 13.4293 3.17422C13.4642 3 13.4835 2.82197 13.4835 2.64388C13.4835 1.18454 12.299 0 10.8397 0C9.38033 0 8.1958 1.18454 8.1958 2.64388C8.1958 2.81809 8.21512 2.99224 8.24609 3.1587C7.22032 3.52258 6.27192 4.09934 5.4629 4.88127C3.93776 6.35224 3.09777 8.33029 3.09777 10.4516V15.178C3.09777 15.3445 2.96228 15.4839 2.79194 15.4839C1.36357 15.4839 0.144187 16.56 0.0125714 17.9303C-0.0609935 18.6929 0.190666 19.4516 0.705491 20.0168C1.21644 20.5781 1.94808 20.9032 2.71062 20.9032H7.37902C7.57256 22.6413 9.05129 24 10.8397 24C12.628 24 14.1068 22.6413 14.3003 20.9032H18.9687C19.7313 20.9032 20.4629 20.5781 20.9739 20.0168C21.4848 19.4516 21.7365 18.6929 21.6668 17.9303C21.5352 16.56 20.312 15.4839 18.8874 15.4839C18.7171 15.4838 18.5816 15.3483 18.5816 15.178ZM10.8397 1.54835C11.4435 1.54835 11.9351 2.03997 11.9351 2.64381C11.9351 2.6941 11.9274 2.74058 11.9196 2.79088C11.6564 2.75215 11.3893 2.72507 11.1222 2.71731C10.6615 2.7018 10.2086 2.73283 9.7596 2.79476C9.75184 2.74446 9.74408 2.69798 9.74408 2.64769C9.74421 2.03997 10.2358 1.54835 10.8397 1.54835ZM10.8397 22.4515C9.90679 22.4515 9.12486 21.7857 8.94289 20.9032H12.7364C12.5545 21.7857 11.7726 22.4515 10.8397 22.4515ZM20.1261 18.0774C20.1571 18.4103 20.0525 18.7316 19.8319 18.9754C19.6035 19.2193 19.3016 19.3547 18.9687 19.3547H2.71068C2.37777 19.3547 2.07588 19.2192 1.85131 18.9754C1.6268 18.7316 1.52227 18.4102 1.55323 18.0774C1.6074 17.4929 2.15326 17.0322 2.79194 17.0322C3.8139 17.0322 4.64613 16.2 4.64613 15.178V10.4516C4.64613 8.7561 5.31965 7.1729 6.53903 5.99612C7.70418 4.8697 9.22163 4.25804 10.8397 4.25804C10.9171 4.25804 10.9906 4.25804 11.0681 4.26192C14.3545 4.37802 17.0332 7.23095 17.0332 10.618V15.178C17.0332 16.2 17.8654 17.0322 18.8874 17.0322C19.5261 17.0322 20.0681 17.4929 20.1261 18.0774Z"
      fill={color}
    />
  </svg>
);

export const UserOutline = ({ className, ...rest }: any) => (
  <svg
    viewBox="0 0 57 68"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
    className={`chakra-icon ${className || ""}`}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.0483 45.3816C8.17391 42.256 12.4131 40.5 16.8334 40.5H40.1667C44.587 40.5 48.8263 42.256 51.9519 45.3816C55.0775 48.5072 56.8334 52.7464 56.8334 57.1667V63.8333C56.8334 65.6743 55.341 67.1667 53.5001 67.1667C51.6591 67.1667 50.1667 65.6743 50.1667 63.8333V57.1667C50.1667 54.5145 49.1132 51.971 47.2378 50.0956C45.3624 48.2202 42.8189 47.1667 40.1667 47.1667H16.8334C14.1813 47.1667 11.6377 48.2202 9.76235 50.0956C7.88698 51.971 6.83341 54.5145 6.83341 57.1667V63.8333C6.83341 65.6743 5.34103 67.1667 3.50008 67.1667C1.65913 67.1667 0.166748 65.6743 0.166748 63.8333V57.1667C0.166748 52.7464 1.9227 48.5072 5.0483 45.3816Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M28.5002 7.16667C22.9773 7.16667 18.5002 11.6438 18.5002 17.1667C18.5002 22.6895 22.9773 27.1667 28.5002 27.1667C34.023 27.1667 38.5002 22.6895 38.5002 17.1667C38.5002 11.6438 34.023 7.16667 28.5002 7.16667ZM11.8335 17.1667C11.8335 7.96192 19.2954 0.5 28.5002 0.5C37.7049 0.5 45.1668 7.96192 45.1668 17.1667C45.1668 26.3714 37.7049 33.8333 28.5002 33.8333C19.2954 33.8333 11.8335 26.3714 11.8335 17.1667Z"
      fill="currentColor"
    />
  </svg>
);

export const DefaultAvatar = ({ className, ...rest }: any) => (
  <svg
    viewBox="0 0 133 132"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={`chakra-icon ${className || ""}`}
    {...rest}
  >
    <g clipPath="url(#clip0_1108_7935)">
      <path
        d="M66.7083 0.00292969C30.2613 0.00292969 0.708252 29.5502 0.708252 66C0.708252 102.45 30.2584 131.997 66.7083 131.997C103.161 131.997 132.708 102.45 132.708 66C132.708 29.5502 103.161 0.00292969 66.7083 0.00292969ZM66.7083 19.7368C78.7683 19.7368 88.5411 29.5125 88.5411 41.5667C88.5411 53.6239 78.7683 63.3967 66.7083 63.3967C54.654 63.3967 44.8812 53.6239 44.8812 41.5667C44.8812 29.5125 54.654 19.7368 66.7083 19.7368ZM66.6938 114.742C54.6656 114.742 43.6491 110.361 35.152 103.111C33.0821 101.345 31.8876 98.7565 31.8876 96.0401C31.8876 83.8147 41.7821 74.0304 54.0104 74.0304H79.4119C91.6431 74.0304 101.5 83.8147 101.5 96.0401C101.5 98.7594 100.311 101.342 98.2384 103.108C89.7442 110.361 78.7249 114.742 66.6938 114.742Z"
        fill="#CCCCCC"
      />
    </g>
    <defs>
      <clipPath id="clip0_1108_7935">
        <rect
          width="132"
          height="132"
          fill="white"
          transform="translate(0.708252)"
        />
      </clipPath>
    </defs>
  </svg>
);

export const Unavailable = ({ className, ...rest }: any) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className={`chakra-icon ${className || ""}`}
    viewBox="0 0 50 50"
    width="50px"
    height="50px"
    {...rest}
  >
    <path d="M25,2C12.317,2,2,12.318,2,25s10.317,23,23,23s23-10.318,23-23S37.683,2,25,2z M7,25c0-4.062,1.371-7.8,3.65-10.815 L35.815,39.35C32.8,41.629,29.062,43,25,43C15.075,43,7,34.925,7,25z M39.35,35.815L14.185,10.65C17.2,8.371,20.938,7,25,7 c9.925,0,18,8.075,18,18C43,29.062,41.629,32.8,39.35,35.815z" />
  </svg>
);

export const CarretLeft = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    {...props}
  >
    <path
      fill="#000"
      d="M7.5 12c0-.192.073-.384.22-.53l7.5-7.5a.75.75 0 1 1 1.06 1.06L9.31 12l6.97 6.97a.75.75 0 1 1-1.06 1.06l-7.5-7.5A.748.748 0 0 1 7.5 12Z"
    />
  </svg>
);

export const SparksMapIcon = () => (
  <svg
    width="28"
    height="28"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className="sidebar-icon"
  >
    <path
      d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z"
      stroke="currentColor"
      strokeWidth="1.5"
      fill="none"
    />
    <path
      d="M12 9l1 3h3l-2.5 2 1 3-2.5-2-2.5 2 1-3-2.5-2h3z"
      stroke="currentColor"
      strokeWidth="1"
      fill="none"
    />
  </svg>
);

export const ResourcesIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className="sidebar-icon"
  >
    <path
      d="M6 2h12c1.1 0 2 .9 2 2v16c0 1.1-.9 2-2 2H6c-1.1 0-2-.9-2-2V4c0-1.1.9-2 2-2z"
      stroke="currentColor"
      strokeWidth="1.5"
      fill="none"
    />
    <path
      d="M11 2v10l-2.5-1.5L6 12V2"
      stroke="currentColor"
      strokeWidth="1.5"
      fill="none"
    />
    <path
      d="M8 14h8M8 17h8"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
  </svg>
);

